var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.47,324.06a7.25,7.25,0,0,1-3.49-.86,2.72,2.72,0,0,1-1.31-1.72c0-.52-.93-13.59-.93-13.59l4.14-3.41,8.23,3s-1.53,13.49-1.53,14-1,1.53-1.74,1.94A7.69,7.69,0,0,1,111.47,324.06Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-11",
    cx: 250,
    cy: 341.65,
    rx: 235.82,
    ry: 136.15,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadows--inject-11",
    d: "M27.05,353.17l46.48-26.84a5.4,5.4,0,0,1,4.86,0l31.74,18.33,43.78-25.31a4,4,0,0,1,3.65,0l59.18,34.17a1.11,1.11,0,0,1,0,2.1L112,416.09a4,4,0,0,1-3.65,0L49.26,382a1.11,1.11,0,0,1,0-2.11l9.59-5.54L27.05,356C25.71,355.2,25.71,353.94,27.05,353.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows--inject-11",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426,363.29l20.89-12.06c2.81-1.63,2.81-4.26,0-5.89L423.66,332a11.3,11.3,0,0,0-10.21,0l-21,12c-2.82,1.62-2.82,4.24,0,5.87l23.28,13.44A11.25,11.25,0,0,0,426,363.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-11",
    d: "M370,357l53.41-30.84a1.24,1.24,0,0,0,0-2.35l-43.84-25.2a4.51,4.51,0,0,0-4.08,0L322.2,329.37a1.24,1.24,0,0,0,0,2.35L365.94,357A4.51,4.51,0,0,0,370,357Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows--inject-11",
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.09,410.81,366,398.75c2.81-1.63,2.81-4.26,0-5.89l-23.19-13.38a11.28,11.28,0,0,0-10.2,0l-21,12c-2.82,1.62-2.82,4.25,0,5.88l23.28,13.44A11.31,11.31,0,0,0,345.09,410.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M288.72,403.92l53.41-30.84a1.24,1.24,0,0,0,0-2.35l-43.84-25.2a4.51,4.51,0,0,0-4.08,0L240.9,376.31a1.24,1.24,0,0,0,0,2.35l43.74,25.26A4.51,4.51,0,0,0,288.72,403.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows--inject-11",
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.91,461.88l20.88-12.06c2.82-1.63,2.82-4.26,0-5.89l-23.18-13.38a11.31,11.31,0,0,0-10.2,0l-21,12c-2.82,1.61-2.83,4.24,0,5.87l23.28,13.44A11.31,11.31,0,0,0,264.91,461.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M207.42,450.86,260.83,420a1.24,1.24,0,0,0,0-2.35L217,392.46a4.54,4.54,0,0,0-4.08,0L159.6,423.25a1.24,1.24,0,0,0,0,2.35l43.74,25.26A4.51,4.51,0,0,0,207.42,450.86Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-11",
    cx: 279.6,
    cy: 267.41,
    rx: 37.7,
    ry: 21.77,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.92,41.84h0l0,0h0l-4-2.32h0l0,0h0c-2.52-1.27-5.89-.9-9.52,1.44C135,45.61,129.47,56.44,129.89,65.1c.21,4.31,1.87,7.28,4.38,8.58h0l0,0h0l4,2.32h0c2.53,1.29,5.9.91,9.53-1.43,7.29-4.69,12.86-15.52,12.44-24.18C160.09,46.11,158.43,43.14,155.92,41.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,75.92,134.3,73.7h0l0,0c-2.51-1.31-4.17-4.27-4.38-8.58A27.16,27.16,0,0,1,132.52,53l4,2.33a26.82,26.82,0,0,0-2.63,12.13C134.1,71.65,135.7,74.57,138.12,75.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,74.6c7.29-4.69,12.86-15.52,12.44-24.18s-6.67-11.87-14-7.18S133.48,58.76,133.9,67.42,140.57,79.3,147.86,74.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,74c-4.29.21-5-4.62-5.1-6.71-.37-7.64,4.75-17.59,11.18-21.73a9.7,9.7,0,0,1,4.62-1.71c4.29-.21,5,4.62,5.1,6.71.37,7.63-4.75,17.58-11.18,21.73A9.8,9.8,0,0,1,141.75,74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,60.35a.39.39,0,0,1-.15,0,.46.46,0,0,1-.31-.44V48.83a.46.46,0,0,1,.46-.46.47.47,0,0,1,.47.46v9.69l5.16-6.62a.47.47,0,1,1,.73.58l-6,7.69A.46.46,0,0,1,147.94,60.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,68.52h-.06a.19.19,0,0,1-.13-.25l2.59-8.74a.2.2,0,0,1,.38.11l-2.6,8.74A.19.19,0,0,1,145.3,68.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,57.68c.85-.56,1.59-.18,1.64.84A3.55,3.55,0,0,1,148,61.37c-.85.55-1.59.17-1.64-.85A3.52,3.52,0,0,1,147.8,57.68Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "242.35 156.74 79.75 250.62 79.75 249.42 242.35 155.54 242.35 156.74",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.49 153.31 242.35 155.54 79.75 249.42 75.89 247.19 238.49 153.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.89 247.19 79.75 249.42 79.75 250.62 75.89 248.38 75.89 247.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.49 153.31 75.89 247.19 75.89 139.11 238.49 45.23 238.49 153.31",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "238.49 153.31 75.89 247.19 75.89 139.11 238.49 45.23 238.49 153.31"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 240.67 79.3 141.69 235.08 51.75 235.08 150.73 79.3 240.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 238.15 79.3 240.66 235.07 150.73 235.07 51.74 232.88 53.01 232.88 149.47 79.3 238.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 240.67 75.89 247.19 238.49 153.31 235.08 150.73 79.3 240.67"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.08 51.75 238.49 45.23 75.89 139.11 79.3 141.69 235.08 51.75"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "72.91 137.4 75.89 139.11 75.89 247.19 72.91 245.47 72.91 137.4",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.91 137.4 75.89 139.11 75.89 247.19 72.91 245.47 72.91 137.4"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "238.49 45.23 235.51 43.52 72.91 137.4 75.89 139.11 238.49 45.23",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.49 45.23 235.51 43.52 72.91 137.4 75.89 139.11 238.49 45.23"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,157c-.58-.22,6.67-10.55,7.18-11.31,1.62-2.41,6.79-2.83,7.34.08a23.29,23.29,0,0,1-.12,8.41c4.13-8.36,7.46-17,12.9-24.92,1.9-2.77,8-2.58,7.48.95-1.28,8.61-4,17-7.06,25.38,5.8-13.5,9.76-27.54,12.84-40.85.88-3.78,8.09-3.65,7.89.12a138.59,138.59,0,0,1-3.27,23.68c1.38-3,2.72-6.05,4-9.09,1.8-4.14,9-3.35,7.74,1l-1.41,5c1.9-3.88,3.76-7.78,5.53-11.69,1.5-3.3,8.55-4,7.89.12,0,.3-.11.6-.16.9h0l0,.06c-.25,1.48-.55,2.95-.88,4.42q3.25-7,6.12-14.1c2.21-5.43,3.52-11.81,7.23-16.78,1.7-2.27,5.27-2.71,6.94-.67,3.24,3.94,1.3,9,.08,13.77a180.75,180.75,0,0,1-6.76,20.68q-1.8,4.59-3.77,9.13c2.1-3,4.12-6,6-9.12,7.68-12.4,11.16-25.58,18-38.14,1.74-3.18,7.62-2.26,7.49,1-.43,9.8-3.47,19.29-7.84,28.75-1.5,3.24-3.11,6.45-4.75,9.65q7.41-9.6,14.11-19.53c1.64-2.44,6.71-2.8,7.34.08a31.11,31.11,0,0,1-.91,16.87c-1.41,4.26-9.16,3.26-7.75-1,.28-.84.5-1.65.7-2.45q-11.26,15.48-24.27,30.11c-2.16,2.44-7.09,1.1-6.86-1.69a27.2,27.2,0,0,1,1.16-5.64c-5.31,7.14-11,14.13-16.65,21.09-3.09,3.8-9,1.45-6.94-2.7,3.31-6.69,6.59-13.4,9.7-20.14A182.9,182.9,0,0,1,148.18,173c-3.06,3.73-9.17,1.45-6.93-2.7q1.81-3.37,3.6-6.76c-2.11,1-4.58.4-5.42-1.18-1.39,2.12-2.82,4.22-4.38,6.28-1.94,2.55-5.31,2.43-6.8.6a127,127,0,0,1-13.94,21.14c-2.66,3.25-8.31,2.11-7.34-1.86a179.1,179.1,0,0,1,7.21-21.62,66.49,66.49,0,0,1-5.48,7.36c-2.26,2.61-6.81.94-6.85-1.7-.06-3.76,1.07-7.6,2.13-11.42-2.54,2.22-5.57,3.37-9.28,2C90.2,161.44,94.24,155.27,98.75,157Z",
    style: {
      fill: "#fff",
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Skuad--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.58,198.31l30-17.3a.56.56,0,0,0,.24-.46V157.33c0-.25-.2-.29-.36-.07l-30,40.52C163.25,198.06,163.34,198.45,163.58,198.31Zm13.11-12.58,12.5-16.84v9.62Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chalk--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.32,228.79a2.48,2.48,0,0,0-1.12-1.94.77.77,0,0,0-.79-.08h0l-12.69,7.32,1.59,2.75L110,229.52h0A.8.8,0,0,0,110.32,228.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.51,234.17a2.5,2.5,0,0,1,1.13,2c0,.71-.51,1-1.13.65a2.49,2.49,0,0,1-1.12-2C95.39,234.11,95.89,233.82,96.51,234.17Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Abecedary--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 178.68,
    width: 158.14,
    height: 0.25,
    transform: "translate(-68.3 102.42) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 170.48,
    width: 158.14,
    height: 0.25,
    transform: "translate(-64.2 101.32) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 166.17,
    width: 158.14,
    height: 0.25,
    transform: "translate(-62.05 100.75) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 160.94,
    width: 158.14,
    height: 0.25,
    transform: "translate(-59.44 100.05) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 152.74,
    width: 158.14,
    height: 0.25,
    transform: "translate(-55.34 98.95) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 148.43,
    width: 158.14,
    height: 0.25,
    transform: "translate(-53.19 98.38) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 143.2,
    width: 158.14,
    height: 0.25,
    transform: "translate(-50.57 97.68) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 135,
    width: 158.14,
    height: 0.25,
    transform: "translate(-46.48 96.58) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 130.69,
    width: 158.14,
    height: 0.25,
    transform: "translate(-44.33 96) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 125.46,
    width: 158.14,
    height: 0.25,
    transform: "translate(-41.71 95.3) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 117.26,
    width: 158.14,
    height: 0.25,
    transform: "translate(-37.62 94.21) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 112.95,
    width: 158.14,
    height: 0.25,
    transform: "translate(-35.47 93.63) rotate(-29.97)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.15,162.12a22.5,22.5,0,0,0,.54-2.36c0-.12,0-.22,0-.32a1.86,1.86,0,0,1,.31-1.08l1.19-4.53c.19-.7.45-1.74.87-2s1.34,2.09,1.52,2.59a10.23,10.23,0,0,0,.53,1.46c.29.12.39.4.39,1,.17.59.3,1.23.47,1.71.25.71.54.67.54,1.5a1,1,0,0,1-.56.88c-.38.22-.81-1.09-.92-1.65s-.28-1.51-.43-1.54-.21-.05-.41.07c-.72.42-1.44.81-2.35,1.34-.24.14-.3.25-.48,1.16L91,162.14c-.06.35-.11.67-.15.8a.8.8,0,0,1-.42.54c-.27.15-.43.11-.43-.35A3.82,3.82,0,0,1,90.15,162.12Zm3.45-5.21c.15-.09.26-.16.61-.4-.18-.67-.78-2-1.06-2.72-.06-.14-.11-.21-.15-.19s-.91,3.35-1.08,4.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,153.78a7.23,7.23,0,0,1,2.63-4.07c1.29-.75,2.37.34,2.37,1.93a8.82,8.82,0,0,1-.09,1.22,11.53,11.53,0,0,0-.09,1.3c0,.9.19,1.07.47.9a1.38,1.38,0,0,0,.26-.35.73.73,0,0,1,.23-.34c.23-.13.35-.05.35.33a2.15,2.15,0,0,1-.93,1.6c-.55.32-1,0-1.13-.69a5.43,5.43,0,0,1-2.06,2.6c-1.12.65-2.42-.05-2.42-1.88A8.9,8.9,0,0,1,97.9,153.78Zm2.19,3.07a4.7,4.7,0,0,0,1.8-3.61,3.15,3.15,0,0,1,.21-.94,1.91,1.91,0,0,0,0-.53,1.09,1.09,0,0,0-1.45-.87c-1.43.83-2.29,3.27-2.29,4.91A1.08,1.08,0,0,0,100.09,156.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06,149.79a3.21,3.21,0,0,1,0-.46l0-2.39v-1.38c0-.91,0-2.13,0-3.36a1.91,1.91,0,0,1,.44-1.14,10.63,10.63,0,0,1,1.93-1.52c.55-.31,1.38-.26,1.38.69a3.93,3.93,0,0,1-.6,1.82c1.07-.23,1.8.43,1.8,2.25a6.12,6.12,0,0,1-2.66,5.2,9.87,9.87,0,0,1-1,.7,2.4,2.4,0,0,0-.23.11c-.16.09-.14.25-.41.4s-.74.19-.74-.31C112,150.17,112.05,150,112.06,149.79Zm1.35-6.8c.15-.13.49-.39.74-.57.23-.35.82-.93.82-1.47,0-.26-.33-.28-.86,0-.26.15-1.23.85-1.23,1.37l0,1.3C113.05,143.47,113.21,143.19,113.41,143Zm.18,5.7a4.56,4.56,0,0,0,2.6-4c0-1.41-1-1.63-1.82-1.15-.47.27-.75,1.05-1.08,1.24l-.24.1a.55.55,0,0,0-.16.25c0,.22,0,.5,0,.72,0,.88.08,1.73.08,2.64,0,.18,0,.36,0,.54A6.16,6.16,0,0,0,113.59,148.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,139.19l0-1.19c0-.17,0-.67,0-.74a.91.91,0,0,1,.44-.89c.17-.09.44-.07.44.2v.68c0,1,0,1.71,0,2.66a4.32,4.32,0,0,1,1.52-1.72c1.61-.92,2.45-.19,2.45,2.42a6.86,6.86,0,0,1-2.94,5.75,2.13,2.13,0,0,1-1,.3,1,1,0,0,1-.41.53c-.33.19-.46-.22-.47-.67C118.39,145.52,118.43,141.06,118.42,139.19Zm1.86,5.94a4.72,4.72,0,0,0,1.8-2.45,7,7,0,0,0,.25-2.21c0-1.39-1-1.33-1.69-.92a3.55,3.55,0,0,0-1.32,1.71c-.07.1,0,2.78,0,3.3a4.34,4.34,0,0,0,.08.91A1.78,1.78,0,0,0,120.28,145.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,132.14c.3-1.42,1.13-3.43,2.36-4.14,1.07-.62,2.23-.31,2.23,1.5,0,.33-.08,1-.42,1.19s-.38-.52-.38-1.07-.82-.74-1.39-.41c-1.59.91-2,4.93-2,6.24,0,1.72,1,2.13,2.05,1.55a6.94,6.94,0,0,0,1.91-1.58c.2-.27.25-.63.53-.79s.44.06.44.47a1.19,1.19,0,0,1-.15.64,7.79,7.79,0,0,1-2.61,2.4c-1.47.84-3,1-3-2.26A20.3,20.3,0,0,1,132.05,132.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,126.31a1.14,1.14,0,0,1,1.58,1.21c0,.35-.28,1.52-.62.45-.17-.51-.67-.49-1.14-.21-1.14.66-1.84,2.63-1.84,4.16,0,1.88.76,1.86,1.9,1.2a2.71,2.71,0,0,0,1-.68l.19-.25a2.89,2.89,0,0,1,.27-.29c.13-.07.5-.07.5.57a1.64,1.64,0,0,1-.52,1l-.37.22c-.44.25-.84.57-1.29.83-1.35.78-2.51.74-2.51-1.69C138.26,130.18,139.28,127.39,141.15,126.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46,119.65a1.9,1.9,0,0,1,.9-1.82l.93-.54c1.61-.93,4-.43,4,2.92a8.34,8.34,0,0,1-3.9,7,6.1,6.1,0,0,1-1.07.51,1.8,1.8,0,0,1-.34.41c-.49.28-.57-.82-.57-1.55Zm1.42,6.54.76-.44a6.57,6.57,0,0,0,2.82-4.77c0-2.41-1.64-3.37-3-2.56a4.84,4.84,0,0,0-1.05.73,14.81,14.81,0,0,0-.08,2.12c0,1.21,0,3.75.14,5C152.48,126.36,152.68,126.3,152.88,126.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,114.51a1.22,1.22,0,0,1,1.49.28,4.11,4.11,0,0,0,0-.47v-2.7a1.07,1.07,0,0,1,.49-1c.27-.16.35.17.35.54,0,.17,0,.85,0,1.08,0,.42,0,1.14,0,2.22,0,.87,0,1.85,0,2.82s0,2,0,2.93c0,.73-.12,1.14-.49,1.35s-.4-.18-.45-.6a4.55,4.55,0,0,1-1.91,2c-1.61.93-2.4-.16-2.4-2.34S159.6,115.58,161.5,114.51Zm-.41,7.15a3.79,3.79,0,0,0,1.81-2.33,15.47,15.47,0,0,0,.06-2c0-1.3-.72-2-1.47-1.61a4.94,4.94,0,0,0-2.05,4.31C159.44,121.63,160.2,122.17,161.09,121.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.76,111.3a1.16,1.16,0,0,1-.07-.48c0-.17.05-.37.07-.56,0-.8-.06-1.58-.06-2.43,0-.51-.06-1.62.47-1.93.28-.16.51,0,.8-.12s.9-.53,1.45-.88,1.22-.74,1.67-1,.72-.39.72.27a1.21,1.21,0,0,1-.42.86c-3.63,2.07-3.84,2.17-3.84,2.16v2.36c0,.06,0,.08,0,.07l1.63-.91c.23-.14.45-.36.71-.51s.46,0,.46.46a1.18,1.18,0,0,1-.37.8l-2,1.17c-.36.21-.4.26-.4.3s0,.23,0,.43,0,.76,0,1.31v1.16c0,.17.38-.12.68-.24.64-.31,2.33-1.22,2.06-1.06l.78-.44c.34-.19.42.23.42.58a1.2,1.2,0,0,1-.65,1.08.92.92,0,0,1-.49.09,7.41,7.41,0,0,0-1.88.89c-.39.22-.81.54-1.26.8-.3.18-.53-.06-.53-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,103c1-.57,2.17-.3,2.17,1.39a1.08,1.08,0,0,1-.34.87c-.19.18-.43.36-.73.68l-3.14,3.32c.24,1.63,1.5,1,2.18.64a12.3,12.3,0,0,0,1.64-1.56c.34-.2.48-.06.48.44,0,1-2.11,2.26-2.6,2.54-1.31.76-2.61-.08-2.61-2.11C178.45,106.48,179.5,104.12,181.4,103Zm1.31,1.49c-.14-.65-.67-.66-1.45-.21a5.13,5.13,0,0,0-1.93,3.86C180.21,107.24,182,105.4,182.71,104.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,102.55V96.81c0-.45,0-2,.47-2.25s.63-.16,1-.35l2.38-1.38c.13-.07.45-.37.58-.44s.62.11.62.56a1,1,0,0,1-.44.92,6.48,6.48,0,0,1-.83.24l-1.44.88-1.37.83a.29.29,0,0,0-.09.17c0,.6,0,.88,0,2.37,0,.2.17.15.34.06a16.88,16.88,0,0,0,1.81-1.32,5.86,5.86,0,0,1,.64-.54c.38-.22.39.34.39.48,0,.66-.32.94-.91,1.28-.74.43-1.47,1.14-2.23,1.58v.52c0,.86,0,1.7,0,2.75,0,.41,0,1-.4,1.23s-.59-.12-.59-.68C192.14,103.58,192.23,102.87,192.23,102.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,98.42c0-.55,0-2.27,0-3.93l0,0-.88.59c-.25.14-.43-.09-.43-.39a1.16,1.16,0,0,1,.43-1l.91-.5.05,0c0-.51.13-1.23.15-1.38a4.84,4.84,0,0,1,2.05-3.63c.31-.19,1.36-.33,1.36.38,0,.18,0,.64-.25.78-.47.27-.5-.28-1.1.07-1,.61-1.24,1.93-1.3,3.28.5-.27.74-.43,1-.56a4.73,4.73,0,0,0,.56-.35h0a2.25,2.25,0,0,1,.36-.24c.17-.1.38-.1.38.4a1,1,0,0,1-.55,1c-.23.14-.59.24-1.55.79l-.21.1c0,.74,0,1.54,0,2.46,0,.44,0,.85,0,1.25a18,18,0,0,0,.17,1.87c.06.52-.1.8-.33.93-.5.29-.64.19-.64-.45C199.14,99.81,199,99.1,199,98.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,82.47a1.67,1.67,0,0,1,1.56-.17,1,1,0,0,1,.56,1,1.3,1.3,0,0,1-.14.61.9.9,0,0,1-.14.2c-.31.18-.42-.43-.65-.47a1.1,1.1,0,0,0-1.23.1c-1.07.62-2.21,3.59-2.21,5.39,0,2.43,1,2.82,2.29,2.07a2.25,2.25,0,0,0,1.39-2.31c0-.23,0-.86,0-1.18a6.35,6.35,0,0,1-.92.61c-.29.17-.66.12-.66-.36a1.06,1.06,0,0,1,.6-1l.43-.21.24-.11c.27-.16.65-.56.93-.72s.47.12.47.44a1.27,1.27,0,0,1-.24.76c0,.61,0,1.33,0,1.9,0,.73.06.87.06,1,0,.73-.13.92-.33,1s-.42,0-.48-.12a5.68,5.68,0,0,1-1.6,1.56c-2,1.17-3,0-3-3.16C210.41,87.79,211.57,83.59,213.51,82.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,81.05a1.32,1.32,0,0,1,2.18.84,1.49,1.49,0,0,0,.13.41.62.62,0,0,1,.33.58v2.61c0,.56,0,1.33-.11,2.47-.12,1.87-.21,3.85-1.68,4.7-.34.2-1.73.79-1.73-.1a.93.93,0,0,1,.4-.91c.14-.07.26,0,.41,0a2.36,2.36,0,0,0,1-.38c.58-.33.71-1.65.75-2.57,0-.43.08-1.23.1-1.8a4.21,4.21,0,0,1-1.69,2.17c-1.56.9-2.44.19-2.44-2.32C217.15,84.6,217.91,82,219.54,81.05Zm.16,6.79c1-.59,1.53-2.46,1.61-3.61a1.42,1.42,0,0,0-.08-.6,1.65,1.65,0,0,1-.12-.57.93.93,0,0,0-1.39-.86c-1.29.75-1.67,2.49-1.67,4.08C218.05,88.28,218.79,88.37,219.7,87.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,169.42c0-.35,0-.91.4-1.12.19-.11.45.21.45.61l0,3.25c0,.1,0,.13.08.1a29.63,29.63,0,0,0,3.22-1.89c0-1.13-.06-2.21-.06-3.35,0-.51.09-1,.4-1.16s.45.37.45.95,0,1.58.06,3a1.8,1.8,0,0,1,.12.54,2.94,2.94,0,0,1,0,.37l0,.23c.08,2.5.09,3.39.09,3.74a1.18,1.18,0,0,1-.45,1c-.29.17-.43,0-.43-.82l0-3.25c-.12.07-.65.41-3.29,1.93a.49.49,0,0,0-.07.27c0,1.08.07,2.28.07,3.45a1.26,1.26,0,0,1-.48.79c-.17.1-.42,0-.42-.34C95.55,174.91,95.49,173.57,95.49,169.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.31,164.65a1.71,1.71,0,0,1,.51-1.18c.21-.13.38,0,.38.33,0,.74,0,1.8,0,2.73v.55a4.1,4.1,0,0,1,1.54-1.87,2.1,2.1,0,0,1,1.48-.33c1.14.35,1.26,1.29,1.24,2.88v2.7c0,.4,0,1.31-.49,1.6-.3.17-.5-.08-.5-.54,0-1,.13-2.09.13-3.12s-.09-2.92-1.85-1.9a3.82,3.82,0,0,0-1.54,2.55v3c0,.3,0,.69,0,1s0,.84-.38,1.06c-.16.09-.52.26-.52-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26,165l.53-.22v-.63c0-1.61,0-5,.1-6.66l-.37.21c-.28.16-.62.33-.62-.25a1.2,1.2,0,0,1,.74-1.18c.26-.14.69-.42,1-.59l.47-.28c.21-.12.4-.35.59-.46s.47.2.47.4a1.53,1.53,0,0,1-.68,1.24c-.08.05-.25,0-.29,0l-.47.32c0,.65-.07,2.42-.07,4.1,0,1,0,2.21.11,3.21.37-.15.69-.43.74-.41a.52.52,0,0,1,.27.53,1.16,1.16,0,0,1-.5.89l-1.61.93c-.22.13-.81.33-.81-.2A1.23,1.23,0,0,1,116.26,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,153.56a1.34,1.34,0,0,1,.45-1c.24-.14.79.19.79.72a1.17,1.17,0,0,1-.37.78A.56.56,0,0,1,120.28,153.56Zm.15,6.4a30,30,0,0,1,.22-3.4c0-.18.16-.78.42-.93s.34.13.34.51c0,1-.12,2.61-.12,3.6s.21,2.18.21,3.08a1.14,1.14,0,0,1-.39,1c-.37.21-.54.13-.61-.35A33,33,0,0,1,120.43,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.31,156.47c.22-.13.33.19.49.28s.31-.06.41-.11a4,4,0,0,0,1.58-2.94c0-.19,0-1.29,0-3.27,0-.83-.07-1.6-.07-2.45a1.63,1.63,0,0,1,.52-1.4c.3-.17.38.39.38.64,0,.87.05,2.22.05,3.61a27.54,27.54,0,0,1-.21,3.59,6,6,0,0,1-2.45,3.59c-.39.23-1.24.49-1.24-.46A1.43,1.43,0,0,1,130.31,156.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.52,153c0-1,0-1.87,0-2.45,0-.76,0-1.2,0-1.81s.07-1.37.47-1.59.44.12.46.46-.09,3-.07,3.66c0,.93,0,1.86,0,2.76,0,2.73-.36,5-2.68,6.36-.25.15-.84.49-.87-.19a1,1,0,0,1,.69-1,3.54,3.54,0,0,0,1.74-1.86,5.65,5.65,0,0,0,.15-1.22C135.43,155.82,135.52,154.62,135.52,153Zm-.32-7.93a1.3,1.3,0,0,1,.55-1.09c.22-.13.67.43.67.77a.91.91,0,0,1-.46.9C135.7,145.81,135.2,145.29,135.2,145.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,146.87c0-2.13,0-5.24,0-6.63a1.21,1.21,0,0,1,.44-1c.19-.11.4,0,.4.38l0,2.91c0,.18,0,.75,0,1l.77-1.76a1.85,1.85,0,0,1,.53-1c.1-.25.31-.74.49-1.19s.39-.9.46-1.06c.18-.49.23-.72.64-1,.12-.07.34-.06.34.37,0,.84-.44,1.16-.72,1.89-.05.09-.46,1.11-.65,1.62a4.48,4.48,0,0,0,.26.49c.37.75.7,1.55,1.11,2.4a8.52,8.52,0,0,1,.93,2.45,1.2,1.2,0,0,1-.49,1.11c-.34.2-.67-.92-.76-1.24s-1.44-3.84-1.7-3.89a18.09,18.09,0,0,0-1.17,2.73c0,.21,0,.34,0,.54a12.44,12.44,0,0,0,.08,1.37c0,.4,0,.82.05,1.26a1.29,1.29,0,0,1-.45.83c-.26.15-.52.05-.54-.26C145.35,148.59,145.36,147.81,145.36,146.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,143l.08-7.28a1.11,1.11,0,0,1,.46-.92c.17-.1.43,0,.43.44,0,1.45-.11,2.88-.11,4.22,0,.55,0,1.1,0,1.7.83-1.88,1.5-3.22,2.23-4.76.17-.37.37-1,.64-1.12s.49-.09.49.38a1.5,1.5,0,0,1-.35.9c-.14.24-.43.8-.68,1.29l-.48,1,.77,2.15c.26.72.46.95.75,1.8a2.21,2.21,0,0,1,.05.25,1.42,1.42,0,0,1,.06.38,1.93,1.93,0,0,1-.5,1.37c-.37.21-.38-.8-.51-1.16l-1.24-3.51-.31.77a7.39,7.39,0,0,1-.94,2l0,2a1.26,1.26,0,0,1-.48,1c-.35.21-.51-.23-.51-.44C151.62,144.75,151.73,143.64,151.73,143Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.63,137.52c0-1.21,0-1,0-1.7,0-1.7-.16-3.38-.16-5.21,0-1.53,0-2,.39-2.24s.49.1.49.53,0,.8,0,1.17c0,2.07.1,4.06.12,6.32,0,.16,0,.16.12.09.33-.17,1.18-.6,2.32-1.25.24-.14.47-.38.73-.54s.45.12.45.5a1.55,1.55,0,0,1-.52,1.07c-.36.21-.49.06-1,.37s-1.26.89-1.9,1.25c-.21.13-.42.15-.64.28,0,0-.14.11-.22.15s-.22.09-.22-.24A2.13,2.13,0,0,1,164.63,137.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,133.21c0-1.29-.1-2.45-.08-3.78l0-3.8c0-.64.11-1.14.43-1.33s.4.12.4.39V130a24.47,24.47,0,0,0,.14,3.11c0,.33.17.32.29.25a.61.61,0,0,0,.19-.24.79.79,0,0,1,.34-.47c.23-.13.34.12.34.41a2,2,0,0,1-.89,1.51c-.65.4-1,.17-1.18-.63A5.82,5.82,0,0,1,170.21,133.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.46,127.37c0-4.23.06-5.67.06-6.39,0-.87.22-1.77.54-2s.41.2.41.57v0a.87.87,0,0,1,0,.21,20.6,20.6,0,0,0,1.15,3,10.56,10.56,0,0,0,.63,1.47,2.43,2.43,0,0,0,.39-.77c.11-.32.26-.75.63-1.92s1-2.93,1.32-4.09c.05-.21.1-.44.17-.68a1.23,1.23,0,0,1,.41-.85c.32-.19.52,0,.52.49,0,2.91-.09,6-.09,9a.85.85,0,0,1-.35.67s-.65.24-.65-.43c0-.47.18-1.08.2-1.55v-3.65c0-.36,0-.75,0-1.14-.73,1.9-1.33,4.66-2.13,6.14a.91.91,0,0,1-.44.49c-.4.23-1.15-1.46-1.33-1.95l-.62-1.59c0,.5,0,1.12,0,1.91v2.61a5.3,5.3,0,0,1,.09.63c0,.63-.09,1.12-.37,1.28-.57.33-.6-.19-.6-.89C180.41,127.84,180.46,127.58,180.46,127.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.33,120.55c0-1.45,0-2.06.06-2.89a1,1,0,0,1,.34-.73c.16-.1.35-.11.42.23a3.74,3.74,0,0,1,1.28-1.45,1.17,1.17,0,0,1,1.78.76,5,5,0,0,1,1.95-2.63c1.45-.84,2.41,0,2.41,3.41,0,.79-.06,1.5-.11,2.73a1.27,1.27,0,0,1-.4.84c-.36.21-.61-.19-.61-.54,0-.78.24-1.1.24-2.16,0-.46,0-.87,0-1.34,0-1.09-.58-2.26-1.56-1.7a3.61,3.61,0,0,0-1.48,2.38v3.13c0,.1,0,.66,0,.74a1.33,1.33,0,0,1-.42,1.07c-.29.16-.63.23-.63-.38,0-.12.07-.84.07-.9v-2.44c0-1-.48-2.15-1.25-1.7-1,.56-1.22,1.26-1.22,2.59,0,.7,0,1.47.05,2.1l.15,1.74a1.41,1.41,0,0,1-.47,1c-.37.22-.53.09-.58-.58S188.33,122.12,188.33,120.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25,112.43c0-1.24,0-2.78,0-4.17,0-.71-.05-1.37-.05-2.18,0-.27.11-1,.37-1.1.8-.46.73,1.43,1.09,2.18.41.9,1,2.16,1.45,2.89s.91,1.34,1,1.28.14-2.29.16-3c0-2.52,0-3.74,0-4.79s.09-1.53.47-1.75.45-.19.45.63c0,1,0,2-.06,3,0,1.73-.11,3.56-.17,5.36,0,.84,0,2-.75,2.4a.3.3,0,0,1-.4-.09,16.34,16.34,0,0,1-2.8-4.61c0,2.4.06,3.56.08,3.69a9.21,9.21,0,0,1,.09,1.13c0,.54-.11,1.06-.45,1.25-.49.28-.54-.21-.54-.81C205.26,113.35,205.25,112.84,205.25,112.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,109.7c0-1.32-.12-2.86-.12-4.62,0-.68.06-1.83.41-2s.41.58.41,1.33a5.93,5.93,0,0,1,2.1-2.83c1.84-1.07,2.31,1.33,2.31,3.36v1.24c0,1.24-.22,2.56-.59,2.77s-.5.24-.5-.57.24-1.79.24-2.59a5.32,5.32,0,0,0-.35-2.36c-.25-.48-.49-1-1.28-.5a6.07,6.07,0,0,0-1.88,2.88v1.85a11.07,11.07,0,0,0,.11,1.3,8.12,8.12,0,0,1,.14,1c0,.45,0,.84-.42,1.07s-.59.26-.59-.52C212,110.35,212,110.11,212,109.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,181.26c2-1.14,3.17.2,3.17,3.54,0,2.9-1.57,5.8-3.25,6.77s-3.35-.87-3.35-3.19C100.48,184.63,102.2,182.25,103.91,181.26Zm-.14,9.12a6.12,6.12,0,0,0,2.47-5.27c0-2.43-.95-3.41-2.21-2.68a6.09,6.09,0,0,0-2.69,5.23C101.34,189.63,102.51,191.1,103.77,190.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,179.26c1.57-.91,2.52.19,2.52,2.82,0,2.29-1.24,4.59-2.57,5.36s-2.67-.66-2.67-2.5C108.31,181.94,109.68,180,111,179.26Zm-.15,7a4.65,4.65,0,0,0,1.86-3.88c0-1.74-.65-2.57-1.53-2.06a4.83,4.83,0,0,0-2.09,3.92C109.12,185.71,110,186.81,110.88,186.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,177.75v-.6a.94.94,0,0,1-.13-.43.82.82,0,0,1,0-.26l0-.15c0-1.93,0-2.22,0-2.7a5.57,5.57,0,0,1,.38-2.42.66.66,0,0,1,.25-.27.21.21,0,0,1,.2,0,5.82,5.82,0,0,1,1.4-1.38c1.65-1,2.47-.54,2.47,1.15a6,6,0,0,1-.54,2.71,10.52,10.52,0,0,1-2.85,3.17,1.73,1.73,0,0,1-.3.16l-.18.06c.06,1.25.19,1.89.19,3a.75.75,0,0,1-.43.67c-.12.07-.3.14-.4.09A9.49,9.49,0,0,1,122.27,177.75Zm1.56-2.69a7.49,7.49,0,0,0,2-2,4,4,0,0,0,.34-1.5c0-1.13-.44-1.51-1.56-.86-.47.27-1.1.75-1.21,1.29a2,2,0,0,1-.27.83c0,.3,0,1,0,1.34s0,.92,0,1.21A6.36,6.36,0,0,0,123.83,175.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33,170.94a4.68,4.68,0,0,1,2-2.68c2-1.14,3.07-.26,3.07,1.62,0,2.86-1.12,5.15-2.94,6.2a2.69,2.69,0,0,1-1.27.45v.57c0,.91.16,1.81.16,2.65a1.12,1.12,0,0,1-.5.88c-.29.16-.51.08-.51-.6,0-.42,0-1.26,0-1.75v-7.34Zm1.72,4.17a5,5,0,0,0,2.47-4.47c0-1.59-.83-1.93-2.17-1.16a2.77,2.77,0,0,0-1.2,1.66v2.05c0,.2,0,.72,0,1.19l0,.9C129.17,175.6,129.85,175.22,130.05,175.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,157.54c1.78-1,3.34.85,3.34,3.18a9.94,9.94,0,0,1-.69,3.79,2.49,2.49,0,0,1,.78,1.27.87.87,0,0,1-.39.75c-.16.09-.52.24-.6,0,0-.05-.21-.34-.48-.71a6.07,6.07,0,0,1-2,2c-2,1.15-3.17-.2-3.17-3.55C141.74,161.42,143.31,158.51,145,157.54Zm-.19,9.14a5.09,5.09,0,0,0,1.59-1.53,4.43,4.43,0,0,0-1.06-1V164c0-.42.08-.73.3-.86s.83.22,1,.4a3.65,3.65,0,0,0,.39.37,6.7,6.7,0,0,0,.45-2.43c0-2-1.17-3.5-2.42-2.77s-2.47,2.81-2.47,5.31S143.54,167.41,144.8,166.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.22,155.55c1-.56,2.46-.41,2.48,1.62a.52.52,0,0,1,.06.28v2c0,.45,0,.85,0,1.27s0,.71,0,1.17c0,1,0,2.15,0,3.2a1,1,0,0,1-.47.84c-.32.19-.5.16-.5-.36l.07-2.76c0-.31,0-.82,0-1.62a4.58,4.58,0,0,1-1.68,2.29c-1.57.91-2.49-.56-2.49-2.36C149.7,158.72,150.77,156.39,152.22,155.55Zm.05,6.62a4.09,4.09,0,0,0,1.5-3.21,7.41,7.41,0,0,1,.2-1.33c-.19-1.13-1-1.3-1.55-1a4.43,4.43,0,0,0-1.85,3.8C150.57,161.69,151.08,162.85,152.27,162.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,154.93c0-.64-.27-2.79-.27-4.09a7,7,0,0,1,.33-2.67,6.66,6.66,0,0,1,2.3-2.77c.86-.5,1.8-.37,1.8,1.23a4.4,4.4,0,0,1-1.28,2.78c.54-.29,1.36-.27,1.59.15a9.92,9.92,0,0,1,.5,4.14,1.44,1.44,0,0,1-.49,1c-.38.21-.42-.24-.42-.82,0-.3.05-.61.05-1a6.94,6.94,0,0,0-.18-1.74c-.32-1-1.29-.64-2.05-.2a4.48,4.48,0,0,0-1.17,1.18,21.22,21.22,0,0,0,.28,3.07c0,.05,0,.07,0,.13a1.24,1.24,0,0,1-.58,1c-.25.14-.47-.15-.47-.52S163.76,155.23,163.76,154.93Zm3.3-7.65c0-1-.51-.95-1-.68a3.82,3.82,0,0,0-1.75,2.53c0,.58,0,1.07,0,1.57C164.89,150.37,167.06,148.21,167.06,147.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.17,151.36c0-.3,0-.6,0-.91,0-.49,0-1.09,0-1.53l.16-3a1.12,1.12,0,0,1,.46-1c.28-.16.41.09.45.33a5.3,5.3,0,0,1,1.87-1.92c.53-.31,1.47-.71,1.47.4a1,1,0,0,1-.44.92c-.2.12-.29,0-.38-.11s-.18-.23-.63,0c-1.42.82-2.06,2.07-2.06,4.19,0,.79,0,1.36.07,2.15,0,.3.05.62.05.93a1.29,1.29,0,0,1-.46.95c-.43.25-.55,0-.55-.65C170.14,151.9,170.17,151.61,170.17,151.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,143.17c.41.93.64.86,1.28.49a4.33,4.33,0,0,0,1.73-2.55c0-.46-.57-.64-1.26-.49-1.19.43-2.65.91-2.65-1a6.45,6.45,0,0,1,2.72-5.17c.91-.52,1.49,0,1.49.9,0,.48,0,1.34-.4,1.58-.25.14-.25-.2-.25-.44,0-1-.36-1.06-1-.7a5,5,0,0,0-1.73,3.24c0,.91.89.65,1.75.38,1.06-.32,2.17-.48,2.17,1.21,0,2-2,3.94-2.72,4.38-.58.33-1.7.79-1.7-.73C182.73,143.94,183,142.83,183.28,143.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.46,140.19c.41.48.62.38,1.25,0a4.69,4.69,0,0,0,1.67-1.81c0-.31-.55-.34-1.21-.13-1.16.43-2.59.92-2.59-.9a5.92,5.92,0,0,1,2.66-4.66c.89-.51,1.46-.11,1.46.66,0,.48,0,1.33-.39,1.56-.25.15-.25-.21-.25-.45,0-.74-.35-.7-.95-.35a4.23,4.23,0,0,0-1.68,2.67c0,.75.85.45,1.69.16,1-.35,2.12-.55,2.12.93s-1.92,3.23-2.65,3.65c-.57.33-1.66.8-1.66-.43C188.93,140.86,189.23,139.93,189.46,140.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.77,131.82c0-.61-.1-1.15-.1-1.81,0-1-.13-2-.14-3.09v-1.53c-.4.26-1,.78-1.43,1s-.57.19-.59-.12a1.49,1.49,0,0,1,.74-1.44c.93-.54,1.87-1.16,2.87-1.74.29-.17.57-.49.88-.67s.5.18.5.62a1.73,1.73,0,0,1-.5,1.07c-.28.16-.48-.08-.63,0a11,11,0,0,0-1,.65V126c0,1,.05,1.91.13,2.86s0,1.86.13,2.8c0,.14.14.69.14.87a.82.82,0,0,1-.45.88c-.55.35-.58-.22-.58-.88C203.75,132.31,203.77,132.08,203.77,131.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.64,125c-.17.1-.3.17-.43.26s-.23.16-.49.31-.57.1-.57-.31a1.21,1.21,0,0,1,.53-1l1-.54c0-.25,0-.51.05-.75,0-.58,0-1,.1-1.49a1.54,1.54,0,0,1,.48-1c.14-.08.35.05.35.42a10.36,10.36,0,0,1-.05,1.28c0,.23,0,.48-.07,1,.72-.44,1.25-.79,2-1.22.25-.14.39.24.39.47a1.09,1.09,0,0,1-.42.87l-1.92,1.06a.25.25,0,0,0,0,.07c0,1.54-.19,4.77.78,4.21a3.31,3.31,0,0,0,.76-.89,1.16,1.16,0,0,1,.28-.35c.24-.14.27,0,.27.34a1.41,1.41,0,0,1-.08.43,4.49,4.49,0,0,1-1.19,1.75C208.52,131,208.67,127.21,208.64,125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28,205.47a36.78,36.78,0,0,1,.25-4,1.21,1.21,0,0,1,.47-.81c.3-.17.38.08.38.42,0,.11,0,.24,0,.36-.1.93-.2,2.3-.2,3.17,0,1.88.14,4.51,1.35,3.82a3.66,3.66,0,0,0,1.65-3.11l.11-4.07c.06-2.07.31-2.91.71-3.14.21-.12.35.19.35.69,0,.22-.28,2.22-.28,4.3,0,1.07,0,2.33,0,3.46a1.43,1.43,0,0,1-.57,1.19c-.14.08-.23-.24-.28-.36a5,5,0,0,1-1.88,2.33C101.66,210.67,101.28,207.76,101.28,205.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,199.27a1.09,1.09,0,0,1,.46-.72c.23-.13.38.08.38.43a19.08,19.08,0,0,0-.29,3.08c0,.95.13,3.36,1.28,2.7,1-.57,1.49-2.4,1.73-3.07.11-1.75.07-2.09.07-3.56v-.86a.93.93,0,0,1,.45-.79c.15-.09.37-.08.37.28v6.88c0,.5-.12.7-.38.85-.46.27-.47.09-.47-.7v-.49a4.34,4.34,0,0,1-1.7,2.67c-2,1.13-2.19-1.72-2.19-3.23A23.08,23.08,0,0,1,108.05,199.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,190.9c0-.24,0-.78.36-1a.3.3,0,0,1,.46.25,42.54,42.54,0,0,0,1.23,5.44c0,.11.07.62.14.58a7.17,7.17,0,0,0,.35-1.26c.85-2.58,1.6-5.29,2.48-7.87a1.36,1.36,0,0,1,.55-.83c.09-.05.3,0,.3.5a3.09,3.09,0,0,1-.12.67c-.42,1.16-2.63,8.2-3,9.46-.24.84-.06,1-.85,1.43A36.53,36.53,0,0,1,120.88,190.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,191.05c-.09-.38-.18-.79-.29-1.16a4.16,4.16,0,0,1-.38-1.42.92.92,0,0,1,.36-.83c.39-.23.46-.07.6.45a31.12,31.12,0,0,0,1.26,4.29c0,.12.13.56.2.52s1-3.65,1.27-4.57c.2-.75.82-3,1-3.39a1,1,0,0,1,.27-.32c.23-.13.38.11.38.54a6.88,6.88,0,0,1-.45,1.71c-.17.5-.37,1.1-.49,1.6a56.61,56.61,0,0,1-1.67,5.54,1.21,1.21,0,0,1-.48.54c-.15.08-.32.07-.35,0A12.64,12.64,0,0,1,128,191.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,179.84a9.24,9.24,0,0,1-.2-1.34,1.55,1.55,0,0,1,.43-1c.42-.24.45.52.54,1.14.2,1.46.4,1.91.89,4.92a4,4,0,0,0,.13.8l.13-.7c.19-1,.62-3.45,1-5,.28-1.06.42-1.57.66-1.7s.44.3.54,1.34a30.79,30.79,0,0,0,.66,4.29c.29-1.25.43-3,.86-5.25.21-1.11.47-2.22.59-2.6s.24-1.59.71-1.86c.27-.16.47.18.47.52a4.56,4.56,0,0,1-.36,1.15c-.37,1-.59,1.95-1.35,7.37-.11.88-.38,3-1,3.32-.18.11-.42.08-.48-.27-.21-1.51-.62-3.19-.82-5-.26,1.31-.84,4.28-1,5.19h0a6.7,6.7,0,0,1-.7,2c-.37.22-.54.06-.59-.38C141.55,184.26,141.19,182.21,140.71,179.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,177.6c0-1.89.34-2.34.56-2.47s.37,0,.37.47-.07.78-.07,1.14c0,.83.09,4.75,1,4.42s1.47-2.56,1.47-4.28c0-.51-.09-1.62-.09-2.17a1.56,1.56,0,0,1,.54-1.14c.22-.13.43.19.44.43s0,.74,0,1.17c0,1.73,0,4.21.76,3.78.92-.53,2-2.5,2-4.87a11,11,0,0,0-.17-2,3.82,3.82,0,0,1-.23-.87,1.19,1.19,0,0,1,.48-1.06c.18-.1.43-.09.48.48a17,17,0,0,1,.26,2.68c0,2.95-1.4,6.22-2.88,7.07-.7.41-1-.35-1.3-1.35-.31,1.37-1,3.06-1.8,3.51C149.29,183.56,149.17,178.47,149.17,177.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.06,169.45c.06-.21.22-1,.28-1.25a11.57,11.57,0,0,0-1.05-2.68,2,2,0,0,1-.15-.71,1.31,1.31,0,0,1,.35-.89c.55-.32.9,1.55,1.41,2.45.37-1.26.7-2.31,1.14-3.91a4.35,4.35,0,0,1,.81-1.85c.21-.12.36.15.36.43s-.66,2.46-.73,2.65c-.17.45-1.13,3.6-1.13,3.78a11.92,11.92,0,0,0,1.19,2.77c.27.44.62.21.62,1.11a.71.71,0,0,1-.32.67c-.7.4-1-.16-1.39-1.12-.32-.72-.49-1.2-.59-1.43-.18.66-.52,1.89-.58,2.4s.07,1.1-.44,1.39-.59-.13-.59-.67C165.25,172.39,165.87,170.07,166.06,169.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,168.38c.15-.43.74-1.85.82-2.09,0,0-.54-1.15-.86-1.89a2.19,2.19,0,0,1-.41-1.12.93.93,0,0,1,.4-.79c.4-.24,1.13,1.91,1.41,2.32.41-1.07,1.32-3.94,2-4.32.26-.16.41,0,.41.29a1.06,1.06,0,0,1-.1.43s-.81,1.67-1,2.21c-.29.7-.51,1.31-.81,2.14a5.44,5.44,0,0,0,.54,1c.4.57.71,1.1,1.1.87.13-.08.17-.18.28-.06a.78.78,0,0,1,.11.47,1.28,1.28,0,0,1-.46,1.16c-.42.24-1-.21-1.3-.57a5.1,5.1,0,0,1-.49-.72c-.11-.16-.21-.34-.32-.53-.28.69-.84,2.08-.87,2.24s-.11,1.06-.48,1.28-.58.2-.58-.34A5.72,5.72,0,0,1,170.89,168.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.24,160a4.15,4.15,0,0,0,.2-.77,1.09,1.09,0,0,0-.12-.45c-.28-.56-2-2.79-2-3.78a1,1,0,0,1,.36-.75c.17-.1.25-.08.36.12a35,35,0,0,0,1.9,3.18c.07-.18.2-.56.23-.67.47-1.5,1.12-3.8,1.56-4.88.21-.53.34-.87.59-1s.32.05.32.32a11.31,11.31,0,0,1-.46,1.61c-.87,2.76-2.17,7.06-2.81,10,0,.17-.18.71-.36.81a.43.43,0,0,1-.57-.36A18.77,18.77,0,0,1,184.24,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.81,158.68c-.49-1.07-1.43-3.54-1.7-4.29a1.83,1.83,0,0,1-.15-.62,1.36,1.36,0,0,1,.52-1.1c.26-.14.28.13.38.42.44,1.32,1.17,3.26,1.46,3.94l1.87-6.09a2.38,2.38,0,0,1,.84-1.28c.17-.09.28.13.28.34,0,.47-.21.47-1.55,4.73l-1.18,4a22.29,22.29,0,0,0-.9,3.91,1.47,1.47,0,0,1-.42,1.08.47.47,0,0,1-.64-.4,12.74,12.74,0,0,1,.63-2.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.67,149.94c.79-2.33,1.73-4.52,2.48-7.14l-.75.37c-.77.38-1.76,1.12-2,1.28s-.59,0-.59-.51a1.07,1.07,0,0,1,.5-.9c.38-.21.7-.3,1.08-.52l1.37-.81a14.64,14.64,0,0,1,1.37-.71c.18-.07.23.21.23.48a65.87,65.87,0,0,1-2.34,7.07,24.86,24.86,0,0,0-.74,2.41l2.86-1.57a1.47,1.47,0,0,0,.49-.42,1.56,1.56,0,0,1,.4-.46c.36-.21.47.06.47.43a1.6,1.6,0,0,1-.46,1.19c-.29.17-.54.13-.8.28-.44.26-1.67,1.17-2.63,1.72a9.55,9.55,0,0,1-1.06.53c-.28.12-.34-.09-.34-.39A7.3,7.3,0,0,1,201.67,149.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.87,144.58c.06-.23.6-1.51.94-2.87a.2.2,0,0,0,0-.07c0-.1-.08-.16-.25-.06-.69.4-1.38,1-2.11,1.41-.24.15-.51.23-.51-.3,0-.25.09-.85.32-1l2-1.14c.38-.22.74-.57,1.15-.81s.42.39.42.73a15.31,15.31,0,0,1-1.14,4.13l-.87,2.52a.3.3,0,0,0,0,.1c0,.24.38,0,.74-.22a4.54,4.54,0,0,0,1.52-1.38.53.53,0,0,1,.13-.13c.27-.15.42.48.42.81a1.38,1.38,0,0,1-.56,1.1c-.25.15-.4.12-.61.24-.65.38-1.09.68-1.74,1.06-.48.27-1.07.62-1.07-.17C207.61,148.25,208.38,146.33,208.87,144.58Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.15,376.51a1,1,0,0,1-1-1v-62a1,1,0,1,1,1.93,0v62A1,1,0,0,1,69.15,376.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,353.94a1,1,0,0,1-.89-.61l-19-48.12a1,1,0,1,1,1.8-.7l19,48.11a1,1,0,0,1-.54,1.25A.92.92,0,0,1,107.51,353.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,348.16a1,1,0,0,1-.7-.3L69.15,310.43,33.84,347.7a1,1,0,1,1-1.4-1.32l36-38a1,1,0,0,1,.7-.3h0a1,1,0,0,1,.69.3l36.08,38.18a1,1,0,0,1,0,1.36A1,1,0,0,1,105.23,348.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,353.94a.92.92,0,0,1-.36-.07,1,1,0,0,1-.54-1.25l19-48.11a1,1,0,1,1,1.79.7l-19,48.12A1,1,0,0,1,30.8,353.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,346.68l2.52,6.63a.88.88,0,0,1,0,.17v.12a.82.82,0,0,1-.38.42,1.72,1.72,0,0,1-1.53,0,.65.65,0,0,1-.3-.32h0l0-.09-2.33-6.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.11,346.68l-2.52,6.63a.88.88,0,0,0,0,.17v.12A.82.82,0,0,0,30,354a1.72,1.72,0,0,0,1.53,0,.7.7,0,0,0,.3-.32h0l0-.09,2.33-6.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,370.74v5.49a.55.55,0,0,1-.33.45,1.74,1.74,0,0,1-1.57,0,.55.55,0,0,1-.33-.45v-5.49A2.38,2.38,0,0,1,70.27,370.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,307.47c0-1.45-1.27-3-4-4.75-5-3.23-16.09-9.71-23-13.57a.07.07,0,0,0-.06,0C73,285.85,68,270.36,64.31,258.6c-1.27-4-2.81-6.28-4.65-7.35l-2.4-1.35c-3.64-2.18-8.41.44-14.36,3.69-5.48,3-9.76,6.84-10.62,17-.53,6.2,0,18.05,1.23,27h0c1.82,15,4.06,15,7.31,17.54,5.6,4.32,18.2,10.4,23.5,12.49,9.64,3.79,17.51-2.06,23.37-4.95a137.23,137.23,0,0,0,15.55-9.21c1.46-1.07,2.22-2.15,2.21-3.28C105.44,309.79,105.45,307.94,105.45,307.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.45,307.47c0-1.45-1.27-3-4-4.75-5-3.23-16.09-9.71-23-13.57a.07.07,0,0,0-.06,0C73,285.85,68,270.36,64.31,258.6c-1.27-4-2.81-6.28-4.65-7.35l-2.4-1.35c-3.64-2.18-8.41.44-14.36,3.69-5.48,3-9.76,6.84-10.62,17-.53,6.2,0,18.05,1.23,27h0c1.82,15,4.06,15,7.31,17.54,5.6,4.32,18.2,10.4,23.5,12.49,9.64,3.79,17.51-2.06,23.37-4.95a137.23,137.23,0,0,0,15.55-9.21c1.46-1.07,2.22-2.15,2.21-3.28C105.44,309.79,105.45,307.94,105.45,307.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,307.47c0-1.45-1.27-3-4-4.75-5-3.23-16.09-9.71-23-13.57a.07.07,0,0,0-.06,0C73,285.85,68,270.36,64.31,258.6c-1.27-4-2.81-6.28-4.65-7.35l-2.4-1.35c-3.64-2.18-8.41.44-14.36,3.69-5.48,3-9.76,6.84-10.62,17-.53,6.2,0,18.05,1.23,27h0c1.82,15,4.06,15,7.31,17.54,5.6,4.32,18.2,10.4,23.5,12.49,9.64,3.79,17.51-2.06,23.37-4.95a137.23,137.23,0,0,0,15.55-9.21c1.46-1.07,2.22-2.15,2.21-3.28C105.44,309.79,105.45,307.94,105.45,307.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.45,251.13c-3.61-1.89-8.29.68-14.09,3.85-3.71,2-6.87,4.45-8.79,9l-2.45-1.41c1.92-4.5,5.08-6.91,8.78-8.94,6-3.26,10.72-5.87,14.36-3.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.45,251.13c-3.61-1.89-8.29.68-14.09,3.85-3.71,2-6.87,4.45-8.79,9l-2.45-1.41c1.92-4.5,5.08-6.91,8.78-8.94,6-3.26,10.72-5.87,14.36-3.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,302.72c-3.22-2.09-3.3-2.63-23.21-13.67l.09,0C73,285.83,68,270.36,64.31,258.6c-3.77-12-10.05-8.49-19-3.61-5.48,3-9.76,6.83-10.62,17s1,35.44,4.5,38.5c3.79,4.19,19,12,25.08,14.37,9.64,3.79,17.51-2.05,23.37-4.94a137.23,137.23,0,0,0,15.55-9.21C106.57,308.3,106.27,305.82,101.48,302.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.48,302.72c-3.22-2.09-3.3-2.63-23.21-13.67l.09,0C73,285.83,68,270.36,64.31,258.6c-3.77-12-10.05-8.49-19-3.61-5.48,3-9.76,6.83-10.62,17s1,35.44,4.5,38.5c3.79,4.19,19,12,25.08,14.37,9.64,3.79,17.51-2.05,23.37-4.94a137.23,137.23,0,0,0,15.55-9.21C106.57,308.3,106.27,305.82,101.48,302.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.36,289.09h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.36,255c8.9-4.88,15.18-8.34,19,3.61C68,270.36,73,285.85,78.37,289.1c0,0-9.19,0-22.5,7.18-13.85,7.48-16,14.79-16.59,14.26-3.51-2.9-5.4-28.34-4.54-38.53S39.88,258,45.36,255Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "207.16 319.2 155.82 289.56 155.82 292 207.16 321.64 207.16 319.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.16 316.76 155.82 287.12 155.82 289.56 207.16 319.2 207.16 316.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 390.8 138.7 374.33 138.7 328.23 110.18 344.69 110.18 390.8",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 390.8 138.7 374.33 138.7 328.23 110.18 344.69 110.18 390.8",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 347.99 110.18 410.56 108.33 409.49 108.33 346.92 110.18 347.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 347.99 110.18 410.56 112.03 409.49 112.03 346.92 110.18 347.99",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.7 319.41 60.69 381.99 58.84 380.92 58.84 318.35 60.7 319.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.69 319.41 60.69 381.99 62.54 380.92 62.54 318.35 60.69 319.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.31 293.06 205.31 355.64 203.46 354.57 203.46 292 205.31 293.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.31 293.06 205.31 355.64 207.16 354.57 207.16 292 205.31 293.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 338.1 110.18 351.28 58.85 321.64 58.84 308.46 110.18 338.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 351.28 207.16 295.29 207.16 288.7 110.18 344.69 110.18 351.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 344.69 53.14 311.76 155.82 252.48 212.86 285.41 110.18 344.69",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 344.69 53.14 311.76 155.82 252.48 212.86 285.41 110.18 344.69",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.14 311.76 53.14 315.05 110.18 347.99 110.18 344.69 53.14 311.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.14 311.76 53.14 315.05 110.18 347.99 110.18 344.69 53.14 311.76",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 347.99 212.86 288.7 212.86 285.41 110.18 344.69 110.18 347.99",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.18 347.99 212.86 288.7 212.86 285.41 110.18 344.69 110.18 347.99",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "108.33 389.73 60.7 362.23 60.69 322.7 108.33 350.21 108.33 389.73",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.33 389.73 60.7 362.23 60.69 322.7 108.33 350.21 108.33 389.73",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.17,274.78l23.12,13.34a1.42,1.42,0,0,0,1.3,0l17-9.82a.4.4,0,0,0,0-.75L147.48,264.2a1.42,1.42,0,0,0-1.3,0l-17,9.82A.4.4,0,0,0,129.17,274.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.17,277.16l23.12,13.35a1.42,1.42,0,0,0,1.3,0l17-9.82a.4.4,0,0,0,0-.76l-23.12-13.34a1.42,1.42,0,0,0-1.3,0l-17,9.82A.4.4,0,0,0,129.17,277.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,276l23.12,13.35a1.48,1.48,0,0,0,1.3,0l17-9.83c.36-.2.36-.54,0-.75l-23.12-13.35a1.48,1.48,0,0,0-1.3,0l-17,9.83C128.81,275.42,128.81,275.76,129.17,276Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,265.39,130,274.72l22.27,12.85a1.42,1.42,0,0,0,1.3,0l16.15-9.32-22.26-12.86A1.48,1.48,0,0,0,146.18,265.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,273.62,152.29,287a1.48,1.48,0,0,0,1.3,0l17-9.83c.36-.2.36-.54,0-.75L147.48,263a1.48,1.48,0,0,0-1.3,0l-17,9.83C128.81,273.07,128.81,273.41,129.17,273.62Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M141.5,293.41c.74.38-1.12,1.69-2,1.18l-16.14-9.45-1.94-2a.13.13,0,0,1,.13-.21l3.74,1.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,282.59l-3.44-.67a.11.11,0,0,0-.1.17l2.34,2.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,282.09a.11.11,0,0,1,.1-.17l.67.13h0a.59.59,0,0,0-.27.55v.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,292.08l-.29-.16-.34-.19-12.19-7a1.56,1.56,0,0,1,.09-1.14,1.64,1.64,0,0,1,1.11-1l12.19,7,.65.38C137.51,289.74,136.28,291.86,136.72,292.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64,291.47l-.63-.36c-.18-.1-.07-.55.14-1,.29-.63.85-1.23,1.1-1.1l.46.26.17.1c-.25-.13-.81.47-1.1,1.1-.21.45-.31.89-.16,1h0A0,0,0,0,0,135.64,291.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.49,291.38c-.43-.23.8-2.35,1.23-2.12l.63.36c-.43-.23-1.67,1.89-1.23,2.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,292.08l-.63-.35c-.42-.22.75-2.28,1.2-2.15h0l.62.37C137.51,289.74,136.28,291.86,136.72,292.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,282l.11-.06,2.5,1.36,12.9,7.4s0,0,.06,0c-.37.57-.65,1.29-.4,1.41l-.29-.16-.34-.19-12.19-7h0l-2.34-2.64A.09.09,0,0,1,121.55,282Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,293.59l-2.63-1.51c-.19-.09-.09-.54.13-1,.28-.63.84-1.24,1.09-1.11h0l2.65,1.51c.52.3,0,1.44-.55,1.95A.61.61,0,0,1,139.35,293.59Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,292.77a1.93,1.93,0,0,1,1.08-1.3.43.43,0,0,1,.39.06c.4.37-.06,1.41-.62,1.89a.63.63,0,0,1-.68.18C139.17,293.48,139.09,293.18,139.19,292.77Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Squads--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--squads--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.47,323.06l15.77-9.1-.62-.36-14.53-8.39Zm3.29-12.19,5.35,3.09-5.35,3.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.63 312.56 149.63 313.59 134.47 322.34 134.47 321.31 149.63 312.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "149.63 312.56 149.63 313.59 134.47 322.34 134.47 321.31 149.63 312.56",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "149.63 312.56 149.63 313.59 134.47 322.34 134.47 321.31 149.63 312.56",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,321.31l15.16-8.75-15.16-8.75Zm3.57-5.15V309l6.24,3.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.47,321.31l15.16-8.75-15.16-8.75Zm3.57-5.15V309l6.24,3.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.47 321.31 148.12 312.74 134.47 303.81 149.63 312.56 134.47 321.31",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 309.99 138.04 308.96 144.28 312.56 143.39 313.07 138.04 309.99",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 309.99 138.04 308.96 144.28 312.56 143.39 313.07 138.04 309.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 309.99 138.04 308.96 144.28 312.56 143.39 313.07 138.04 309.99",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--squads--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,301.87l16.65,9.62,21.09-12.16-.61-.37-36.55,2.57Zm9.22,1.58,16-1-8.91,5.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.62 310.8 137.57 301.53 137.57 300.5 153.62 309.77 153.62 310.8",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "153.62 310.8 137.57 301.53 137.57 300.5 153.62 309.77 153.62 310.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "153.62 310.8 137.57 301.53 137.57 300.5 153.62 309.77 153.62 310.8",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.12 298.96 174.12 297.93 153.62 309.77 153.62 310.8 174.12 298.96",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "174.12 298.96 174.12 297.93 153.62 309.77 153.62 310.8 174.12 298.96",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "174.12 298.96 174.12 297.93 153.62 309.77 153.62 310.8 174.12 298.96",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.57,300.5l16.05,9.27,20.5-11.84Zm8,1.55,17.83-1-9.8,5.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.57,300.5l16.05,9.27,20.5-11.84Zm8,1.55,17.83-1-9.8,5.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "153.62 309.77 171.51 298.65 137.57 300.5 174.12 297.93 153.62 309.77",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 302.05 163.42 301.02 162.07 301.8 146.84 302.77 145.59 302.05",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 302.05 163.42 301.02 162.07 301.8 146.84 302.77 145.59 302.05",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 302.05 163.42 301.02 162.07 301.8 146.84 302.77 145.59 302.05",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.59,302.57l-22.59-13L64.71,310.51a.58.58,0,0,0,0,1.1L86.3,324a2.16,2.16,0,0,0,1.92,0l35.37-20.36A.59.59,0,0,0,123.59,302.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.89,308.32V309a2,2,0,0,0,1,1.7l18.61,10.71a2,2,0,0,0,2,0l34.15-19.72a2,2,0,0,0,1-1.69v-.47l-36.1,20.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,299.54l-20.25-11.69a1.15,1.15,0,0,0-1.16,0L65,308.13a.26.26,0,0,0,0,.45l20.44,11.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.27 318.66 74.35 312.36 106.28 293.93 117.26 300.19 85.27 318.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 301.14 80.11 301.26 85.46 304.35 94.98 298.85 95.17 298.74 89.62 295.53 79.9 301.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.11 301.26 85.46 304.35 94.98 298.85 89.62 295.76 80.11 301.26",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,320.38v1.3a2,2,0,0,0,1-.26l34.15-19.72a2,2,0,0,0,1-1.69v-.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.46,320.38v1.3a2,2,0,0,0,1-.26l34.15-19.72a2,2,0,0,0,1-1.69v-.47Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86,320.67a2.29,2.29,0,0,0,2-.16l34-19.62a2.36,2.36,0,0,0,1.12-1.62l3.72-22.2a2.34,2.34,0,0,0,0-.38,2.3,2.3,0,0,0-.68-1.64l-35.33,20.4a1.75,1.75,0,0,0-.83,1.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,320.67a2.29,2.29,0,0,0,2-.16l34-19.62a2.36,2.36,0,0,0,1.12-1.62l3.72-22.2a2.34,2.34,0,0,0,0-.38,2.3,2.3,0,0,0-.68-1.64l-35.33,20.4a1.75,1.75,0,0,0-.83,1.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,320.38l.23.13.32.16,4-24a1.75,1.75,0,0,1,.83-1.2l35.33-20.4a2.35,2.35,0,0,0-.47-.36l-35.4,20.44a1.7,1.7,0,0,0-.83,1.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,300.18a7.53,7.53,0,0,1,3.43-4.41c1.64-.95,2.77-.51,2.53,1a7.53,7.53,0,0,1-3.43,4.41C106,302.1,104.91,301.66,105.15,300.18Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Penciles--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M116.21,330.26c2.54,1.41,2.54,3.68,0,5.09a10.58,10.58,0,0,1-9.19,0c-2.53-1.41-2.53-3.68,0-5.09A10.58,10.58,0,0,1,116.21,330.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil-can--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Can--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.22,321.48H106l1.25,10.31h0a2.26,2.26,0,0,0,1.27,1.64,6.82,6.82,0,0,0,6.16,0,2.26,2.26,0,0,0,1.27-1.64h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.22,321.48H106l1.25,10.31h0a2.26,2.26,0,0,0,1.27,1.64,6.82,6.82,0,0,0,6.16,0,2.26,2.26,0,0,0,1.27-1.64h0Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66,319.19a8.73,8.73,0,0,1,7.93,0c2.18,1.26,2.18,3.31,0,4.58a8.79,8.79,0,0,1-7.93,0C105.47,322.5,105.47,320.45,107.66,319.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66,319.19a8.73,8.73,0,0,1,7.93,0c2.18,1.26,2.18,3.31,0,4.58a8.79,8.79,0,0,1-7.93,0C105.47,322.5,105.47,320.45,107.66,319.19Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62,324.06a7.37,7.37,0,0,1-3.64-.86,1.79,1.79,0,0,1,0-3.45,8.13,8.13,0,0,1,7.28,0,1.79,1.79,0,0,1,0,3.45A7.34,7.34,0,0,1,111.62,324.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.67,327.2l0-.34-.06-.4-2-14.61a1.66,1.66,0,0,0,1.22.24,1.77,1.77,0,0,0,1.33-.62l2,14.5.11.78C111.11,326.25,108.58,326.7,108.67,327.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,325.92l-.11-.76c0-.21.41-.42.94-.54.7-.17,1.55-.19,1.6.1l.08.56,0,.19c0-.28-.91-.26-1.61-.1-.51.12-.94.32-.94.52h0A0,0,0,0,0,108.49,325.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,325.73c-.09-.51,2.45-1,2.54-.44l.11.75c-.09-.51-2.63-.06-2.54.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67,327.2l-.11-.74c-.09-.5,2.36-.95,2.54-.49a0,0,0,0,0,0,0l.1.75C111.11,326.25,108.58,326.7,108.67,327.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,309c-.37.1-.5,0-.5,0l-.54,2.86a1.53,1.53,0,0,0,1.63.33l0-.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.07 311.47 109.07 311.47 109.07 311.47 109.07 311.47 109.07 311.47 107.74 308.83 107.74 308.83 109.07 311.47",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.74 308.83 107.42 308.19 107.74 308.83 107.74 308.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21,308.22l-.15.77s.13.09.5,0l-.14-.78h0a.11.11,0,0,0-.15-.05A.1.1,0,0,0,107.21,308.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,326l-2-14.5a1.36,1.36,0,0,1-.92.71l1.9,14.39h0c.57-.08,1.11-.05,1.16.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,311.47h0l-1.33-2.64a.32.32,0,0,1-.18.14l.57,3.07,0,.14A1.36,1.36,0,0,0,109.07,311.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,309a.25.25,0,0,0,.18-.14l-.32-.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,330.35l-.44-3.15c0-.22.4-.42.92-.55.71-.16,1.56-.19,1.62.1h0l.43,3c.15.7-1.14,1.2-1.94,1A.68.68,0,0,1,109.11,330.35Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.8,310.53h0a74.92,74.92,0,0,0-.5,7.87,52.82,52.82,0,0,0,.86,8.77h0a.29.29,0,0,0,.17.19.28.28,0,0,0,.38-.15.14.14,0,0,0,0-.07h0a57.4,57.4,0,0,0,1-8.79,75.25,75.25,0,0,0-.49-7.85h0a.38.38,0,0,0-.21-.25,1.1,1.1,0,0,0-1,0A.36.36,0,0,0,110.8,310.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,310.53h0a74.92,74.92,0,0,0-.5,7.87,52.82,52.82,0,0,0,.86,8.77h0a.29.29,0,0,0,.17.19.28.28,0,0,0,.38-.15.14.14,0,0,0,0-.07h0a57.4,57.4,0,0,0,1-8.79,75.25,75.25,0,0,0-.49-7.85h0a.38.38,0,0,0-.21-.25,1.1,1.1,0,0,0-1,0A.36.36,0,0,0,110.8,310.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,327.23a.14.14,0,0,0,0-.07h0a57.4,57.4,0,0,0,1-8.79c0-2.57-.22-5.23-.37-6.7l-.89.15s.14,15.55-.11,15.56A.28.28,0,0,0,111.71,327.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,310.15a4.23,4.23,0,0,0,.58-2.5,1.21,1.21,0,0,1-.39-.09c-.49-.2-.43-.63-.78-.82s-.76.4-.77.4h0a3,3,0,0,0,.66,3.39h1.41l.28-.42-.28.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,307.87c-.3-.36-.61-.21-1-.22a4.23,4.23,0,0,1-.58,2.5l.71.37.28-.42.07-.12a2,2,0,0,0,.14-.25,2.68,2.68,0,0,0,.19-.42,3,3,0,0,0,.1-.32,3.47,3.47,0,0,0,.11-.75C113.1,308.11,113.09,308,113.08,307.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,307.87c-.3-.36-.61-.21-1-.22a4.23,4.23,0,0,1-.58,2.5l.71.37.28-.42.07-.12a2,2,0,0,0,.14-.25,2.68,2.68,0,0,0,.19-.42,3,3,0,0,0,.1-.32,3.47,3.47,0,0,0,.11-.75C113.1,308.11,113.09,308,113.08,307.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,307.87c0-.07,0-.13,0-.19h0l0-.14s0,0,0,0l0,0a.64.64,0,0,1,0-.07l0-.08a1.62,1.62,0,0,0-.1-.18,1,1,0,0,0-.11-.17,1,1,0,0,0-.12-.16,3.15,3.15,0,0,0-.93-.76l-.08,0h0l-.09,0a2.47,2.47,0,0,0-.57-.18l-.25-.05-.22,0H110a1.24,1.24,0,0,1,.28,1,2.47,2.47,0,0,1-.11.43s.42-.58.77-.4.29.62.78.82a1.21,1.21,0,0,0,.39.09c.39,0,.7-.14,1,.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,305.68a3.27,3.27,0,0,1,1.91,1.46,1.51,1.51,0,0,1,.2.51c.39,0,.7-.14,1,.22h0c0-.07,0-.13,0-.19h0l0-.14s0,0,0,0l0,0a.64.64,0,0,1,0-.07l0-.08a1.62,1.62,0,0,0-.1-.18,1,1,0,0,0-.11-.17,1,1,0,0,0-.12-.16,3.15,3.15,0,0,0-.93-.76l-.08,0h0l-.09,0a2.47,2.47,0,0,0-.57-.18l-.25-.05-.22,0H110Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.21,310.52a.38.38,0,0,0-.21-.25,1.1,1.1,0,0,0-1,0,.36.36,0,0,0-.2.26c-.07.55-.13,1.15-.19,1.78a.48.48,0,0,1,.26-.34,1.4,1.4,0,0,1,1.26,0,.43.43,0,0,1,.26.35C112.33,311.62,112.26,311,112.21,310.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,311.82a1.3,1.3,0,0,1,.69.15.43.43,0,0,1,.26.35c-.06-.7-.13-1.35-.18-1.8a.38.38,0,0,0-.21-.25,1,1,0,0,0-.5-.12h0l0,1.66Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.92,326.49l.66,3.44a.11.11,0,0,0,.2,0l1.58-3.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,330a.11.11,0,0,1-.2,0l-.13-.67h0a.6.6,0,0,0,.62.05l.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,312.18l0,.32-.06.38-1.94,13.93a1.58,1.58,0,0,1-1.09.34,1.56,1.56,0,0,1-1.34-.66l1.94-13.92.1-.74C113.93,312.32,116.36,312.66,116.4,312.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,313.4l-.11.72c0,.2-.48.28-1,.25-.69,0-1.46-.33-1.43-.61l.08-.53,0-.18c0,.27.75.57,1.44.6.49,0,.94,0,1-.23h0S116.24,313.41,116.24,313.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,313.58c0,.48-2.48.13-2.43-.36l.1-.71c0,.48,2.38.83,2.43.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,312.18l-.1.7c0,.48-2.39.16-2.43-.31v0l.1-.72C113.93,312.32,116.36,312.66,116.4,312.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,330l-.1-.09.34-2.82,2-14.73s0,0,0-.05c.66.13,1.44.12,1.46-.15l0,.32-.06.38-1.94,13.93h0L112.78,330A.11.11,0,0,1,112.68,330Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,309.17l-.42,3c0,.2-.47.28-1,.25-.69,0-1.46-.32-1.44-.6h0l.42-3c.08-.6,1.32-.58,2-.22A.63.63,0,0,1,116.82,309.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,309.62a1.92,1.92,0,0,1-1.61-.51.47.47,0,0,1-.1-.39c.2-.5,1.34-.47,2-.13a.63.63,0,0,1,.42.56C116.78,309.38,116.53,309.56,116.12,309.62Z",
    style: {
      opacity: 0.1
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--V--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M183.79,297.16l20.3-11.72a.25.25,0,0,0,0-.47L180,271.16a.89.89,0,0,0-.81,0L159,282.84a.25.25,0,0,0,0,.47l24,13.85A.89.89,0,0,0,183.79,297.16Z",
    style: {
      opacity: 0.2
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186,294.28l-.56-.32a.9.9,0,0,1,.47,0C186.08,294,186,294.28,186,294.28Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.41,293.93a.68.68,0,0,0-1,0c-.55.5-.58,1-.81,1s-.22-4-.22-4l2.16,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,279.35l0,0,.35-.2,14.9-8.6,21.7,14.05c.36.21.43.51.15.67l-.51.29-13.93,8-.1-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,289l1.08-.22v4.32c-.65.27-1.06.53-1.13,1.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.11,293.16l13.8-8a1,1,0,0,0,.43-.75v-4.26l-13.93,8.11a1.29,1.29,0,0,1-.66.79c-.49.19-.12.39-.12.39v3.63C186.06,293.06,186.11,293.16,186.11,293.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.84,288.86c.14-.08.25-.09.25,0V289c0,.15.23.14.51,0s.51-.42.51-.57v-.13c0-.08.2-.25.43-.39L164.1,275l-.35.2a.32.32,0,0,0-.09.19v.13c0,.15-.22.4-.5.57s-.51.17-.51,0V276c0-.08-.12-.07-.26,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,275.24l0,0,.35-.2,14.9-8.6L200.7,279c.36.21.43.51.15.67l-.51.29-13.93,8.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,275.86l22.43,12.95-.78.61-22.36-12.9a.88.88,0,0,1,.3-.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,282.31l0,0,0,0a.09.09,0,0,1,0-.06l0,0a.61.61,0,0,1,0-.12.88.88,0,0,1-.05-.15l0-.17a.34.34,0,0,1,0-.1v-.09a1.15,1.15,0,0,1,0-.19v-3.71a3,3,0,0,1,.21-1.13l22.36,12.91.09,5.81L162,282.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,289.42h0l-19.21-9c-1.06-.5-1.58.54-1.33,1.63A5.11,5.11,0,0,0,164.9,284h0L162,282.32h0l0,0,0,0a.09.09,0,0,1,0-.06l0,0a.61.61,0,0,1,0-.12.88.88,0,0,1-.05-.15l0-.17a.34.34,0,0,1,0-.1v-.09a1.15,1.15,0,0,1,0-.19v-3.71a3,3,0,0,1,.21-1.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,290.55h.5a2.33,2.33,0,0,1,.24-1.09.69.69,0,0,0,.41.13,1.26,1.26,0,0,0,.62-.19,1.87,1.87,0,0,0,.58-.51l0,0a.8.8,0,0,0,.15-.43l13.22-7.63.44-.26.58-.33a.31.31,0,0,0,.17-.26v-.58a.31.31,0,0,1-.17.26h0l-1.52.87-12.77,7.38c-.24.14-.44.31-.44.39v.13a.39.39,0,0,1-.12.24,1.65,1.65,0,0,1-.39.33c-.28.16-.51.17-.51,0v-.14c0-.08-.11-.07-.25,0l-.25.15A2,2,0,0,0,184.08,290.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,290.55v3.86l0,.13h0a1.41,1.41,0,0,1,.75-.94,1.26,1.26,0,0,1,.61-.19.63.63,0,0,1,.45.17l.05,0,.09-.05,12.77-7.38.74-.42.21-.13.61-.35A.29.29,0,0,0,201,285v.58a.29.29,0,0,1-.13.23h0l-.23.13-.14.09a2,2,0,0,0-.25.14l-.15.09-.11.06-.18.11-10.15,5.86-3.25,1.87c-.23.13-.41.18-.43.11v-.15c0-.17-.23-.17-.51,0a.69.69,0,0,0-.4.51v.16a.26.26,0,0,1-.07.19l-.08,0-.16.09-.19.12a.21.21,0,0,1-.26,0l0,0-.05-.06h0l0,0-.06-.13s0-.09,0-.14l0-.17s0-.07,0-.1v-.09a1.15,1.15,0,0,1,0-.19v-3.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.93,276.51l21.25,12.27,16.06-9.27a.26.26,0,0,0,0-.5l-21-12.14L164.1,275h0l-.35.2a.32.32,0,0,0-.09.19v.13c0,.15-.22.4-.5.57l0,0-.47-.27-.22.13h0l-.16.1A.83.83,0,0,0,161.93,276.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,279.6l-.64-.34.59-.14A.46.46,0,0,1,198,279.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,279.6l-.64-.34.59-.14A.46.46,0,0,1,198,279.6Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,288.13a1.42,1.42,0,0,0,1.3,0L197,279.7l-21.85-12.41-.51-.29-14.59,8.22c-.36.21-.36.55,0,.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,272.42l5.09,2.93,3.29-1.91,3.83,2.22v2.56c0,.33-.37.81-.51.73a3.6,3.6,0,0,0-.73.26,5.75,5.75,0,0,0-1.06.78l-11.69-6.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,272.42l5.09,2.93,3.29-1.91,3.83,2.22v2.56c0,.33-.37.81-.51.73a3.6,3.6,0,0,0-.73.26,5.75,5.75,0,0,0-1.06.78l-11.69-6.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,276v2.77l.05,0a1.26,1.26,0,0,1,.62-.19.62.62,0,0,1,.41.1v-3.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,279.7a.82.82,0,0,1,.18-.48,1.12,1.12,0,0,1,.18-.2l.06-.06.08-.07.07-.05.14-.1V276l-.71.41h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,278.22c0,.33-.37.81-.51.73h0l-.51-.33v-2.11l.51-.89.28-.1.23.14Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,284.59v3.17a.88.88,0,0,0,.43-.1l1.6-.92,12.2-7v-3.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,272.69v2.4a1,1,0,0,0,.44.75l18.88,10.9,1.59.92a.89.89,0,0,0,.44.1V285Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,263.18,197,275.79v.29c0,.17.23.23.51.06s.51-.36.51-.64l0-.28-22.26-12.85-.09-.05a.22.22,0,0,0,0,.13v.14C175.66,262.75,175.43,263,175.15,263.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,263.18,197,275.79v.29c0,.17.23.23.51.06s.51-.36.51-.64l0-.28-22.26-12.85-.09-.05a.22.22,0,0,0,0,.13v.14C175.66,262.75,175.43,263,175.15,263.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,284.22,196.68,276c.18-.1.35-.17.42-.14l-.1,0-21.85-12.61-.25-.15a.82.82,0,0,0-.69.1l-14.16,8.18a.4.4,0,0,0,0,.75l21.06,12.16A1.42,1.42,0,0,0,182.41,284.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,262.32l.09.05,22.26,12.85a.14.14,0,0,1,0-.06l.07,0,.16-.09.2-.12a.21.21,0,0,1,.25,0l0,0,.06.09a.34.34,0,0,1,.06.12l0,.15,0,.17a.34.34,0,0,1,0,.1v.08c0,.07,0,.13,0,.2v-.63a1.37,1.37,0,0,0-.65-1l-21.06-12.16a1.34,1.34,0,0,0-1.16-.08l-.27.16h0l-.11.07h0A.24.24,0,0,0,175.7,262.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,288.13l.88-.51L196.5,280a.86.86,0,0,1,.18-.47,2,2,0,0,1,.58-.51,1.3,1.3,0,0,1,.62-.2.64.64,0,0,1,.41.14,2.21,2.21,0,0,0,.25-1.09h.5a2,2,0,0,1-.51,1.54l-.25.15c-.15.08-.26.09-.26,0v-.14c0-.15-.23-.14-.51,0s-.51.42-.51.57v.13c0,.08-.19.25-.43.39l-12.78,7.38-1.38.8h0a1.34,1.34,0,0,1-.64.15v-.58A1.38,1.38,0,0,0,182.41,288.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,288.13l.88-.51L196.5,280a.86.86,0,0,1,.18-.47,2,2,0,0,1,.58-.51,1.3,1.3,0,0,1,.62-.2.64.64,0,0,1,.41.14,2.21,2.21,0,0,0,.25-1.09h.5a2,2,0,0,1-.51,1.54l-.25.15c-.15.08-.26.09-.26,0v-.14c0-.15-.23-.14-.51,0s-.51.42-.51.57v.13c0,.08-.19.25-.43.39l-12.78,7.38-1.38.8h0a1.34,1.34,0,0,1-.64.15v-.58A1.38,1.38,0,0,0,182.41,288.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,284.22h0l.88-.51,10.15-5.86,3.24-1.87c.23-.14.42-.18.43-.11h0V276c0,.16.23.16.51,0s.4-.35.4-.51v-.16c0-.08,0-.17.08-.19l.07,0,.16-.09.2-.12a.21.21,0,0,1,.25,0l0,0a.15.15,0,0,1,0,.06l0,0a.34.34,0,0,1,.06.12l0,.15,0,.17a.34.34,0,0,1,0,.1v.08c0,.07,0,.13,0,.2v2h-.5v-2c0-.05,0-.11,0-.16v-.12h0a1.48,1.48,0,0,1-.76.94,1.37,1.37,0,0,1-.61.19.69.69,0,0,1-.45-.17l0,0-.09.05L183.79,284l-1.38.8h0a1.28,1.28,0,0,1-.63.15v-.58A1.26,1.26,0,0,0,182.4,284.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,284.22h0l.88-.51,10.15-5.86,3.24-1.87c.23-.14.42-.18.43-.11h0V276c0,.16.23.16.51,0s.4-.35.4-.51v-.16c0-.08,0-.17.08-.19l.07,0,.16-.09.2-.12a.21.21,0,0,1,.25,0l0,0a.15.15,0,0,1,0,.06l0,0a.34.34,0,0,1,.06.12l0,.15,0,.17a.34.34,0,0,1,0,.1v.08c0,.07,0,.13,0,.2v2h-.5v-2c0-.05,0-.11,0-.16v-.12h0a1.48,1.48,0,0,1-.76.94,1.37,1.37,0,0,1-.61.19.69.69,0,0,1-.45-.17l0,0-.09.05L183.79,284l-1.38.8h0a1.28,1.28,0,0,1-.63.15v-.58A1.26,1.26,0,0,0,182.4,284.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,271.68v.58a.45.45,0,0,0,.26.37h0L179.73,284l1.38.8h0a1.36,1.36,0,0,0,.65.15v-.58a1.36,1.36,0,0,1-.65-.15l-.88-.51h0l-20.18-11.65A.45.45,0,0,1,159.78,271.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,271.68v.58a.45.45,0,0,0,.26.37h0L179.73,284l1.38.8h0a1.36,1.36,0,0,0,.65.15v-.58a1.36,1.36,0,0,1-.65-.15l-.88-.51h0l-20.18-11.65A.45.45,0,0,1,159.78,271.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,275.59v.58a.47.47,0,0,0,.26.38h0l19.68,11.36,1.38.8h0a1.36,1.36,0,0,0,.65.15v-.58a1.36,1.36,0,0,1-.65-.15l-.88-.51h0L160.05,276A.45.45,0,0,1,159.78,275.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,275.59v.58a.47.47,0,0,0,.26.38h0l19.68,11.36,1.38.8h0a1.36,1.36,0,0,0,.65.15v-.58a1.36,1.36,0,0,1-.65-.15l-.88-.51h0L160.05,276A.45.45,0,0,1,159.78,275.59Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Apple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.11,273.63c1.82,1.42,5.32,1.74,7.82.72s3-3,1.19-4.41-5.34-1.74-7.83-.72S175.28,272.22,177.11,273.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,262.13a4.15,4.15,0,0,0-4,2.51,6.14,6.14,0,0,0,2,7.29c2.47,1.74,6.34,1.84,8.62-.23,2.52-2.3,2.71-6.65,1-8.56a4.81,4.81,0,0,0-5.06-1.07C181.07,262.51,180.37,262.08,179.56,262.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.56,262.13a4.15,4.15,0,0,0-4,2.51,6.14,6.14,0,0,0,2,7.29c2.47,1.74,6.34,1.84,8.62-.23,2.52-2.3,2.71-6.65,1-8.56a4.81,4.81,0,0,0-5.06-1.07C181.07,262.51,180.37,262.08,179.56,262.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,271.16a8.33,8.33,0,0,1-8.58-.69,5.72,5.72,0,0,0,1.39,1.46c2.47,1.74,6.34,1.84,8.62-.23a7.08,7.08,0,0,0,1.89-6.81C188.17,265.49,187.71,269.55,184.75,271.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.49,263.05a2.62,2.62,0,0,0-2.15,1.45,6.44,6.44,0,0,0-.52,3.89c.4,2.34,2.67,3.57,2.88,3.37s-1.42-1.73-.52-4.06S179.58,263.14,178.49,263.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,263.43a3.53,3.53,0,0,0-1.68,2.09,1.9,1.9,0,0,0,0,1.38c.19.17,1.58-1.19,2-1.79C179,264.25,179.07,263.06,178,263.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.64,264.13c-.36-.29-.7-.43-.89,0s.79,1.12,1.86.81,1.45-1,1.43-1.37a2,2,0,0,1-1.21.86A1.83,1.83,0,0,1,180.64,264.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.64,264.13c-.36-.29-.7-.43-.89,0s.79,1.12,1.86.81,1.45-1,1.43-1.37a2,2,0,0,1-1.21.86A1.83,1.83,0,0,1,180.64,264.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,264.67a9.9,9.9,0,0,0-.48-2.94,5.41,5.41,0,0,0-1.58-2.44,2.73,2.73,0,0,0-1.17-.18c-.55,0-1.21.38-1,.59a10.65,10.65,0,0,1,1.94,1.27,6.37,6.37,0,0,1,1.88,3.7A.45.45,0,0,0,181.61,264.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,259.27l0,0h0a3.13,3.13,0,0,0-1.07-.14,1.5,1.5,0,0,0-1,.4c0,.08.08.19.57.26a3.06,3.06,0,0,0,1.45-.14C179.6,259.55,179.69,259.36,179.51,259.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,262.93a5.68,5.68,0,0,0-2.65-2.73h0a5.27,5.27,0,0,1,1,.77,6.37,6.37,0,0,1,1.88,3.7.45.45,0,0,0,.44,0,7.45,7.45,0,0,0-.05-.92C181.53,264.25,181.3,264.07,180.9,262.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35,262.5a2.56,2.56,0,0,0,2.4-.93,2.61,2.61,0,0,0,.27-2.3,2.43,2.43,0,0,0-2.12.66A2.89,2.89,0,0,0,181.35,262.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35,262.5a2.56,2.56,0,0,0,2.4-.93,2.61,2.61,0,0,0,.27-2.3,2.43,2.43,0,0,0-2.12.66A2.89,2.89,0,0,0,181.35,262.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,259.27a2.43,2.43,0,0,0-2.12.66,2.89,2.89,0,0,0-.55,2.57A7.14,7.14,0,0,1,184,259.27Z",
    style: {
      fill: "#BA68C8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--map--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.49,136.94a.38.38,0,0,1-.25-.09L408.36,82,348.27,66.7a.37.37,0,1,1,.19-.72l60.17,15.35a.3.3,0,0,1,.16.08l60.95,54.88a.37.37,0,0,1,0,.53A.38.38,0,0,1,469.49,136.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--map--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 229.59 348.19 159.9 348.19 70.95 468.89 140.64 468.89 229.59",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 229.59 348.19 159.9 348.19 70.95 468.89 140.64 468.89 229.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.61 158.13 350.61 75.62 466.47 142.52 466.47 225.03 350.61 158.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.61 158.13 350.61 75.62 466.47 142.52 466.47 225.03 350.61 158.13",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,97.63c0,.32-.42.28-.07.66a2.23,2.23,0,0,1-.35-.17c.1.62.73.74,1,.8-.07.49-.12.52.39,1a5.44,5.44,0,0,1,2.24.56c.37-1.28-.92-.48-.82-1.93-.25-.19-.61-.31-.55.17.17.21.08.45.25.73-.18-.11-.44-.12-.43-.47-.09-.1-.23,0-.27-.28-.23-.31-.83-.6-.82-1C369.25,97.42,369.21,97.81,369,97.63Zm25.48,57.64c-.36-.39-1.13-.82-1.09-1.61-.07-.06-.18,0-.18-.22-.53-.64-1.09-.46-1.55-1.22-.53-1.08-1.14-1.29-1.79-1.94-.33-.26.14-.47-.1-.8a7.93,7.93,0,0,0-.92-2c-.2.11,0-.27-.25-.29-.15.22-.18-.59-.41-.25-.7.13-1-1.59-1.64-2-.35-.36-.22-.69-.51-1.12-.59-.65-1.13-.37-1.74-1.11-.47-.1-.32-1.11-1.22-1-.35.13-.19-.17-.31-.44-.78-.17-1.14-.06-1.51.61-.36-.42-.74-1.24-1.18-1-2-1,.3-3.82-2.47-4.27,0-.14.22-.14.06-.3-.57-.9.5-.46.31-1.28.38-.47-.15-.94-.66-1s-.28,1.14-.86.73c-1.75-.18-2.25-4.58-1.16-5.07.57-.52,1.17.27,1.87.74.42-.53.34-.15,1.07.14.28.08.29.77.54.62.77.24.61,1.88,1.09,2.65,1.1.72-.49-2.62.12-2.92.37-.54,1.56-.35,1.58-1.12-.1-.16.06-.29-.15-.46a1.26,1.26,0,0,1-.06-.82c.17.06.07.44.25.53.2-.1.08-.59.24-.54.36-.3.29-.55,1-.36-.11-.17-.25-.17-.36-.34,1.51.69-.13-1.19,2.09-.75.42,0,.27.12.06.35-.17.63.59.79.75.44.47.22,1.14.28,1.38-.11-.37-.47,0-.54-.59-.64-.05.17,0,.57-.23.35-.09.11-.18.06-.27-.16-.7-.3-.37-1.13-.8-1.46.07-.11.22,0,.34,0,.12-1.35-1-.59-1.46-1.18.78-.66,2,.47,3.1.79.11-.27.43-.2.64.09-.07.53-1.2,1.2-.35,1.77.58-.27,2.05,2.46,1.62.46-.38-1.27-.38-.46-.93-1.47.18-1.94.45-1-.46-3a6.11,6.11,0,0,1-1.24-1.66c.05-.56-.9-3.76-1.19-2.76s-1.31.19-1.28-.88c0-.32.1-.56-.22-.78-.61-.32-.82-1.76-1.45-1.71-.36-.06-.92-1-1.15-.49,0,.26.18.68,0,.87.07.24.42.73.18.79-.52.37.2.94.27,1.5.51,2-1.33.14-.64,2.43.39.72-.61,1-.64.11-.21,0-.19-.27-.18-.47-.43-.31-.23-1.15-.27-1.61-.29-.25-.79-.24-.92-.77-.25-.31-.6-.43-.72-.91-.46-.37-.93-1.27-1.41-1.21-.23.06-.12-.49-.15-.66a.68.68,0,0,1-.18-.59c-.45-.11-.75-.79-.45-1.12,0-.21-.08-.55.18-.5.07-.27.15-.59.45-.46-.14-.76.5,0,.5-.45-.32-.17-.49-.64-.76-.87.32,0,.75.79,1,.45.07-.09.14-.15.29.1a.34.34,0,0,0,.49,0c.26-.43-.94-1-.64-1.29,1.8,2.15.21-.93,1.66.83.07-.31.29-.06.45,0,0-.18.12,0,.19,0,0-.17.13-.19.27-.09.18-.38-.61-1.29,0-1.09v-.49c-.34-.07-.37-.7-.72-.82.22-.08.55.29.81.39.08-.11.42,0,.46.26.68,0,.39,0,1,1,.22.34-.3.19,0,.59,0,.41.18.8.52.72-.58-1.46,1.44,1.25.45,1.09-.37-.27-.24.36-.27.66-.29.24-1.4-1-1.27,0,.33.81,1.07.6,1.48.93s.29,1.13.76,1.46c.49.11,1.39,2.26,1.58,1.39a2.78,2.78,0,0,1-.36-.76c.27.2.51.2.77.38.22-.61-.4-1.37-.81-1.93-.36-2.31.94,1.07,1.18.68.22-.14.42-.49.77-.4a6.91,6.91,0,0,0-1.12-1.73c-.47-.49-1.18-.9-.61-1.27-.37-.27-.14-.26-.2-.61a10.16,10.16,0,0,0-1.64-2.21c-.62-.28-1.16-1.94-1.76-2.36-.49.12-.93-1.14-1.5-1.23-.27-.19-.79.24-.78-.45-1.94-1.27-2,1.41-.32,2.73.24.18.52.19.72.49-.16-.07-.32-.18-.45-.09v.24c.28.3.24.69-.09.44,0,.21,0,.51-.15.49l0-.23c-.36-.3,0,.35-.12.51-.11,0-.56-.77-.34-.77s-.07-.63-.16-.82a.43.43,0,0,0-.5-.3c-.36-.56-.33-1.22-.77-1.66-.87-2.41.15-.67.44-1.6.57-.52-.9-1.45-1.25-1.37-.36.33.16,1.51-.2,1.7s-.27.73-.22,1.21-.52-.44-.61-.16c-.05.49-.53.13,0,.76-.09,1-1.84-.36-2.3-1.3.46.53,1.88.85.91-.16,1.68.63-.67-1-.57-1.86-.45-.79.35-1.46-.28-1.86-.33-.33-.35,0-.6,0-.52-.29,0,.9-.16,1.13-.19-.55-.3-1.26-.81-1.42,0,0-.09.47-.24.13s-.3-.23-.42-.51-.31.52-.56-.07c.33.09.1-.28.07-.48-.58-.29-1.45-.42-1.46.5.22-.05.24.41.41.49,0,.13-.07.13-.14.15.36.9,1.44.64,1.82,1.56-.46,0-1.12-.66-1.64-.72v.24c1.12,1.22,1.68,2,3,2.44.91,1.4-.2-.33.14,1.29-.16.42-.44-1.2-1-1.1-.46-.17-1.79-.64-1.11-1.22-.88-.79-1.86-1.79-2.78-2.46.08.44-.64,0-.37-.21v-.12c-.3-.18-.57.47-.72-.42-.09-.18-.33-.82-.46-.64.06.51-.86.36-.82-.1-.56,0-1.13-.45-1.64-.46l.17.41c-.62-.13-1.09-1.29-1.72-1.55,0-.32-.34-.13-.37-.45A28.44,28.44,0,0,1,358,95.91c-.36.14-1.29-.86-1.56-1.34-.46-.39-.78,0-1.27-.42,0,.6-.53-.14-.71.12s-.49.79-1,.34c-.82-.51.53,1.25.7,1.62.42.14.49.55.74,1-.51,0-.87-.42-1.22-.89-.31.18-.7,0-1,0,.27.48.43.48.54,1,.45.72,1.27.57,1.64.92.09,1.23-.29.34-.59.78-.28-.11-.42-.53-.59-.17s-.65.44-.19,1.09c-.19.18.14.39.22.57.07.74.8.58.84,1-.26,1,.52.29.78,1,.14.31.2-.08.32-.11l0,.12c.66.27.11.87.1,1.22.57.39,1-.08,1.45-.3-.27-.49-.26-.73.19-.4-.09-.33.37-.72.45-.33s0,.69-.25.65c.44.75.7-.14,1.21.37.28.22,0-.55.19-.61s.3.44.34.63a7.25,7.25,0,0,1,1.84,1.47c1.15.63,1.42,2.76,2.34,3.31.26.28-.12.2,0,.41,0,.38.16.92.51.7.19-.08.58.7.49,1,.07.41.48.79.72,1.13s-.07.43.1.75-.25.35.05.63a4.8,4.8,0,0,1,1.15,2.94,9.24,9.24,0,0,0,1.77,7,7.86,7.86,0,0,1,.77,2.2c0,.45,1,1.44.28,1.26.22.61.93.84.81,1.55,0,.16.12.24.18.35,1.59,2.84-.06-1.1-.45-2.19.16-.06,0-.3,0-.32-1.1-1.48.31-1.39.33.51.74,1.31,2.48,4.05,2.17,5.3,1.08,2.11,2.74,3,4,4.39a2.74,2.74,0,0,0,1.46,1.57c.48.58.52,1.54.8,2.05a14.3,14.3,0,0,1,1.08,1.34c.75,1.38.34-.19.91.06.16.35.09.56.24.93l.17.14c.76,2.16-1.53,1.76-.86,3.62.36.47-.28,0-.15.42-.56.39.5,1.56.63,2.3a13.15,13.15,0,0,0,2.66,5.67,7.88,7.88,0,0,1,0,2.39c-.45,1.77-.16,4.11-.94,5.56-.29-.06,0,.82,0,1.15s-.54,1.5-.22,1.91c.33.24,0-.75.29-.67.28.68-.27,1-.06,1.72-.15.06-.9-.24-.56.5.07.15.36.31.12.45-.07.07.17.37,0,.32-.23-.24-.47,0-.17.27.07,0,.21.07.08.2-.38.19.23.57.13.87a.31.31,0,0,0,.07.55l0,.2a.79.79,0,0,1,.34.34c-.09.07-.22,0-.18.27.2,0,.9.17.46.32.59.55-.12.17.09,1.09.1.23.36.22.39.56.1.17.19-.07.28.17s.2.15.35.3.11.3.21.27c.05-.67.06-.5.41-.65-.61.16-1-2.68-.41-2.5.41-.91,1.25-.35.23-1.95,0-.29.2-.33.36-.31.49,0,.26-.92.82-.8.09-.36-.47-.41-.36-.76,0-.88,1,1.07.82-.67,1.06.32,2.3.74,1.37-1.54.09.1.23,0,.27.28,1,.79,1.09.28,1.55-.2-.05-.38.17-.46.29-.63s.08.35.26.34c0-.08,0-.26.09-.19-.07-.81.72-.48.55-1.39-.32-.55.37-.95.73-.79,1.32-.32,1,.81,2.09-.61,0-.25-.12-1,.19-.87,0-.13-.06-.7.09-.68-.48-1.67.56-1.77,1.18-2.23,0-.35-.07-.82.09-1A1.2,1.2,0,0,1,394.45,155.27Zm-17.95-34c.94-.32,1.7-.61,2.27,1.44.26.89,1.33.75,1.45,1.87-.9-.28-.23,0-.72.56-.24-.2.06-.57-.28-.64s.18-.58-.2-.86c-1.07-1-.48,1.4-1.07,1.21a2.32,2.32,0,0,1,.06-2.06c0-.33-.51-1.06-.77-.9S376.52,121.51,376.5,121.24ZM362.66,107a.33.33,0,0,1,0-.06h.05l0,.06Zm5.88-1.86c-.16.11-.28.33-.55.09s-.39.64-.63,0c-.13-.44-.19.19-.39-.09-.49-.17,0-.77.21-.66a1.59,1.59,0,0,0-.26-.41c.35,0,.85-.18,1.06.59C368.08,105,368.58,104.66,368.54,105.12Zm3.52.5,0-.09,0,0C372.08,105.56,372.11,105.61,372.06,105.62Zm-4.92-8.8c.18.2.46-.06.41.36.21.2.28-.21.51,0,.34-1.42.28,1.21,1-.42-.38-.48-.66-.34-1.09-.69C367.93,96.61,366.34,96.08,367.14,96.82Zm6.61,3.09c-.36,1.32.11.48.37,1.55a.93.93,0,0,0,.45.38c0-.13,0-.23.09-.25-.22-.42.14-.53-.18-1C374.2,100.48,374,100,373.75,99.91Zm-9.12.25c-.09-.13-.18-.16-.27-.14C364.44,100.17,364.53,100.14,364.63,100.16Zm1.57-.59c.36.33.34,1,.89,1.12s.58-.72,1.21-.65c.22,0,1.15.14.62-.42-.07-.14-.25-.21-.18-.42-.2-.06-.44-.37-.6-.22-.5-.5-1.59-1.63-1.87-1.08.33.29,0,1-.18,1,0,.22,0,.26-.18.14A.53.53,0,0,0,366.2,99.57Zm6.53-2.14c.25.21.28.45,0,.29-.83-.1.94.63,1,1,1.5,1.27-.19-1.09-.55-1.53l-.82-.47a.89.89,0,0,0,.09.54C372.5,97.31,372.61,97.19,372.73,97.43Zm61.18,34.68c.75.58,2.22,3.09,2.44,1.52.29-.66-.87-.71-.74-1.38C435.63,130.62,433.54,131,433.91,132.11Zm2.14,2.75c.57.31,1.7,1.06,2,.52C437.41,133.81,436.32,133.68,436.05,134.86Zm12.26,9.92.5.29v0c.45.09,2,1.27,1.63.06-.6-.88-1.27-.81-1.79-1.51S447.49,144.26,448.31,144.78Zm-73.65-42.16c-.23-.07-1.66-.52-.88.23.24.68-.66-.55-.67,0s.78,1,1,1.69c.52,1.25,1.67-.69.69-.84-.61-.43.38-.16.08-.61C374.77,102.91,374.6,102.83,374.66,102.62Zm46.78,28.84c-.07.33.35.47.28.76.17.17.31-.18.39.32s1.67,1.56,1,.48c-1-1.63.91-2.29,1.73-2.17a2,2,0,0,1,1.64.22c.08-.23.27-.17.46-.1,0-.4-.06-.58-.37-.7-.23.09-.69-.11-1-.21-1.71-.51-2.47-.63-3.41.93-.18-.08-.22,0-.25.26C421.87,131.65,421.36,131,421.44,131.46Zm-46.11-33c.08.3.34.29.48.46.15,1,1.46,2.18,1.92,1.71.34.59-.24.58,0,1,.08.23,0,.2-.07.15-.41-.15-.53.47-1-.21-.49,0-.93-1-1.49-1.12l-.09.19c.53,1,1.51,1.11,1.46,2.54.11.11.34.09.36.33.4.28.74.16,1.1.76.31.11.69.54,1,.7,0-.56.81.17,1,.45l.18.11c.78-.77-.7-1.51-1.27-1.83-.43-.07-1.88-.7-1.48-1.46.71.39,1.28,1.11,1.94,1.12.58.59.94.9,1.55.88.3-.24-.19-.56-.37-.75.16-.79,2,.56,1.38-1.14,1-.13,2.62.22,3.23-.51.74.16,1.74.36.49-.74-1.21-1.44-2.82-2-4.2-2.86-.41,0-.84-.41-1.23-.48a2.58,2.58,0,0,1-1.68-.59c.07.31-.15.12-.26.15.06.45-.28.13-.37-.16-.25-.31-.51.37-.64-.12-.21,0-.45-.19-.64-.13.13.34.27,0,.45.32l-.09.13c.4.13-.08.4.29.55.06,0,.14.21.2.33.22.6.86.15.79.57,0,.22.19.19.21.36a8.16,8.16,0,0,0,2.15.73c0,.9-1.86-.93-.74.8-.46-.17-1.49-2.15-1.7-1.16.1.56.71.56.62,1.13-.28-.64-.83-.57-.89-1.38,0-.22,0-.47-.24-.33a5.69,5.69,0,0,1-.87-1.21c-.27-.1-.43-.57-.64-.86s-.54-.16-.57.13c-.39-.09-.26.45-.42.64C374.8,97.6,375.34,98.22,375.33,98.48Zm33.61,19.59c-.09.75.48,1,.83,1.85-.32.44.45.63.55,1.15.57,1,.72-1.38,1.36-.8a2,2,0,0,0,.36.7c-.15.14,0,.25.1.37.45.72.44.35.82.38a6.86,6.86,0,0,1-1.07-2c.75.37,1.6,1.09,2,.23a4.66,4.66,0,0,0-1.54-1.15c-.11.39-.59-.64-.82-.61-.1.32-.51-.33-.61.07-.11.23-.39-.12-.49-.34-.18.25,0,.58,0,.88-.5-.67-.14-.29-.21-.7-.09.09-.13,0-.12-.14-.19-.19-.06.5-.27.07C410,117.59,408.18,117.06,408.94,118.07ZM402.54,134c.89.15,1.34,0,.7-1.56-.06.22-.28-.43-.31,0-.19.21-.79-.66-.63.13C402.76,133.43,401.59,133.11,402.54,134Zm1-2.76a.86.86,0,0,0,.07.1c-.13.12-.13.83.06.93.38.14.05.62.38.72.28-.13.35.34.38.67s-.52-.13-.39.43c.13.41-.34.07-.21.46.63.38,0,.4.09.78.24.21.55.48.79.35s.95.72,1.18.2l-.16-.13c.35-.17.48-.59-.09-.92-.15-.37-.18-.67-.3-1s-.36-.44-.27-.73c-.13-.17-.28-.52-.48-.62.65-1.09.08-.46-.16-1.53,0-.27-.25,0-.37-.29s-.25-.1-.25,0C403.84,131,403.25,130.78,403.5,131.19Zm56.93,76.72c-.31.08-.28-.33-.49-.68-.39.22-.62.77-.13,1.55-.27.87.53.87.56,0C460.4,208.47,461.19,208.35,460.43,207.91ZM446,183.55c.35.17.13.63.36,1,.44.82,1.49,1,1.83,2-.36,1.23.07.94.91,1.7.35,1.21.87-.17,1.3.48.91,1.65,1.9,2.64.7.06.22-1.16-2.07-3-2.91-4.09-.36-.46-.83.59-1.12-.23,0-1.12-.84-1.8-1.25-1.19C445.86,183.38,445.93,183.54,446,183.55Zm13.26,25c-.62-.57-.51.18-.83.4-.35.44-1.07,0-1.27.7-.17.36.31.78.27,1.22.16.2.23-.12.41,0C458.19,211,460.32,209.28,459.24,208.6Zm-10.62-41.45c0,.33-.55.93-.65.36a.12.12,0,0,0-.17-.11c-.13.14-.16.93-.48.43-.46-.32-2-.48-1.23.64.29-.07.6.25.88.39,0-.22.06-.14.14,0,.12-.07-.09-.32-.13-.48.38-.13.17.6.53.6a1.88,1.88,0,0,1,1.27.13C449.53,169.18,449.59,164.3,448.62,167.15Zm.33-1.1c.21.08.29-.2,0-.4.37-.08.66.77,1,.5s.73.21.72-.42c-.72-.35-.73-.68-1.22-1.44-.23,0,0,.79-.28.89A.51.51,0,0,0,449,166.05Zm.76-6.36-.09-.05c-.41.84.17,3.06-.18,3.91-.06.36.14.44.34.4s-.41-1-.07-1c0-.09,0-.26.1-.19.06-.43.6.24.27-.82a3.78,3.78,0,0,1-.18-1.56A1.11,1.11,0,0,1,449.71,159.69ZM442.07,178c-.89-1.19-.69-.45-1.34-.29-.55-.11-.87.84-1.59.29l0-.12c-.42.61.38,2.68,1.07,3,1.05.95,1,.68,1.44-.23.62-1.37.69.46.07-1.93C441.82,178.54,442.59,178.62,442.07,178Zm-33.61-36.25c.05-.59-.5-.37-.51-.17.33.48-.24,1.11.14,1.63C408.8,143.64,408.46,142.34,408.46,141.78Zm1,3.54c0,.31.67.28.51,0C409.62,144.45,409.59,144.84,409.49,145.32Zm54.92,15.28c-.55-1.35-1.19-.49-1.37-1.25.06-.78-.87-1.12-.92-1.74a1.92,1.92,0,0,1-.92-1.13c-.55-.27-.91-1.08-1.5-1.23-.31-.27-1-.86-1.32-.71-.31-.08-.54-.89-.91-.58-.18.69-1.77-1.39-1.87-.48,0-.54-.41-.56-.5-.93-.26-2-2-1.14-2.65-2.58-.22-.05-.39-.35-.52-.53-.41-.23-.09-.31-.12-.57-1-.91-.86.66-1.46-.91-.08-.45-.63-.46-.88-.85s-.44.06-.76-.28c.09.12-.26.08,0,.28.52,1-.89.44-1.12-.18-.4-.23-.61.1-1-.57-.3-.3-.17.5-.48.32-1.28-.66-.37-2-1.16-2.73-1.56-1.27-.66-.67-1.77-.54a5.77,5.77,0,0,1-1.6-1.66l-.55-.31c-.06.21-.24-.07-.36-.09-.29.14-.19-.15-.35-.44-.25.29-.56-.45-1-.61,1.51-.38,1.51-1.67-.58-2.55-.43,0-.36-.49-.67-.71s-.22-.67-.41-.95c-.84-.68-.93.56-1.52.24.11.4-.15.08-.35,0-.43.06-.85-.72-1.23-.52-3.4-1.11-.65,1.78-3.47-.13-.08.22-.45-.24-.29.36-.1.35.11.4.38.72.53,1.87-1.72-2-1.4-.39-.2-.29-.52-.34-.25.12.15.19.46.4.46.66-1-.81-1.08-.28-.91-1.78-.3.11-.13.82-.69.35-.26,0,.19.36,0,.69-.14-.18-.41-.23-.35-.56-.22-.32,0-.33,0-.57.36-.81-1.14-1.67-1.18-.68.12.56-.62.2-.41.6s-.17.55-.05,1c.81.36.48,2.19,0,.48-.6-.48-1.16-1.69-1.77-1.85-.34.23-.9-1.34-1-.6.37.47,1.11,1.42.36,1.4,0-.35-.27-.59-.45-.58-.31.31-.77-.49-1.07-.21s-.3-.73-.59-.64c-.85-.65-2.09.83-2.35-.27-.56-.77.61.09.22-.85l-.73-.42c.15.45-.14.66.11,1.12a.35.35,0,0,1,0,.43c-.26.19-.6-.68-.87-.33-.84-.27-.16,1.65-1.33,0-.75-.49.1.58.05.75-1.07-.24-.63-1.87-1.42-2.68.69.49,2.66,2.7,2.53.93-.6-1.38-2.1-2.18-2.73-3.27l-.19-.1c0,.21-.18,0-.27,0a.63.63,0,0,0-.27-.34.57.57,0,0,1,.36-.09c-.18-.52-1-1.42-1.24-1.07,0,0-.06.14-.14-.09-.6-1-1.45-.16-2-.33a.57.57,0,0,0-.41-.6c.12.57-1.13-.18-.36.59-.11.48-.38-.07-.55-.39a1,1,0,0,1-.36.21c.59.85-.54,1.16-.66,1.65s-.31.2-.43.39.18.27,0,.18c-1.21.26-2.61.73-1.38,3.24,1.7,1.13,1.14-1.51,2.08,3,.22.1.35,0,.44-.18.24,0,.81.49.7-.19-.32-1.19,1.26-1,.11-2.42-.17-1.63,1.37-.79,1.36-2.13,1.28-.23,1.43,1.51.19,1.2-.66.87-.06.74-.37,1.85.8,1.32,1.94.5,2.55,1.88-.55.2-1.12-.46-1.73-.67-.3-.28-.57.46-.27.63s.32,0,.45.32c-.25,1.46-1-2-1.09.82,0,.29,0,.46-.26.39s-.3,0-.36-.07c-.51-.94-.94-.09-1.46-.7-.32-.7-.92-.1-1.2-1,.05-.12.16-.05.27,0-.46-.9.18-.35-.08-.88-.17-.26.15-.49-.08-.84-1.65,0,.2,2.11-1,2-.69-.52-1,.28-1.27.72-.54-.52-.32.33-.6.26-.44-.08-.46.19-.93-.38,0,.18.19.73-.07.53s-1.21-1-.77,0a2.45,2.45,0,0,1,.91,2.72c-2.55-1.28-2.12-2.37-2.46,1,.38.14,0,.79.46,1s.55.9,1.09,1c.55-.35.58.64,1.37-.31,0-.18-.13-.91.18-.62,0-.09-.05-.26.09-.19,0-.45.27-.2.55-.05-.06-.42.4.09.27-.45,0-1.12.77.52,1.07.22.81-.3.91-.15,1.4,1.26.7,1.05,1.7,2.07,1.12,3a.56.56,0,0,0,.67-.31c.09-.12-.22-.7.06-.56.82.75-.43-1-.62-1.24-.37-.36-1.41-2.69-.51-2.15.28.73.74,1.94,1.37,2.13a.78.78,0,0,0,.33.7,4.09,4.09,0,0,0,.12,1.26c.37.23.2.71.64.91-.41-.08,0,.88.27,1.07.06-.25.62-.4.36-.82-.09-.14-.35-.22-.19-.34s-.23-.48-.22-.66c.4.43.55-.15,1.06.22,0,.11,0,.22.12.32s-.32,0-.08.29c.32.44,0,1.14.52,1.66.52,1.12.88.4,1.35,1.09.3.7,1.1,0,1.19.74-.25.47-.17,1.57-.46,2a26.12,26.12,0,0,1-2.91-1.81c-2.18-3.1-1.21.31-2-.67-.62-.66-1-1.37-1.61-2a.81.81,0,0,1-.6-.53c.08-.23-.78-.66-.19-.54.42-.15-.14-.92.18-1l-.09-.18c-.15,0-.21-.16-.18-.34l-.37-.21c-.09.22-.63-.32-.82-.36-.42,0-1.21-.56-1.73-.75-.55.88-1.72-.87-2.28-.54a1.82,1.82,0,0,1-1.19.72v.73c.35.64-.63.37-.63.85l-.37-.21c-.69.94-1.54,1.73-.92,3.73.06.5-.6,1-.22,1.45,0,.17,0,.28.14.32-.21.16,0,.84.27,1,.9,2.31,2,4.88,3.83,5,.42.84,1.17.5,1.55.41.16.08.32.22.46.14.85.74.69,1.65,1.73,1.85.05.33.56.59.42.94s.23.63-.2.63c.28.19-.05.26.1.56-.71.24.72,2.2.87,2.93.7,2.13,0,3.12-.19,4.76.09,1.1.93,2.89.82,4.17.18,1.14.82,2.43,1,3.6-.21.26.07,1,.35,1.31,1.84,1.09,4,.9,4.16-1.76,1.57.54.12-2,.94-2.39.35-.58,1.46.1,1.49-.93.14-1.4-.45-2.92-.52-4.2.65-2.38,4.1-1.78,3.76-5.25a3.38,3.38,0,0,1-2.42-1.06c.14-.72-.65-1.72-1.1-2.64-.3-.38,0-.92-.45-1.17-.45-.9-.07-1.88-.82-2.67.15-.76-.73-2-.57-2.61.84.61,1.44,3,1.77,4.23.91,1.33.87,3.36,1.62,4.43a7.44,7.44,0,0,0,3.9-.11c.38.08.2-.62.52-.67s.47-.92-.09-1.39c-.53-.26-.38-1.11-.65-1.46-.41.42-.78.4-1.4.17a3.56,3.56,0,0,1,0-.87c-.19-.15-.37.15-.47-.18,0-.78-.58-1.49-.67-2.31.91.21.86,1.48,1.62,2.2.56.78,1.09.47,1.38,1.47,1,1.3,2.57.89,3.12,2.48.09.25.87,1,.54,1.16.25.82.85,1.56,1,.67.29,1.41,1,8.78,2.3,6.4-.06-2.19.81-2.49,2-3.1.15-.5.45-.4.91-.17s.3-.7.57.07.53,1.52.79,2.45c-.23.86.29,1.18.73.78a1.62,1.62,0,0,0,.3.76c0,.39-.22.57.08,1,.24.15-.08.18.06.3s.15.32,0,.25c.15.51-.07.91,0,1.6.67,1,.54,2.11,1.09,3.25-.66-.32-.91-1.84-1.62-2.28-1.14-.84.78,1.84.72,2.49.6,1.29,1,2.85,2,3.83.05.77.49,1,1,1.44.41-.12.8.93,1.27,1.11a2.49,2.49,0,0,1,1.21.92c.19-.54-.58-.8-.78-1.26-.32-.83-2-1.29-2.47-2.25.46-2.15-.7-1.23-1.09-3.73.9,1.29.23-.17.27-.76a1.3,1.3,0,0,0-.36-1c-.53-1.22-1.16-2.33-.73-3.4.18-.29.46.72.82.78l.11.52c1.06,2,.4,1.35,1.79,1.14,1.41-1-2.23-4.45-.08-4.62.64.5.24.32.5.76a2,2,0,0,1,2.06.1c.16-.2.33-.38.63-.11,0-.48.39-.58.41-1.09.42,0,.57-.39.69-.9-.4-.41-.45-.5,0-.42v-.12c-.35-.34-.69-1-.09-.42-.88-2.18-.91-1.94.18-2.57-.66-.89-.86.09-1-.62,0-.39-.43-.18-.46-.65-.1-.76.56.14.62-.51.14.29.2.1.29.08,1-.41-.12,1,1.19.85V164c.64.57-.5,1,.73,1.4.08.34-.24.36,0,.74-.37,1.93,1.93.8.57-.67-.16-.62-.29-.87.18-.87s.29-.73.65-.84l.09,0v-.24c1,.73,1.27.48,1.87-.26.82-.51,1.06-1.49,1.23-2.83,0-.53-.38-1.64-.79-1.27-.8-.21-1.39-2-.31-1.54,0-.18.12,0,.19,0,.55-1,1.77-1.42,2.91-.14.59-.29,1.3.89,1.87,1.1s.29-.59.69-.52c.72-.55,1.21-.39,1.82.85.4-.1.61-.84,1.11-.45,0,.29-.22,1.34-.74.9-1,1.37-3.11.53-1.62,4.56.38-.33.56-.87.93-1.18.61.24.4-.51.76-.74,0-1.65-.6-.61.11-1.84.44-.25,1.06.11,1.64.38a2,2,0,0,0,1.93.19c.43.24.78-.27,1.18.22.18.25.28.13.35,0-.11-.72-1.4-2.38-.36-1.44.78,1.06.68-1.17,1.1-.24,0,.32,0,.33.24.46.47.17,1,1.16,1.21,1.67l.28.16C463.77,160.16,464.71,161.45,464.41,160.6Zm-47.35-2.37a.26.26,0,0,1-.09-.17A.26.26,0,0,0,417.06,158.23Zm-.91-5.51h0Zm2.1-4.62c-.8.32-1.63-1.14-2.51-1.59-.63-.21-1.23.07-1.77-1l.09.17c0-.1,0-.2-.09-.29-.29-.54.23-.32.18-.75.42-.49.64-1.53,1.45-.37.5.37-.16.17,0,.48s.12.32.14.48l.18.1a.25.25,0,0,1,.37,0c-.5-1.28.63-.53,1.09-.71-.09.9-.82,1.1.37,2.28v.24A1.2,1.2,0,0,1,418.25,148.1Zm4.08,2.84c-.26,0-.86-.63-.36.36.82,2.34-.8,1.41-1.44-.19.18-.4.47-1.26-.18-1.68-.3-1.18-.69-2.17.18-2.33s2.14,1.19.74,1.22c-.33.39.38,1.08.56,1.84l.07-.08C422.07,150,422.55,151,422.33,150.94Zm6.34-12.39c-.9-.82-.17-.88-.15-1.54C428.34,137.55,429.39,138.93,428.67,138.55Zm-22.53,3.55c.24.22.38-.13.57-.13C406.32,141.23,405.43,141.8,406.14,142.1Zm46.78,57.06c.12-1.36-.78-2.43-1.22-3.72-.19-1-1.27-1.61-1.07-2.63-.38-.44,0-1.23-.65-1.49-.05,0-.14-.25-.17-.38s-.17-1.62-.41-1.15c-.06.16,0,.57-.23.35v.24c.4.85-.27,2.59-.73,1-.77-.6-1.35-1.58-.92-2.4-.43-.66-1.9-1.68-2-.22-.52.17-1.16-1.85-1.77-.21-.08.52-.4-.32-.51-.06-.08,1.55-1.8.22-2.53.64-.84.9.47,3.49.43,5.15-.53,2.33,4.48.8,5.2,2.58.62.16.68,1,1,1.68.2.52.45-.37.67-.24s.06.26.08.39c.11.36.29.91.46,1.38.49.34,0,1,.63,1.28a4.17,4.17,0,0,0,2.57,1.28c.42-.26.12-1.78.77-1.89.44.06.1-1.34.5-1.13v-.25A.18.18,0,0,1,452.92,199.16Zm-51.78-74.3c.22-.36-.54-1.35-.83-1.59-.18.14-.41.09-.72-.19-.19-.11-.29.07-.46-.22-.16,1.07-.44-.78-.91-.41C398.64,125,399.85,125.37,401.14,124.86Zm19.33,48.25c-.07.38-.46.32-.51.75-1.83,0-.76.45-1.18,2.07-.62.67.55,3.22,1.2,2.36a17.39,17.39,0,0,1,.9-3.3C420.9,174.48,421,173.42,420.47,173.11Zm-22.53-53.77c-.27-.31-.59-.39-.84-.68.18-.1.55-1,.63,0,.07.06.18,0,.19.23.7.79.74.23.45-.59-.24-.05-.64-.74-.47-.87.14.09.29.09.43.33.31.33,0-.71-.17-.54-.21-.06-.45.12-.58-.25s.42-.73.72-.05c.24.44.9.38.44-.11s.34-.16.53-.11a2.09,2.09,0,0,1-.17-.41c-.29,0-.38-.54-.12-.55s.4.39.4,0c.14-.57-1.31-1.18-.77-1.48.34-.16.83.48,1,.33,0-.18-1-.72-.49-.74.3.16-.05-.21,0-.22-.24-.24-.39-.08-.59-.11-.09-.72.09-1.15.59-1-.07-.56.31-.37.54-.46-.12-.26-.39-.18-.55-.29-.24-.74.71.24.91,0a1.3,1.3,0,0,1-.42-.37,4.25,4.25,0,0,1,1.71.35c.24-.55-.33-.57-.54-1l-.46-.26c-.18.13-1.1.27-1.19-.44l-.18-.11c.07.47-.32-.12-.41.22s-.77.19-.56-.18c.14-.16.59-.15.37-.64-.4-.52-.9.13-1.37-.17-.38-.51.35-.1.42-.32-.78-.71.8-.08,1.1.1-.32-2-7.74-6.1-8.09-4.62-.29-.44-1.68-1.52-.86-.23-.64-.45-1.25-1.27-1.91-1.42s-1,0-1.53-.4c-.25-.09,0,.48,0,.68-.49-.63-2.41-.8-1.68.28,1.47,1.22-1.47.2-1.84.27-.57.39.74,1,.68,1.46-.65.08.17.49.21.84.33,1.33,1.57.92,2.22,1.68a6.63,6.63,0,0,1,2.31,4.23c-.53,1.09.58.7.75,1.68,0,.31-.66-.5-.38.18-.63,0-.16.69.24,1.19.28.32,0-.68.32,0,0,.12.1.11.12,0,.38-.91.56,1-.38.41.05.35-.21.33-.25.57s.3.59.1.77c-.19.43.61,1,.43,1.61.57,1.87,1.5,3.88,2.87,4.64.54-.9.59-3.45,1.9-2.78,1.14,1,1-1.29,2-.56.24-.12.84.25,1.18.44C397.1,119.65,398.46,120,397.94,119.34Zm-14.63,20c.9-.83-.66-2.31-1.51-2.66h0a14.86,14.86,0,0,1-1.6-1.81c-.18.14-.42-.22-.61-.15.06.24.17.54.37.62.66.27,1,1.66,1.67,1.83h0C382.39,137.42,383.53,138.1,383.31,139.35Zm60.19,37.22c-.21-.59-.7-.3-.34.13.4.25-.2.47.35.89-.31.07-.33.85,0,.54.27.3.35,1.26.76,1.32.05-.18-.11-.62.16-.46.4.31.12-.79.07-1.15-.35-.29-.36.18-.68-.18s.09-.51.33-.32c.09-.43.43-.21-.14-.73.21.08.21,0,0-.23-.15-.38-.16-.8-.44-.59C443.61,176,443.93,177.16,443.5,176.57Zm-1.4,4.87c-.25.38.31.87.23,1.29,0,.15-.06.4.11.48.32-.25.06-1.27.54-.05.45.26.35-.51.24-.9-.3-.68.61,0,.18-.8-.3-1.83-.39.19-.67-1.11C442.27,180.39,442.31,181,442.1,181.44Zm9.26,22.89c.06-.49-.48-.44-.65-.56C449.18,202.51,451.38,207.34,451.36,204.33Zm-8.93-30.42c-.19.34.23,1.22.27,1.69.46.82.45-1.45.54-1.78.12-.53-.79-1.19-.64-.46C442.57,173.58,442.71,174,442.43,173.91ZM380.09,113.3c-.39-.85-1.17-1.34-1.41-2.16-.51-.17-.33.94-.63,1.17.34.22.68,1,1,.67C379.23,112.59,380.22,114.3,380.09,113.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,97.63c0,.32-.42.28-.07.66a2.23,2.23,0,0,1-.35-.17c.1.62.73.74,1,.8-.07.49-.12.52.39,1a5.44,5.44,0,0,1,2.24.56c.37-1.28-.92-.48-.82-1.93-.25-.19-.61-.31-.55.17.17.21.08.45.25.73-.18-.11-.44-.12-.43-.47-.09-.1-.23,0-.27-.28-.23-.31-.83-.6-.82-1C369.25,97.42,369.21,97.81,369,97.63Zm25.48,57.64c-.36-.39-1.13-.82-1.09-1.61-.07-.06-.18,0-.18-.22-.53-.64-1.09-.46-1.55-1.22-.53-1.08-1.14-1.29-1.79-1.94-.33-.26.14-.47-.1-.8a7.93,7.93,0,0,0-.92-2c-.2.11,0-.27-.25-.29-.15.22-.18-.59-.41-.25-.7.13-1-1.59-1.64-2-.35-.36-.22-.69-.51-1.12-.59-.65-1.13-.37-1.74-1.11-.47-.1-.32-1.11-1.22-1-.35.13-.19-.17-.31-.44-.78-.17-1.14-.06-1.51.61-.36-.42-.74-1.24-1.18-1-2-1,.3-3.82-2.47-4.27,0-.14.22-.14.06-.3-.57-.9.5-.46.31-1.28.38-.47-.15-.94-.66-1s-.28,1.14-.86.73c-1.75-.18-2.25-4.58-1.16-5.07.57-.52,1.17.27,1.87.74.42-.53.34-.15,1.07.14.28.08.29.77.54.62.77.24.61,1.88,1.09,2.65,1.1.72-.49-2.62.12-2.92.37-.54,1.56-.35,1.58-1.12-.1-.16.06-.29-.15-.46a1.26,1.26,0,0,1-.06-.82c.17.06.07.44.25.53.2-.1.08-.59.24-.54.36-.3.29-.55,1-.36-.11-.17-.25-.17-.36-.34,1.51.69-.13-1.19,2.09-.75.42,0,.27.12.06.35-.17.63.59.79.75.44.47.22,1.14.28,1.38-.11-.37-.47,0-.54-.59-.64-.05.17,0,.57-.23.35-.09.11-.18.06-.27-.16-.7-.3-.37-1.13-.8-1.46.07-.11.22,0,.34,0,.12-1.35-1-.59-1.46-1.18.78-.66,2,.47,3.1.79.11-.27.43-.2.64.09-.07.53-1.2,1.2-.35,1.77.58-.27,2.05,2.46,1.62.46-.38-1.27-.38-.46-.93-1.47.18-1.94.45-1-.46-3a6.11,6.11,0,0,1-1.24-1.66c.05-.56-.9-3.76-1.19-2.76s-1.31.19-1.28-.88c0-.32.1-.56-.22-.78-.61-.32-.82-1.76-1.45-1.71-.36-.06-.92-1-1.15-.49,0,.26.18.68,0,.87.07.24.42.73.18.79-.52.37.2.94.27,1.5.51,2-1.33.14-.64,2.43.39.72-.61,1-.64.11-.21,0-.19-.27-.18-.47-.43-.31-.23-1.15-.27-1.61-.29-.25-.79-.24-.92-.77-.25-.31-.6-.43-.72-.91-.46-.37-.93-1.27-1.41-1.21-.23.06-.12-.49-.15-.66a.68.68,0,0,1-.18-.59c-.45-.11-.75-.79-.45-1.12,0-.21-.08-.55.18-.5.07-.27.15-.59.45-.46-.14-.76.5,0,.5-.45-.32-.17-.49-.64-.76-.87.32,0,.75.79,1,.45.07-.09.14-.15.29.1a.34.34,0,0,0,.49,0c.26-.43-.94-1-.64-1.29,1.8,2.15.21-.93,1.66.83.07-.31.29-.06.45,0,0-.18.12,0,.19,0,0-.17.13-.19.27-.09.18-.38-.61-1.29,0-1.09v-.49c-.34-.07-.37-.7-.72-.82.22-.08.55.29.81.39.08-.11.42,0,.46.26.68,0,.39,0,1,1,.22.34-.3.19,0,.59,0,.41.18.8.52.72-.58-1.46,1.44,1.25.45,1.09-.37-.27-.24.36-.27.66-.29.24-1.4-1-1.27,0,.33.81,1.07.6,1.48.93s.29,1.13.76,1.46c.49.11,1.39,2.26,1.58,1.39a2.78,2.78,0,0,1-.36-.76c.27.2.51.2.77.38.22-.61-.4-1.37-.81-1.93-.36-2.31.94,1.07,1.18.68.22-.14.42-.49.77-.4a6.91,6.91,0,0,0-1.12-1.73c-.47-.49-1.18-.9-.61-1.27-.37-.27-.14-.26-.2-.61a10.16,10.16,0,0,0-1.64-2.21c-.62-.28-1.16-1.94-1.76-2.36-.49.12-.93-1.14-1.5-1.23-.27-.19-.79.24-.78-.45-1.94-1.27-2,1.41-.32,2.73.24.18.52.19.72.49-.16-.07-.32-.18-.45-.09v.24c.28.3.24.69-.09.44,0,.21,0,.51-.15.49l0-.23c-.36-.3,0,.35-.12.51-.11,0-.56-.77-.34-.77s-.07-.63-.16-.82a.43.43,0,0,0-.5-.3c-.36-.56-.33-1.22-.77-1.66-.87-2.41.15-.67.44-1.6.57-.52-.9-1.45-1.25-1.37-.36.33.16,1.51-.2,1.7s-.27.73-.22,1.21-.52-.44-.61-.16c-.05.49-.53.13,0,.76-.09,1-1.84-.36-2.3-1.3.46.53,1.88.85.91-.16,1.68.63-.67-1-.57-1.86-.45-.79.35-1.46-.28-1.86-.33-.33-.35,0-.6,0-.52-.29,0,.9-.16,1.13-.19-.55-.3-1.26-.81-1.42,0,0-.09.47-.24.13s-.3-.23-.42-.51-.31.52-.56-.07c.33.09.1-.28.07-.48-.58-.29-1.45-.42-1.46.5.22-.05.24.41.41.49,0,.13-.07.13-.14.15.36.9,1.44.64,1.82,1.56-.46,0-1.12-.66-1.64-.72v.24c1.12,1.22,1.68,2,3,2.44.91,1.4-.2-.33.14,1.29-.16.42-.44-1.2-1-1.1-.46-.17-1.79-.64-1.11-1.22-.88-.79-1.86-1.79-2.78-2.46.08.44-.64,0-.37-.21v-.12c-.3-.18-.57.47-.72-.42-.09-.18-.33-.82-.46-.64.06.51-.86.36-.82-.1-.56,0-1.13-.45-1.64-.46l.17.41c-.62-.13-1.09-1.29-1.72-1.55,0-.32-.34-.13-.37-.45A28.44,28.44,0,0,1,358,95.91c-.36.14-1.29-.86-1.56-1.34-.46-.39-.78,0-1.27-.42,0,.6-.53-.14-.71.12s-.49.79-1,.34c-.82-.51.53,1.25.7,1.62.42.14.49.55.74,1-.51,0-.87-.42-1.22-.89-.31.18-.7,0-1,0,.27.48.43.48.54,1,.45.72,1.27.57,1.64.92.09,1.23-.29.34-.59.78-.28-.11-.42-.53-.59-.17s-.65.44-.19,1.09c-.19.18.14.39.22.57.07.74.8.58.84,1-.26,1,.52.29.78,1,.14.31.2-.08.32-.11l0,.12c.66.27.11.87.1,1.22.57.39,1-.08,1.45-.3-.27-.49-.26-.73.19-.4-.09-.33.37-.72.45-.33s0,.69-.25.65c.44.75.7-.14,1.21.37.28.22,0-.55.19-.61s.3.44.34.63a7.25,7.25,0,0,1,1.84,1.47c1.15.63,1.42,2.76,2.34,3.31.26.28-.12.2,0,.41,0,.38.16.92.51.7.19-.08.58.7.49,1,.07.41.48.79.72,1.13s-.07.43.1.75-.25.35.05.63a4.8,4.8,0,0,1,1.15,2.94,9.24,9.24,0,0,0,1.77,7,7.86,7.86,0,0,1,.77,2.2c0,.45,1,1.44.28,1.26.22.61.93.84.81,1.55,0,.16.12.24.18.35,1.59,2.84-.06-1.1-.45-2.19.16-.06,0-.3,0-.32-1.1-1.48.31-1.39.33.51.74,1.31,2.48,4.05,2.17,5.3,1.08,2.11,2.74,3,4,4.39a2.74,2.74,0,0,0,1.46,1.57c.48.58.52,1.54.8,2.05a14.3,14.3,0,0,1,1.08,1.34c.75,1.38.34-.19.91.06.16.35.09.56.24.93l.17.14c.76,2.16-1.53,1.76-.86,3.62.36.47-.28,0-.15.42-.56.39.5,1.56.63,2.3a13.15,13.15,0,0,0,2.66,5.67,7.88,7.88,0,0,1,0,2.39c-.45,1.77-.16,4.11-.94,5.56-.29-.06,0,.82,0,1.15s-.54,1.5-.22,1.91c.33.24,0-.75.29-.67.28.68-.27,1-.06,1.72-.15.06-.9-.24-.56.5.07.15.36.31.12.45-.07.07.17.37,0,.32-.23-.24-.47,0-.17.27.07,0,.21.07.08.2-.38.19.23.57.13.87a.31.31,0,0,0,.07.55l0,.2a.79.79,0,0,1,.34.34c-.09.07-.22,0-.18.27.2,0,.9.17.46.32.59.55-.12.17.09,1.09.1.23.36.22.39.56.1.17.19-.07.28.17s.2.15.35.3.11.3.21.27c.05-.67.06-.5.41-.65-.61.16-1-2.68-.41-2.5.41-.91,1.25-.35.23-1.95,0-.29.2-.33.36-.31.49,0,.26-.92.82-.8.09-.36-.47-.41-.36-.76,0-.88,1,1.07.82-.67,1.06.32,2.3.74,1.37-1.54.09.1.23,0,.27.28,1,.79,1.09.28,1.55-.2-.05-.38.17-.46.29-.63s.08.35.26.34c0-.08,0-.26.09-.19-.07-.81.72-.48.55-1.39-.32-.55.37-.95.73-.79,1.32-.32,1,.81,2.09-.61,0-.25-.12-1,.19-.87,0-.13-.06-.7.09-.68-.48-1.67.56-1.77,1.18-2.23,0-.35-.07-.82.09-1A1.2,1.2,0,0,1,394.45,155.27Zm-17.95-34c.94-.32,1.7-.61,2.27,1.44.26.89,1.33.75,1.45,1.87-.9-.28-.23,0-.72.56-.24-.2.06-.57-.28-.64s.18-.58-.2-.86c-1.07-1-.48,1.4-1.07,1.21a2.32,2.32,0,0,1,.06-2.06c0-.33-.51-1.06-.77-.9S376.52,121.51,376.5,121.24ZM362.66,107a.33.33,0,0,1,0-.06h.05l0,.06Zm5.88-1.86c-.16.11-.28.33-.55.09s-.39.64-.63,0c-.13-.44-.19.19-.39-.09-.49-.17,0-.77.21-.66a1.59,1.59,0,0,0-.26-.41c.35,0,.85-.18,1.06.59C368.08,105,368.58,104.66,368.54,105.12Zm3.52.5,0-.09,0,0C372.08,105.56,372.11,105.61,372.06,105.62Zm-4.92-8.8c.18.2.46-.06.41.36.21.2.28-.21.51,0,.34-1.42.28,1.21,1-.42-.38-.48-.66-.34-1.09-.69C367.93,96.61,366.34,96.08,367.14,96.82Zm6.61,3.09c-.36,1.32.11.48.37,1.55a.93.93,0,0,0,.45.38c0-.13,0-.23.09-.25-.22-.42.14-.53-.18-1C374.2,100.48,374,100,373.75,99.91Zm-9.12.25c-.09-.13-.18-.16-.27-.14C364.44,100.17,364.53,100.14,364.63,100.16Zm1.57-.59c.36.33.34,1,.89,1.12s.58-.72,1.21-.65c.22,0,1.15.14.62-.42-.07-.14-.25-.21-.18-.42-.2-.06-.44-.37-.6-.22-.5-.5-1.59-1.63-1.87-1.08.33.29,0,1-.18,1,0,.22,0,.26-.18.14A.53.53,0,0,0,366.2,99.57Zm6.53-2.14c.25.21.28.45,0,.29-.83-.1.94.63,1,1,1.5,1.27-.19-1.09-.55-1.53l-.82-.47a.89.89,0,0,0,.09.54C372.5,97.31,372.61,97.19,372.73,97.43Zm61.18,34.68c.75.58,2.22,3.09,2.44,1.52.29-.66-.87-.71-.74-1.38C435.63,130.62,433.54,131,433.91,132.11Zm2.14,2.75c.57.31,1.7,1.06,2,.52C437.41,133.81,436.32,133.68,436.05,134.86Zm12.26,9.92.5.29v0c.45.09,2,1.27,1.63.06-.6-.88-1.27-.81-1.79-1.51S447.49,144.26,448.31,144.78Zm-73.65-42.16c-.23-.07-1.66-.52-.88.23.24.68-.66-.55-.67,0s.78,1,1,1.69c.52,1.25,1.67-.69.69-.84-.61-.43.38-.16.08-.61C374.77,102.91,374.6,102.83,374.66,102.62Zm46.78,28.84c-.07.33.35.47.28.76.17.17.31-.18.39.32s1.67,1.56,1,.48c-1-1.63.91-2.29,1.73-2.17a2,2,0,0,1,1.64.22c.08-.23.27-.17.46-.1,0-.4-.06-.58-.37-.7-.23.09-.69-.11-1-.21-1.71-.51-2.47-.63-3.41.93-.18-.08-.22,0-.25.26C421.87,131.65,421.36,131,421.44,131.46Zm-46.11-33c.08.3.34.29.48.46.15,1,1.46,2.18,1.92,1.71.34.59-.24.58,0,1,.08.23,0,.2-.07.15-.41-.15-.53.47-1-.21-.49,0-.93-1-1.49-1.12l-.09.19c.53,1,1.51,1.11,1.46,2.54.11.11.34.09.36.33.4.28.74.16,1.1.76.31.11.69.54,1,.7,0-.56.81.17,1,.45l.18.11c.78-.77-.7-1.51-1.27-1.83-.43-.07-1.88-.7-1.48-1.46.71.39,1.28,1.11,1.94,1.12.58.59.94.9,1.55.88.3-.24-.19-.56-.37-.75.16-.79,2,.56,1.38-1.14,1-.13,2.62.22,3.23-.51.74.16,1.74.36.49-.74-1.21-1.44-2.82-2-4.2-2.86-.41,0-.84-.41-1.23-.48a2.58,2.58,0,0,1-1.68-.59c.07.31-.15.12-.26.15.06.45-.28.13-.37-.16-.25-.31-.51.37-.64-.12-.21,0-.45-.19-.64-.13.13.34.27,0,.45.32l-.09.13c.4.13-.08.4.29.55.06,0,.14.21.2.33.22.6.86.15.79.57,0,.22.19.19.21.36a8.16,8.16,0,0,0,2.15.73c0,.9-1.86-.93-.74.8-.46-.17-1.49-2.15-1.7-1.16.1.56.71.56.62,1.13-.28-.64-.83-.57-.89-1.38,0-.22,0-.47-.24-.33a5.69,5.69,0,0,1-.87-1.21c-.27-.1-.43-.57-.64-.86s-.54-.16-.57.13c-.39-.09-.26.45-.42.64C374.8,97.6,375.34,98.22,375.33,98.48Zm33.61,19.59c-.09.75.48,1,.83,1.85-.32.44.45.63.55,1.15.57,1,.72-1.38,1.36-.8a2,2,0,0,0,.36.7c-.15.14,0,.25.1.37.45.72.44.35.82.38a6.86,6.86,0,0,1-1.07-2c.75.37,1.6,1.09,2,.23a4.66,4.66,0,0,0-1.54-1.15c-.11.39-.59-.64-.82-.61-.1.32-.51-.33-.61.07-.11.23-.39-.12-.49-.34-.18.25,0,.58,0,.88-.5-.67-.14-.29-.21-.7-.09.09-.13,0-.12-.14-.19-.19-.06.5-.27.07C410,117.59,408.18,117.06,408.94,118.07ZM402.54,134c.89.15,1.34,0,.7-1.56-.06.22-.28-.43-.31,0-.19.21-.79-.66-.63.13C402.76,133.43,401.59,133.11,402.54,134Zm1-2.76a.86.86,0,0,0,.07.1c-.13.12-.13.83.06.93.38.14.05.62.38.72.28-.13.35.34.38.67s-.52-.13-.39.43c.13.41-.34.07-.21.46.63.38,0,.4.09.78.24.21.55.48.79.35s.95.72,1.18.2l-.16-.13c.35-.17.48-.59-.09-.92-.15-.37-.18-.67-.3-1s-.36-.44-.27-.73c-.13-.17-.28-.52-.48-.62.65-1.09.08-.46-.16-1.53,0-.27-.25,0-.37-.29s-.25-.1-.25,0C403.84,131,403.25,130.78,403.5,131.19Zm56.93,76.72c-.31.08-.28-.33-.49-.68-.39.22-.62.77-.13,1.55-.27.87.53.87.56,0C460.4,208.47,461.19,208.35,460.43,207.91ZM446,183.55c.35.17.13.63.36,1,.44.82,1.49,1,1.83,2-.36,1.23.07.94.91,1.7.35,1.21.87-.17,1.3.48.91,1.65,1.9,2.64.7.06.22-1.16-2.07-3-2.91-4.09-.36-.46-.83.59-1.12-.23,0-1.12-.84-1.8-1.25-1.19C445.86,183.38,445.93,183.54,446,183.55Zm13.26,25c-.62-.57-.51.18-.83.4-.35.44-1.07,0-1.27.7-.17.36.31.78.27,1.22.16.2.23-.12.41,0C458.19,211,460.32,209.28,459.24,208.6Zm-10.62-41.45c0,.33-.55.93-.65.36a.12.12,0,0,0-.17-.11c-.13.14-.16.93-.48.43-.46-.32-2-.48-1.23.64.29-.07.6.25.88.39,0-.22.06-.14.14,0,.12-.07-.09-.32-.13-.48.38-.13.17.6.53.6a1.88,1.88,0,0,1,1.27.13C449.53,169.18,449.59,164.3,448.62,167.15Zm.33-1.1c.21.08.29-.2,0-.4.37-.08.66.77,1,.5s.73.21.72-.42c-.72-.35-.73-.68-1.22-1.44-.23,0,0,.79-.28.89A.51.51,0,0,0,449,166.05Zm.76-6.36-.09-.05c-.41.84.17,3.06-.18,3.91-.06.36.14.44.34.4s-.41-1-.07-1c0-.09,0-.26.1-.19.06-.43.6.24.27-.82a3.78,3.78,0,0,1-.18-1.56A1.11,1.11,0,0,1,449.71,159.69ZM442.07,178c-.89-1.19-.69-.45-1.34-.29-.55-.11-.87.84-1.59.29l0-.12c-.42.61.38,2.68,1.07,3,1.05.95,1,.68,1.44-.23.62-1.37.69.46.07-1.93C441.82,178.54,442.59,178.62,442.07,178Zm-33.61-36.25c.05-.59-.5-.37-.51-.17.33.48-.24,1.11.14,1.63C408.8,143.64,408.46,142.34,408.46,141.78Zm1,3.54c0,.31.67.28.51,0C409.62,144.45,409.59,144.84,409.49,145.32Zm54.92,15.28c-.55-1.35-1.19-.49-1.37-1.25.06-.78-.87-1.12-.92-1.74a1.92,1.92,0,0,1-.92-1.13c-.55-.27-.91-1.08-1.5-1.23-.31-.27-1-.86-1.32-.71-.31-.08-.54-.89-.91-.58-.18.69-1.77-1.39-1.87-.48,0-.54-.41-.56-.5-.93-.26-2-2-1.14-2.65-2.58-.22-.05-.39-.35-.52-.53-.41-.23-.09-.31-.12-.57-1-.91-.86.66-1.46-.91-.08-.45-.63-.46-.88-.85s-.44.06-.76-.28c.09.12-.26.08,0,.28.52,1-.89.44-1.12-.18-.4-.23-.61.1-1-.57-.3-.3-.17.5-.48.32-1.28-.66-.37-2-1.16-2.73-1.56-1.27-.66-.67-1.77-.54a5.77,5.77,0,0,1-1.6-1.66l-.55-.31c-.06.21-.24-.07-.36-.09-.29.14-.19-.15-.35-.44-.25.29-.56-.45-1-.61,1.51-.38,1.51-1.67-.58-2.55-.43,0-.36-.49-.67-.71s-.22-.67-.41-.95c-.84-.68-.93.56-1.52.24.11.4-.15.08-.35,0-.43.06-.85-.72-1.23-.52-3.4-1.11-.65,1.78-3.47-.13-.08.22-.45-.24-.29.36-.1.35.11.4.38.72.53,1.87-1.72-2-1.4-.39-.2-.29-.52-.34-.25.12.15.19.46.4.46.66-1-.81-1.08-.28-.91-1.78-.3.11-.13.82-.69.35-.26,0,.19.36,0,.69-.14-.18-.41-.23-.35-.56-.22-.32,0-.33,0-.57.36-.81-1.14-1.67-1.18-.68.12.56-.62.2-.41.6s-.17.55-.05,1c.81.36.48,2.19,0,.48-.6-.48-1.16-1.69-1.77-1.85-.34.23-.9-1.34-1-.6.37.47,1.11,1.42.36,1.4,0-.35-.27-.59-.45-.58-.31.31-.77-.49-1.07-.21s-.3-.73-.59-.64c-.85-.65-2.09.83-2.35-.27-.56-.77.61.09.22-.85l-.73-.42c.15.45-.14.66.11,1.12a.35.35,0,0,1,0,.43c-.26.19-.6-.68-.87-.33-.84-.27-.16,1.65-1.33,0-.75-.49.1.58.05.75-1.07-.24-.63-1.87-1.42-2.68.69.49,2.66,2.7,2.53.93-.6-1.38-2.1-2.18-2.73-3.27l-.19-.1c0,.21-.18,0-.27,0a.63.63,0,0,0-.27-.34.57.57,0,0,1,.36-.09c-.18-.52-1-1.42-1.24-1.07,0,0-.06.14-.14-.09-.6-1-1.45-.16-2-.33a.57.57,0,0,0-.41-.6c.12.57-1.13-.18-.36.59-.11.48-.38-.07-.55-.39a1,1,0,0,1-.36.21c.59.85-.54,1.16-.66,1.65s-.31.2-.43.39.18.27,0,.18c-1.21.26-2.61.73-1.38,3.24,1.7,1.13,1.14-1.51,2.08,3,.22.1.35,0,.44-.18.24,0,.81.49.7-.19-.32-1.19,1.26-1,.11-2.42-.17-1.63,1.37-.79,1.36-2.13,1.28-.23,1.43,1.51.19,1.2-.66.87-.06.74-.37,1.85.8,1.32,1.94.5,2.55,1.88-.55.2-1.12-.46-1.73-.67-.3-.28-.57.46-.27.63s.32,0,.45.32c-.25,1.46-1-2-1.09.82,0,.29,0,.46-.26.39s-.3,0-.36-.07c-.51-.94-.94-.09-1.46-.7-.32-.7-.92-.1-1.2-1,.05-.12.16-.05.27,0-.46-.9.18-.35-.08-.88-.17-.26.15-.49-.08-.84-1.65,0,.2,2.11-1,2-.69-.52-1,.28-1.27.72-.54-.52-.32.33-.6.26-.44-.08-.46.19-.93-.38,0,.18.19.73-.07.53s-1.21-1-.77,0a2.45,2.45,0,0,1,.91,2.72c-2.55-1.28-2.12-2.37-2.46,1,.38.14,0,.79.46,1s.55.9,1.09,1c.55-.35.58.64,1.37-.31,0-.18-.13-.91.18-.62,0-.09-.05-.26.09-.19,0-.45.27-.2.55-.05-.06-.42.4.09.27-.45,0-1.12.77.52,1.07.22.81-.3.91-.15,1.4,1.26.7,1.05,1.7,2.07,1.12,3a.56.56,0,0,0,.67-.31c.09-.12-.22-.7.06-.56.82.75-.43-1-.62-1.24-.37-.36-1.41-2.69-.51-2.15.28.73.74,1.94,1.37,2.13a.78.78,0,0,0,.33.7,4.09,4.09,0,0,0,.12,1.26c.37.23.2.71.64.91-.41-.08,0,.88.27,1.07.06-.25.62-.4.36-.82-.09-.14-.35-.22-.19-.34s-.23-.48-.22-.66c.4.43.55-.15,1.06.22,0,.11,0,.22.12.32s-.32,0-.08.29c.32.44,0,1.14.52,1.66.52,1.12.88.4,1.35,1.09.3.7,1.1,0,1.19.74-.25.47-.17,1.57-.46,2a26.12,26.12,0,0,1-2.91-1.81c-2.18-3.1-1.21.31-2-.67-.62-.66-1-1.37-1.61-2a.81.81,0,0,1-.6-.53c.08-.23-.78-.66-.19-.54.42-.15-.14-.92.18-1l-.09-.18c-.15,0-.21-.16-.18-.34l-.37-.21c-.09.22-.63-.32-.82-.36-.42,0-1.21-.56-1.73-.75-.55.88-1.72-.87-2.28-.54a1.82,1.82,0,0,1-1.19.72v.73c.35.64-.63.37-.63.85l-.37-.21c-.69.94-1.54,1.73-.92,3.73.06.5-.6,1-.22,1.45,0,.17,0,.28.14.32-.21.16,0,.84.27,1,.9,2.31,2,4.88,3.83,5,.42.84,1.17.5,1.55.41.16.08.32.22.46.14.85.74.69,1.65,1.73,1.85.05.33.56.59.42.94s.23.63-.2.63c.28.19-.05.26.1.56-.71.24.72,2.2.87,2.93.7,2.13,0,3.12-.19,4.76.09,1.1.93,2.89.82,4.17.18,1.14.82,2.43,1,3.6-.21.26.07,1,.35,1.31,1.84,1.09,4,.9,4.16-1.76,1.57.54.12-2,.94-2.39.35-.58,1.46.1,1.49-.93.14-1.4-.45-2.92-.52-4.2.65-2.38,4.1-1.78,3.76-5.25a3.38,3.38,0,0,1-2.42-1.06c.14-.72-.65-1.72-1.1-2.64-.3-.38,0-.92-.45-1.17-.45-.9-.07-1.88-.82-2.67.15-.76-.73-2-.57-2.61.84.61,1.44,3,1.77,4.23.91,1.33.87,3.36,1.62,4.43a7.44,7.44,0,0,0,3.9-.11c.38.08.2-.62.52-.67s.47-.92-.09-1.39c-.53-.26-.38-1.11-.65-1.46-.41.42-.78.4-1.4.17a3.56,3.56,0,0,1,0-.87c-.19-.15-.37.15-.47-.18,0-.78-.58-1.49-.67-2.31.91.21.86,1.48,1.62,2.2.56.78,1.09.47,1.38,1.47,1,1.3,2.57.89,3.12,2.48.09.25.87,1,.54,1.16.25.82.85,1.56,1,.67.29,1.41,1,8.78,2.3,6.4-.06-2.19.81-2.49,2-3.1.15-.5.45-.4.91-.17s.3-.7.57.07.53,1.52.79,2.45c-.23.86.29,1.18.73.78a1.62,1.62,0,0,0,.3.76c0,.39-.22.57.08,1,.24.15-.08.18.06.3s.15.32,0,.25c.15.51-.07.91,0,1.6.67,1,.54,2.11,1.09,3.25-.66-.32-.91-1.84-1.62-2.28-1.14-.84.78,1.84.72,2.49.6,1.29,1,2.85,2,3.83.05.77.49,1,1,1.44.41-.12.8.93,1.27,1.11a2.49,2.49,0,0,1,1.21.92c.19-.54-.58-.8-.78-1.26-.32-.83-2-1.29-2.47-2.25.46-2.15-.7-1.23-1.09-3.73.9,1.29.23-.17.27-.76a1.3,1.3,0,0,0-.36-1c-.53-1.22-1.16-2.33-.73-3.4.18-.29.46.72.82.78l.11.52c1.06,2,.4,1.35,1.79,1.14,1.41-1-2.23-4.45-.08-4.62.64.5.24.32.5.76a2,2,0,0,1,2.06.1c.16-.2.33-.38.63-.11,0-.48.39-.58.41-1.09.42,0,.57-.39.69-.9-.4-.41-.45-.5,0-.42v-.12c-.35-.34-.69-1-.09-.42-.88-2.18-.91-1.94.18-2.57-.66-.89-.86.09-1-.62,0-.39-.43-.18-.46-.65-.1-.76.56.14.62-.51.14.29.2.1.29.08,1-.41-.12,1,1.19.85V164c.64.57-.5,1,.73,1.4.08.34-.24.36,0,.74-.37,1.93,1.93.8.57-.67-.16-.62-.29-.87.18-.87s.29-.73.65-.84l.09,0v-.24c1,.73,1.27.48,1.87-.26.82-.51,1.06-1.49,1.23-2.83,0-.53-.38-1.64-.79-1.27-.8-.21-1.39-2-.31-1.54,0-.18.12,0,.19,0,.55-1,1.77-1.42,2.91-.14.59-.29,1.3.89,1.87,1.1s.29-.59.69-.52c.72-.55,1.21-.39,1.82.85.4-.1.61-.84,1.11-.45,0,.29-.22,1.34-.74.9-1,1.37-3.11.53-1.62,4.56.38-.33.56-.87.93-1.18.61.24.4-.51.76-.74,0-1.65-.6-.61.11-1.84.44-.25,1.06.11,1.64.38a2,2,0,0,0,1.93.19c.43.24.78-.27,1.18.22.18.25.28.13.35,0-.11-.72-1.4-2.38-.36-1.44.78,1.06.68-1.17,1.1-.24,0,.32,0,.33.24.46.47.17,1,1.16,1.21,1.67l.28.16C463.77,160.16,464.71,161.45,464.41,160.6Zm-47.35-2.37a.26.26,0,0,1-.09-.17A.26.26,0,0,0,417.06,158.23Zm-.91-5.51h0Zm2.1-4.62c-.8.32-1.63-1.14-2.51-1.59-.63-.21-1.23.07-1.77-1l.09.17c0-.1,0-.2-.09-.29-.29-.54.23-.32.18-.75.42-.49.64-1.53,1.45-.37.5.37-.16.17,0,.48s.12.32.14.48l.18.1a.25.25,0,0,1,.37,0c-.5-1.28.63-.53,1.09-.71-.09.9-.82,1.1.37,2.28v.24A1.2,1.2,0,0,1,418.25,148.1Zm4.08,2.84c-.26,0-.86-.63-.36.36.82,2.34-.8,1.41-1.44-.19.18-.4.47-1.26-.18-1.68-.3-1.18-.69-2.17.18-2.33s2.14,1.19.74,1.22c-.33.39.38,1.08.56,1.84l.07-.08C422.07,150,422.55,151,422.33,150.94Zm6.34-12.39c-.9-.82-.17-.88-.15-1.54C428.34,137.55,429.39,138.93,428.67,138.55Zm-22.53,3.55c.24.22.38-.13.57-.13C406.32,141.23,405.43,141.8,406.14,142.1Zm46.78,57.06c.12-1.36-.78-2.43-1.22-3.72-.19-1-1.27-1.61-1.07-2.63-.38-.44,0-1.23-.65-1.49-.05,0-.14-.25-.17-.38s-.17-1.62-.41-1.15c-.06.16,0,.57-.23.35v.24c.4.85-.27,2.59-.73,1-.77-.6-1.35-1.58-.92-2.4-.43-.66-1.9-1.68-2-.22-.52.17-1.16-1.85-1.77-.21-.08.52-.4-.32-.51-.06-.08,1.55-1.8.22-2.53.64-.84.9.47,3.49.43,5.15-.53,2.33,4.48.8,5.2,2.58.62.16.68,1,1,1.68.2.52.45-.37.67-.24s.06.26.08.39c.11.36.29.91.46,1.38.49.34,0,1,.63,1.28a4.17,4.17,0,0,0,2.57,1.28c.42-.26.12-1.78.77-1.89.44.06.1-1.34.5-1.13v-.25A.18.18,0,0,1,452.92,199.16Zm-51.78-74.3c.22-.36-.54-1.35-.83-1.59-.18.14-.41.09-.72-.19-.19-.11-.29.07-.46-.22-.16,1.07-.44-.78-.91-.41C398.64,125,399.85,125.37,401.14,124.86Zm19.33,48.25c-.07.38-.46.32-.51.75-1.83,0-.76.45-1.18,2.07-.62.67.55,3.22,1.2,2.36a17.39,17.39,0,0,1,.9-3.3C420.9,174.48,421,173.42,420.47,173.11Zm-22.53-53.77c-.27-.31-.59-.39-.84-.68.18-.1.55-1,.63,0,.07.06.18,0,.19.23.7.79.74.23.45-.59-.24-.05-.64-.74-.47-.87.14.09.29.09.43.33.31.33,0-.71-.17-.54-.21-.06-.45.12-.58-.25s.42-.73.72-.05c.24.44.9.38.44-.11s.34-.16.53-.11a2.09,2.09,0,0,1-.17-.41c-.29,0-.38-.54-.12-.55s.4.39.4,0c.14-.57-1.31-1.18-.77-1.48.34-.16.83.48,1,.33,0-.18-1-.72-.49-.74.3.16-.05-.21,0-.22-.24-.24-.39-.08-.59-.11-.09-.72.09-1.15.59-1-.07-.56.31-.37.54-.46-.12-.26-.39-.18-.55-.29-.24-.74.71.24.91,0a1.3,1.3,0,0,1-.42-.37,4.25,4.25,0,0,1,1.71.35c.24-.55-.33-.57-.54-1l-.46-.26c-.18.13-1.1.27-1.19-.44l-.18-.11c.07.47-.32-.12-.41.22s-.77.19-.56-.18c.14-.16.59-.15.37-.64-.4-.52-.9.13-1.37-.17-.38-.51.35-.1.42-.32-.78-.71.8-.08,1.1.1-.32-2-7.74-6.1-8.09-4.62-.29-.44-1.68-1.52-.86-.23-.64-.45-1.25-1.27-1.91-1.42s-1,0-1.53-.4c-.25-.09,0,.48,0,.68-.49-.63-2.41-.8-1.68.28,1.47,1.22-1.47.2-1.84.27-.57.39.74,1,.68,1.46-.65.08.17.49.21.84.33,1.33,1.57.92,2.22,1.68a6.63,6.63,0,0,1,2.31,4.23c-.53,1.09.58.7.75,1.68,0,.31-.66-.5-.38.18-.63,0-.16.69.24,1.19.28.32,0-.68.32,0,0,.12.1.11.12,0,.38-.91.56,1-.38.41.05.35-.21.33-.25.57s.3.59.1.77c-.19.43.61,1,.43,1.61.57,1.87,1.5,3.88,2.87,4.64.54-.9.59-3.45,1.9-2.78,1.14,1,1-1.29,2-.56.24-.12.84.25,1.18.44C397.1,119.65,398.46,120,397.94,119.34Zm-14.63,20c.9-.83-.66-2.31-1.51-2.66h0a14.86,14.86,0,0,1-1.6-1.81c-.18.14-.42-.22-.61-.15.06.24.17.54.37.62.66.27,1,1.66,1.67,1.83h0C382.39,137.42,383.53,138.1,383.31,139.35Zm60.19,37.22c-.21-.59-.7-.3-.34.13.4.25-.2.47.35.89-.31.07-.33.85,0,.54.27.3.35,1.26.76,1.32.05-.18-.11-.62.16-.46.4.31.12-.79.07-1.15-.35-.29-.36.18-.68-.18s.09-.51.33-.32c.09-.43.43-.21-.14-.73.21.08.21,0,0-.23-.15-.38-.16-.8-.44-.59C443.61,176,443.93,177.16,443.5,176.57Zm-1.4,4.87c-.25.38.31.87.23,1.29,0,.15-.06.4.11.48.32-.25.06-1.27.54-.05.45.26.35-.51.24-.9-.3-.68.61,0,.18-.8-.3-1.83-.39.19-.67-1.11C442.27,180.39,442.31,181,442.1,181.44Zm9.26,22.89c.06-.49-.48-.44-.65-.56C449.18,202.51,451.38,207.34,451.36,204.33Zm-8.93-30.42c-.19.34.23,1.22.27,1.69.46.82.45-1.45.54-1.78.12-.53-.79-1.19-.64-.46C442.57,173.58,442.71,174,442.43,173.91ZM380.09,113.3c-.39-.85-1.17-1.34-1.41-2.16-.51-.17-.33.94-.63,1.17.34.22.68,1,1,.67C379.23,112.59,380.22,114.3,380.09,113.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.72,225.46l-.37-.21-116-67V75.19l.37.22,116,67ZM350.86,158,466.22,224.6V142.66L350.86,76.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 115.52,
    width: 0.5,
    height: 133.79,
    transform: "translate(46.29 445.01) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 106.35,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 54.23, 440.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 97.18,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 62.17, 435.85)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 88.02,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 70.11, 431.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 78.85,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 78.05, 426.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 69.68,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 85.99, 422.09)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 60.51,
    width: 0.5,
    height: 133.79,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 93.93, 417.51)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 51.34,
    width: 0.5,
    height: 133.79,
    transform: "translate(101.87 412.93) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.98,
    y: 138.34,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.74,
    y: 134.16,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.5,
    y: 129.98,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.26,
    y: 125.79,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.02,
    y: 121.61,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.77,
    y: 117.43,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.53,
    y: 113.25,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 109.07,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.05,
    y: 104.89,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.81,
    y: 100.71,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.57,
    y: 96.53,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.32,
    y: 92.35,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.08,
    y: 88.17,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.84,
    y: 83.99,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.6,
    y: 79.8,
    width: 0.5,
    height: 82.51,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "473.95 144.88 342.82 69.17 342.82 64.48 473.95 140.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.98 139.02 475.98 143.71 473.95 144.88 473.95 140.19 475.98 139.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.98 139.02 344.85 63.31 342.82 64.48 473.95 140.19 475.98 139.02",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.29,228.6l-2.81-5.28,2.26-6.52v-4l-6.91,4v4l3,5.15a.41.41,0,0,0,.2.17h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.76,188a4.56,4.56,0,0,0-2.08-3.59l-1.68-1a4.6,4.6,0,0,0-4.15,0L403.7,200.19a4.58,4.58,0,0,0-2.07,3.59v21.66A4.59,4.59,0,0,0,403.7,229l1.69,1a4.6,4.6,0,0,0,4.15,0l11.63-6.71,3,5.14a.45.45,0,0,0,.81-.08l3.13-9.05,10.61-6.11a4.56,4.56,0,0,0,2.08-3.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.63,225.44A4.59,4.59,0,0,0,403.7,229l1.69,1a4.63,4.63,0,0,0,3.79.16c-1,.37-1.72-.18-1.72-1.36V207.14a4.29,4.29,0,0,1,.61-2l-5.83-3.37a4.19,4.19,0,0,0-.61,2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.69,187.36c-.24-.88-1.05-1.16-2-.61l-29.15,16.81a4,4,0,0,0-1.46,1.54l-5.83-3.36a4.13,4.13,0,0,1,1.46-1.55l29.14-16.81a4.66,4.66,0,0,1,4.15,0l1.69,1A4.58,4.58,0,0,1,440.69,187.36Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.12,206.19a1.91,1.91,0,0,1,1.77-.2,1.11,1.11,0,0,1,.63,1.14,1.43,1.43,0,0,1-.16.69,1.82,1.82,0,0,1-.15.23c-.36.2-.48-.48-.74-.54a1.26,1.26,0,0,0-1.39.12c-1.21.7-2.5,4.05-2.5,6.08,0,2.73,1.11,3.18,2.59,2.32a2.54,2.54,0,0,0,1.58-2.6c0-.26,0-1,0-1.33a7.18,7.18,0,0,1-1,.69c-.33.19-.74.14-.74-.41a1.19,1.19,0,0,1,.68-1.1,4.3,4.3,0,0,1,.48-.24l.27-.12c.3-.18.73-.63,1.05-.81s.53.13.53.49a1.44,1.44,0,0,1-.27.86c0,.69-.05,1.5,0,2.14,0,.82.06,1,.06,1.08,0,.83-.14,1-.37,1.17s-.47,0-.54-.13a6.3,6.3,0,0,1-1.8,1.76c-2.29,1.32-3.39,0-3.39-3.56C412.63,212.19,413.94,207.45,416.12,206.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.74,204.12a1.5,1.5,0,0,1,2.46.95c.08.28.11.44.15.46a.69.69,0,0,1,.37.65v2.93c0,.64-.05,1.5-.13,2.79-.13,2.1-.23,4.33-1.89,5.29-.39.22-2,.89-2-.1a1,1,0,0,1,.46-1c.15-.08.29,0,.46,0a2.91,2.91,0,0,0,1.09-.42c.65-.38.8-1.87.84-2.91,0-.48.09-1.38.11-2a4.81,4.81,0,0,1-1.9,2.45c-1.77,1-2.76.21-2.76-2.62C421,208.12,421.89,205.18,423.74,204.12Zm.18,7.65c1.17-.68,1.73-2.78,1.81-4.07a1.45,1.45,0,0,0-.09-.68,2.08,2.08,0,0,1-.13-.64,1,1,0,0,0-1.57-1c-1.46.85-1.88,2.81-1.88,4.6C422.06,212.27,422.89,212.37,423.92,211.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.87,207.72c.34-.19.75-.25.75.5a1.47,1.47,0,0,1-.67,1.37c-.29.16-.82.3-.82-.42A2.13,2.13,0,0,1,429.87,207.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,206c.34-.2.74-.26.74.5a1.44,1.44,0,0,1-.66,1.36c-.29.17-.82.3-.82-.42A2.08,2.08,0,0,1,433,206Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,204.17c.34-.2.75-.25.75.5a1.43,1.43,0,0,1-.66,1.36c-.29.17-.83.31-.83-.41A2.17,2.17,0,0,1,436,204.17Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--student-3--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "416.97 303.75 380.23 282.54 380.23 284.28 416.97 305.49 416.97 303.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.97 302 380.23 280.79 380.23 282.54 416.97 303.75 416.97 302",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 330.29 333.89 310.6 332.56 311.58 367.98 332.03 367.98 330.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 312.56 367.98 352.63 366.66 351.87 366.66 311.8 367.98 312.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 312.56 367.98 352.63 369.31 351.87 369.31 311.8 367.98 312.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.56 292.12 332.56 332.19 331.24 331.42 331.24 291.35 332.56 292.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.56 292.12 332.56 332.19 333.89 331.42 333.89 291.35 332.56 292.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 332.03 331.24 310.82 331.24 312.56 367.98 333.78 367.98 332.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.65 285.05 415.65 325.11 414.33 324.35 414.33 284.28 415.65 285.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.65 285.05 415.65 325.11 416.97 324.35 416.97 284.28 415.65 285.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 305.49 367.98 314.92 331.24 293.71 331.24 284.28 367.98 305.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 314.92 416.97 286.64 416.97 281.92 367.98 310.21 367.98 314.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 310.21 327.16 286.64 380.23 256 421.06 279.57 367.98 310.21",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 310.21 327.16 286.64 380.23 256 421.06 279.57 367.98 310.21",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.16 286.64 327.16 289 367.98 312.56 367.98 310.21 327.16 286.64",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.16 286.64 327.16 289 367.98 312.56 367.98 310.21 327.16 286.64",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 312.56 421.06 281.92 421.06 279.57 367.98 310.21 367.98 312.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 312.56 421.06 281.92 421.06 279.57 367.98 310.21 367.98 312.56",
    style: {
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.64,333.79a3.18,3.18,0,0,0,.54,1.61c.32.52,2.58,1.71,5.53,1.68s6-1.41,7.53-1.69,3.24-.11,5.06-.51,3.55-1,4.65-2.87a4,4,0,0,0-.26-1.9C412.29,330,389.64,333.79,389.64,333.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53,324.55c-.69,1.24-4.56,2.35-7,3.23s-5.22,1.28-6.48,2.55-1,3.19,2.19,4.47a11.48,11.48,0,0,0,2.87,1c3,.26,5.64-1.11,7.47-1.51,2.38-.52,4.17-.08,6.29-.68,3.14-.89,3.83-2.58,3.86-3.48.05-1.36-.44-2.27-.65-3.72s-.1-2.39-.85-2.46c0,0-.59,3.06-5.53,2.31A2.45,2.45,0,0,1,403.53,324.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,320l-.65,5a2.86,2.86,0,0,1-2.43,1.67c-1.88.18-2.73,1.09-3.07,1s0-1-.24-1.2-1.51-.32-1.81-1.79c0-.13,0-7.26,0-7.26Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,335.78s-2.69-5.79.47-7.69L396,328s-.19-.4-1.57-.1c-2.66.56-4.21,1.37-5,2.81a3.53,3.53,0,0,0,.16,3.07C390.28,334.81,392,335.76,395.07,335.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,331.47s-.9-2.42.51-3.87a1,1,0,0,1,1-.33s-1.47,1-.66,4c0,0,0,.22-.37.33C396.85,331.59,396.57,331.67,396.5,331.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,326.73s0-.08-.47,0a.77.77,0,0,0-.45.28s-1,1.17-.05,3.7a.47.47,0,0,0,.57.18.39.39,0,0,0,.34-.46S398.51,327.81,399.55,326.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,326.11s-.14-.11-.44,0-.39.38-.39.38a4.88,4.88,0,0,0,.52,3.39s.13.36.63.16.23-.55.23-.55S400.4,326.88,400.94,326.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,293.77c-1.86,7.66-.64,28.36-.64,28.36s4.57,1.49,8.46.11l5-23.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.35,344.93a3.2,3.2,0,0,0,.53,1.61c.33.52,2.59,1.72,5.54,1.68s5.94-1.41,7.53-1.69,3.23-.11,5.06-.51,3.54-1,4.65-2.86a4.13,4.13,0,0,0-.26-1.91C394,341.1,371.35,344.93,371.35,344.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05,335.69c-.69,1.24-4.37,2.35-6.85,3.24s-5.23,1.28-6.48,2.54-1,3.2,2.19,4.47a11.35,11.35,0,0,0,2.87,1c3,.27,5.64-1.11,7.47-1.5,2.38-.52,4.17-.08,6.29-.69,3.13-.89,3.82-2.58,3.86-3.48a20.63,20.63,0,0,0-.65-3.72c-.2-1.36-.1-2.38-.85-2.46,0,0-.59,3.07-5.53,2.32A2.81,2.81,0,0,1,385.05,335.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.67,331.43l-.89,4.76a2.86,2.86,0,0,1-2.43,1.66c-1.88.19-2.74,1.09-3.07,1s0-1-.24-1.2-1.69-.52-2-2c0-.12.47-7.53.47-7.53Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,346.92s-2.69-5.79.47-7.68l.44-.15s-.19-.39-1.57-.1c-2.67.56-4.21,1.37-5,2.81a3.47,3.47,0,0,0,.16,3.07C372,346,373.73,346.9,376.78,346.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.2,342.62s-.89-2.43.52-3.87a1,1,0,0,1,1-.34s-1.47,1-.67,4c0,0,0,.22-.36.32C378.56,342.74,378.28,342.82,378.2,342.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.26,337.88s0-.08-.48,0a.83.83,0,0,0-.44.28s-1,1.18-.06,3.71a.49.49,0,0,0,.58.17.38.38,0,0,0,.34-.45S380.21,339,381.26,337.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65,337.26s-.14-.11-.44,0-.39.37-.39.37a4.81,4.81,0,0,0,.52,3.39s.13.36.62.17.24-.55.24-.55S382.1,338,382.65,337.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.09,300.74c-2.41,7.19-3,31.07-3,31.07s4.88,2.47,8.54,1l6.56-21.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.75,312.94s-6.79-2.61-8.39-4.42c0,0,3.61,5.12,7.83,6.21Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,346.48l6.91-32.07a1,1,0,1,1,1.92.48l-4,18.52,18.12,10.47V324a1,1,0,0,1,2,0v19.93L439,333.42l-4-18.53a1,1,0,0,1,1.93-.48l6.91,32.07a1,1,0,0,1-.73,1.2l-.24,0a1,1,0,0,1-1-.76l-2.48-11.5-18.56,10.72v14.5a1,1,0,1,1-2,0v-14.5l-18.56-10.73L397.81,347a1,1,0,0,1-1,.76l-.24,0A1,1,0,0,1,395.89,346.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.48,316.71c-2.84-1.65-2.84-4.31,0-5.95l13.86-8a11.4,11.4,0,0,1,10.3,0L438,312.7s-12.58,11.77-18.17,12.85c-7.31,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.48,316.71c-2.84-1.65-2.84-4.31,0-5.95l13.86-8a11.4,11.4,0,0,1,10.3,0L438,312.7s-12.58,11.77-18.17,12.85c-7.31,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.61,264.39l25.21,13.54.41.65v.53a.77.77,0,0,1-.41.65l-26.53,15.31a1.41,1.41,0,0,1-1.38,0l-24.76-14.3v-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,294.72a1.41,1.41,0,0,0,.69-.17l26.53-15.32a.72.72,0,0,0,0-1.3L379.5,263.88l-28.35,16.37,24.76,14.3A1.41,1.41,0,0,0,376.6,294.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,262.34l24.1,13.93.2.27v2h0a.33.33,0,0,1-.2.27l-26.53,15.32a1,1,0,0,1-.94,0L352,280.25V278.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,278.21l.24.13,3.1,1.79.57.33,20.2,11.67a1,1,0,0,0,.94,0l26.53-15.32a.28.28,0,0,0,0-.54l-.25-.15L379.5,262.34l-27.24,15.73-.06,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,292.24v2.05a.91.91,0,0,0,.47-.12l26.53-15.32a.33.33,0,0,0,.2-.27v-2a.33.33,0,0,1-.2.27l-26.53,15.32A.91.91,0,0,1,376.6,292.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,277.93l3.43,2,.53.31,20.15,11.64a1,1,0,0,0,.94,0l23.76-13.72.6-.34a5.89,5.89,0,0,0,1.92-1.68l0-.07a.27.27,0,0,0,.05-.14.41.41,0,0,0-.33-.48,8.75,8.75,0,0,1-1.79-.75h0l-21.81-12.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,277.69a.27.27,0,0,1,0,.51.92.92,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,355.57,277.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.12,277.42a2.25,2.25,0,0,0,0,.44l.3-.18a2.35,2.35,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.16,1.16,0,0,1,.54.17,3.27,3.27,0,0,1,1.33,1.9,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.17,1.17,0,0,0-1.19-.08A1.51,1.51,0,0,0,352.12,277.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.19,278a.17.17,0,0,0,0,.07l.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.23,276.16a.27.27,0,0,1,0,.51,1,1,0,0,1-.89,0,.27.27,0,0,1,0-.51A1,1,0,0,1,358.23,276.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78,275.88a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.56.56,0,0,1,.31-.09,1.16,1.16,0,0,1,.55.17,3.4,3.4,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.69,3.69,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,354.78,275.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.89,274.62a.27.27,0,0,1,0,.51,1,1,0,0,1-.89,0,.27.27,0,0,1,0-.51A1,1,0,0,1,360.89,274.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.44,274.34a3.4,3.4,0,0,0,0,.45l.31-.18a2.44,2.44,0,0,1,0-.27,1.21,1.21,0,0,1,.44-1.09.72.72,0,0,1,.32-.08,1.18,1.18,0,0,1,.54.16,3.39,3.39,0,0,1,1.34,1.91,1.12,1.12,0,0,0,.32,0,3.74,3.74,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,357.44,274.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,273.09c.25.14.25.37,0,.51a1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,363.54,273.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,272.81a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.62.62,0,0,1,.32-.09,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.72.72,0,0,0,.33,0,3.69,3.69,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,360.1,272.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.2,271.55c.25.14.25.37,0,.51a.92.92,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,366.2,271.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.76,271.27a3.4,3.4,0,0,0,0,.45l.31-.18a2.44,2.44,0,0,1,0-.27,1.22,1.22,0,0,1,.44-1.09.72.72,0,0,1,.32-.08,1.18,1.18,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.19,1.19,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,362.76,271.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,270c.25.14.25.37,0,.51a1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,368.86,270Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.42,269.74a3.37,3.37,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.62.62,0,0,1,.32-.09,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.73.73,0,0,0,.33,0,3.69,3.69,0,0,0-1.49-2.14,1.18,1.18,0,0,0-1.19-.09A1.52,1.52,0,0,0,365.42,269.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,268.48a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,371.52,268.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,268.2a3.4,3.4,0,0,0,0,.45l.31-.18a2.45,2.45,0,0,1,0-.27,1.21,1.21,0,0,1,.45-1.09.69.69,0,0,1,.32-.08,1.22,1.22,0,0,1,.54.16A3.33,3.33,0,0,1,371,269.1a1.19,1.19,0,0,0,.33,0,3.71,3.71,0,0,0-1.5-2.15,1.13,1.13,0,0,0-1.18-.08A1.49,1.49,0,0,0,368.08,268.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,267a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,374.18,267Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.74,266.67a3.37,3.37,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.7,3.7,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.52,1.52,0,0,0,370.74,266.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,265.41a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,376.84,265.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,265.13a2.12,2.12,0,0,0,0,.44l.31-.17a2.45,2.45,0,0,1,0-.27,1.19,1.19,0,0,1,.45-1.09.66.66,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.52,1.52,0,0,0,373.39,265.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,263.88a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A.92.92,0,0,1,379.5,263.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.05,263.6a2.25,2.25,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.55,1.55,0,0,0,376.05,263.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M352.12,277.42a2.25,2.25,0,0,0,0,.44l.3-.18a2.35,2.35,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.16,1.16,0,0,1,.54.17,3.27,3.27,0,0,1,1.33,1.9,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.17,1.17,0,0,0-1.19-.08A1.51,1.51,0,0,0,352.12,277.42Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.78,275.88a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.56.56,0,0,1,.31-.09,1.16,1.16,0,0,1,.55.17,3.4,3.4,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.69,3.69,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,354.78,275.88Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.44,274.34a3.4,3.4,0,0,0,0,.45l.31-.18a2.44,2.44,0,0,1,0-.27,1.21,1.21,0,0,1,.44-1.09.72.72,0,0,1,.32-.08,1.18,1.18,0,0,1,.54.16,3.39,3.39,0,0,1,1.34,1.91,1.12,1.12,0,0,0,.32,0,3.74,3.74,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,357.44,274.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M360.1,272.81a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.62.62,0,0,1,.32-.09,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.72.72,0,0,0,.33,0,3.69,3.69,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,360.1,272.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M362.76,271.27a3.4,3.4,0,0,0,0,.45l.31-.18a2.44,2.44,0,0,1,0-.27,1.22,1.22,0,0,1,.44-1.09.72.72,0,0,1,.32-.08,1.18,1.18,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.19,1.19,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,362.76,271.27Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M365.42,269.74a3.37,3.37,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.62.62,0,0,1,.32-.09,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.73.73,0,0,0,.33,0,3.69,3.69,0,0,0-1.49-2.14,1.18,1.18,0,0,0-1.19-.09A1.52,1.52,0,0,0,365.42,269.74Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M368.08,268.2a3.4,3.4,0,0,0,0,.45l.31-.18a2.45,2.45,0,0,1,0-.27,1.21,1.21,0,0,1,.45-1.09.69.69,0,0,1,.32-.08,1.22,1.22,0,0,1,.54.16A3.33,3.33,0,0,1,371,269.1a1.19,1.19,0,0,0,.33,0,3.71,3.71,0,0,0-1.5-2.15,1.13,1.13,0,0,0-1.18-.08A1.49,1.49,0,0,0,368.08,268.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M370.74,266.67a3.37,3.37,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.7,3.7,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.52,1.52,0,0,0,370.74,266.67Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M373.39,265.13a2.12,2.12,0,0,0,0,.44l.31-.17a2.45,2.45,0,0,1,0-.27,1.19,1.19,0,0,1,.45-1.09.66.66,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.52,1.52,0,0,0,373.39,265.13Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M376.05,263.6a2.25,2.25,0,0,0,0,.44l.31-.18a2.28,2.28,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.55,1.55,0,0,0,376.05,263.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,272.06l-22.45-2.68a13.25,13.25,0,0,0-6-2.25,5.83,5.83,0,0,0-2.59.94c-2.31,1.73-5.52,8.18-1.48,8.87,2.4.41,5.27-1.22,7.22-1.31a25,25,0,0,1,5.19.56c4.64,1.48,13.08,4.64,19.35,6,2.37.51,5-1,6.33-3.61C434,274.33,426.32,272.06,426.32,272.06Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,271.24,394.29,277s.43,0,.85,0c0,0,1.24-2.4,1.85-3.28s1.2-1.85,1.2-1.85a7.66,7.66,0,0,0,2.45-2C401.22,268.94,397.44,271.24,397.44,271.24Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,277.35,390.3,281a.12.12,0,0,0,.19.11l2.8-2.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,281.15h0l2.8-2.52-1.22-.67-.22.41L390.41,281Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,281.14a.12.12,0,0,1-.19-.11l.13-.71h0a.66.66,0,0,0,.59.29h.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,262.67l-.17.3-.2.37-8.61,15.28a1.66,1.66,0,0,1-1.22-.09,1.7,1.7,0,0,1-1.08-1.17l8.6-15.28.4-.7C399.76,261.85,402,263.14,402.27,262.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,262.67l-.17.31-.2.36-8.61,15.28a1.77,1.77,0,0,1-1.47-.22l8.95-16.08s0-.05,0-.06C401.37,262.64,402.14,262.93,402.27,262.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.63,263.82l-.38.68c-.11.2-.59.09-1.1-.14-.67-.3-1.32-.9-1.19-1.16l.28-.5.11-.18c-.14.27.51.87,1.18,1.17.49.21,1,.32,1.08.15h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.53,264c-.24.46-2.52-.84-2.28-1.3l.38-.67c-.24.46,2,1.76,2.28,1.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,262.67l-.37.67c-.24.46-2.45-.78-2.31-1.26a0,0,0,0,0,0,0l.39-.67C399.76,261.85,402,263.14,402.27,262.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,281.16a.14.14,0,0,0,.11,0A.14.14,0,0,1,390.36,281.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,261.29l-.79,1.38c-.1.2-.58.1-1.09-.13-.67-.3-1.33-.89-1.19-1.16h0l.79-1.39c.32-.56,1.55-.06,2.1.56A.67.67,0,0,1,403.06,261.29Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,261.47a2,2,0,0,1-1.4-1.14.46.46,0,0,1,0-.42c.39-.43,1.52.06,2,.64a.7.7,0,0,1,.19.73C403,261.49,402.62,261.57,402.19,261.47Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.65,267.31a6.77,6.77,0,0,0-1.39,0,4.56,4.56,0,0,0-1.87.5,1.43,1.43,0,0,0-.56.47,2.18,2.18,0,0,0-.24.72c-.29,1.29-1.23,2.31-1.52,3.59s0,4,.95,4.4c.59.23,1.09-1.12,1.14-2,.37.53,1.14,0,1.26-1.49.11-1.2.36-2.88.36-2.88Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,269.88a.77.77,0,0,0,0,.78,1.61,1.61,0,0,0,.61.65l.09-.69Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,269.36c-1.73-1-2.54-2.26-4.29-1.9s-2.28,1-4.2,1.54c-2.72.78-.67,2.59,1.77,2.27a6.23,6.23,0,0,0,3.49-1.38S403.83,272.17,403.87,269.36Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.32,302.16s-16.2-8-21.43-10.34-8.25-2.91-10.87-1.95c-2.24.82-3.58,2.71-4.47,6-.18.63-.89,4.38-.89,4.38a49.74,49.74,0,0,0,15.8,6C427.94,308.18,440.32,302.16,440.32,302.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.64,301.28c.65,9.69-1.29,13.81-5,16-6.05,3.61-14.11,5.77-23.29,2.07-6.13-2.47-17.17-9.1-17.17-9.1-1.79-2.9-8.57-1.29-8.27-3.65.23-1.89.59-4,.75-4.61.84-3.16,3.54-7.33,10.19-5.8,4.09.93,7.3,2.72,14.06,4.84,1.54.49,3.79-1.62,5-1.16,3,1.09,3.72,6.16,3.72,6.16Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "420.56 265.71 421.55 275.06 431.34 274.3 430.5 263.94 420.56 265.71",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.74,302.25c-.92-19.75-1.05-22.68-1.87-27.19s-2.74-8.66-6.51-8l-1.56.23c-.12,2.57-5.11,3.31-9.91,1.69-1.35.32-5.18,1.33-5.18,1.33-3.45,2.08-4.25,4.34-4.25,13.36s.62,15.77.69,21.1C419.66,310.39,436.84,307.88,440.74,302.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.92,241c-.1-.56-1.47-1.34-1.93-1.59a6.73,6.73,0,0,0-2.43-.78,3.94,3.94,0,0,0-2.48.44,2.24,2.24,0,0,0-1.13,2.13c.06.42.26.89,0,1.22a1.07,1.07,0,0,1-.34.25,7,7,0,0,0-1.82,1.26,2.08,2.08,0,0,0-.58,2c.25.76,1.07,1.28,1.16,2.08a4.9,4.9,0,0,1-.21,1.3c-.29,1.78,2,3.71,3.54,2.26a7.06,7.06,0,0,0,.83-1.41l2-3.44,1.76-3,.85-1.43C420.35,242,421,241.3,420.92,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.06,252.53s-2.56,3.94-2.39,4.59c.22.85,2.29.85,2.29.85Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,243.36c-2.17,1.2-5.55,3.36-4.9,11.12-2,7.4,1.16,10.25,2.49,11.1a9.2,9.2,0,0,0,6.71.52c2.56-.87,8.09-3.79,10.6-8.17,3-5.15,1.7-11.34-1.94-13.9C425.54,240.44,419.55,242.34,417.7,243.36Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.64,266.4l-.13-1.37s-3.28,1.15-5.22.55A8.93,8.93,0,0,0,420.64,266.4Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.46,255.74a2.92,2.92,0,0,1,1.06-1.43,2.51,2.51,0,0,1,2.65-.09c2.34,1.13.66,4.86-.41,5.59s-2.4.6-2.8,0c0,1.51.08,4.38,3.78,5.22a6.89,6.89,0,0,0,5.76-1.09c.51-2.63,3.84-4.95,4.85-9.33s-.06-8.11-2.85-8.86c0,0,0-3.81-6.4-4.85s-10.48.6-11.48,4.94c0,0-.45,6.32,4.37,7.46,0,0-1.2,3,1.07,3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,259.82a2.73,2.73,0,0,1-.71,1.5,4.88,4.88,0,0,1-1.27.83,4.81,4.81,0,0,0-2.39,1.73,2.12,2.12,0,0,0,.44,2.5,4.92,4.92,0,0,1,.82.69c.49.66.15,1.48,0,2.19a3.43,3.43,0,0,0,0,1.56c.43,1.7,2.27,1.85,3.72,1.62.59-.1,1.06-.39,1.62-.53a2.11,2.11,0,0,1,1.77.54c.51.4.92.91,1.44,1.29a3.69,3.69,0,0,0,3.67.31,11.64,11.64,0,0,1,2.52-1.41,5.76,5.76,0,0,1,2,.11,2.59,2.59,0,0,0,1.92-.28c.88-.61,1.17-1.94,1.41-2.91a3,3,0,0,1,1.47-2.24c.63-.25,1.38-.09,2-.38a2.23,2.23,0,0,0,1.08-2,4,4,0,0,0-1-2.81c-.51-.56-1.23-1.11-1.13-1.86.06-.53.52-.9.77-1.36a2.75,2.75,0,0,0-.55-3,13.74,13.74,0,0,0-2.52-2,4.41,4.41,0,0,1-1.89-2.53,15.23,15.23,0,0,1-.05-1.79,4.18,4.18,0,0,0-1.63-3c-.8-.62-2.25-1.41-2.61,0-.81,3.05-.18,6.23-.41,9.33a4.85,4.85,0,0,1-1.62,3.85,7,7,0,0,1-3.81,2.05C421.21,262.31,421,259.86,421,259.82Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.29,286.43a7.33,7.33,0,0,0,2.51.6c.58,0,1.17-.14,1-.83s-.36-1.12-.47-1.7a1.88,1.88,0,0,1,.36-1.66.54.54,0,0,1,.52-.19.71.71,0,0,1,.34.38c.86,1.68,2.31,2.88,3.46,4.36.91,1.18,2.25,1.22,3.66,1.46,3,.51,10.33,1.42,10.33,1.42s4.81-7.89,6.65-10.62c3.21-4.76,3.33-7.62,11-9.35,1.53,2.06,2.71,7.5-.08,13.29-3.62,4.76-9,12.48-10.51,14.1s-1.73,1.62-2.46,1.86a7.75,7.75,0,0,1-2.92.05,41.87,41.87,0,0,1-5.75-1.28c-3.77-1.06-7.46-2.42-11.3-3.22a30.16,30.16,0,0,1-3.87-.9,11.5,11.5,0,0,1-7.2-7.51,1.39,1.39,0,0,1,.13-1.39,1.29,1.29,0,0,1,1.27-.15A28.07,28.07,0,0,1,376.29,286.43Z",
    style: {
      fill: "#9e6767"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,323.67l7,4.05c4.45,2.58,9.16,4,13.91,1.29L440,321.9c4.76-2.73,7-7.82,8.09-13.17l4.78-22.45c.53-2.53.17-4.34-.88-5.3h0c-1.18-.36-2.8-.08-4.71,1l-7.68,4.29c-4.78,2.67-9.61,9.18-10.77,14.53l-3.85,17.81c-1.17,5.36-5.71,8.67-10.15,7.38ZM445.38,294a1.87,1.87,0,0,1,.2,1.36l-.65,4-11.28,6.52c.05-.3.11-.65.17-1s.14-.84.21-1.29l.06-.35c.36-2.18,3-5.27,5.79-6.91l2.26-1.3a8.56,8.56,0,0,1,1.77-.77A3.72,3.72,0,0,1,445,294Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.74,323.67l7,4.05c4.45,2.58,9.16,4,13.91,1.29L440,321.9c4.76-2.73,7-7.82,8.09-13.17l4.78-22.45c.53-2.53.17-4.34-.88-5.3h0c-1.18-.36-2.8-.08-4.71,1l-7.68,4.29c-4.78,2.67-9.61,9.18-10.77,14.53l-3.85,17.81c-1.17,5.36-5.71,8.67-10.15,7.38ZM445.38,294a1.87,1.87,0,0,1,.2,1.36l-.65,4-11.28,6.52c.05-.3.11-.65.17-1s.14-.84.21-1.29l.06-.35c.36-2.18,3-5.27,5.79-6.91l2.26-1.3a8.56,8.56,0,0,1,1.77-.77A3.72,3.72,0,0,1,445,294Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,323.67l7,4.05c4.45,2.58,9.16,4,13.91,1.29L440,321.9c4.76-2.73,7-7.82,8.09-13.17l4.78-22.45c.53-2.53.17-4.34-.88-5.3h0c-1.18-.36-2.8-.08-4.71,1l-7.68,4.29c-4.78,2.67-9.61,9.18-10.77,14.53l-3.85,17.81c-1.17,5.36-5.71,8.67-10.15,7.38ZM445.38,294a1.87,1.87,0,0,1,.2,1.36l-.65,4-11.28,6.52c.05-.3.11-.65.17-1s.14-.84.21-1.29l.06-.35c.36-2.18,3-5.27,5.79-6.91l2.26-1.3a8.56,8.56,0,0,1,1.77-.77A3.72,3.72,0,0,1,445,294Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44,307.09,446,299.82l.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.87,1.87,0,0,1,.2,1.36l-.65,4-11.28,6.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44,307.09,446,299.82l.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.87,1.87,0,0,1,.2,1.36l-.65,4-11.28,6.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,316.7l9.26,5.33s5.13,3.52,10.21,3.65c3.67-.12,7-3.17,8-7.64l3.85-17.82c1.17-5.35,6-11.87,10.76-14.54l7.68-4.28c2.53-1.42,4.55-1.46,5.72-.42-1.18-.36-2.8-.08-4.72,1l-7.68,4.29c-4.78,2.67-9.61,9.18-10.77,14.53l-3.85,17.81a9.76,9.76,0,0,1-5.22,7,8.08,8.08,0,0,1-5.61.84c-3.07-.38-7.36-2.74-7.36-2.74-.21-.11-.39-.22-.54-.31l-.45-.25-9.26-5.32a3.6,3.6,0,0,1-2.11-3v-.67A3.85,3.85,0,0,0,396.49,316.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.38,314.81v-.67a3.85,3.85,0,0,0,2.11,2.56l9.26,5.33s5.13,3.52,10.21,3.65c3.67-.12,7-3.17,8-7.64l3.85-17.82a18.39,18.39,0,0,1,1.58-4.31l1,.57a18.55,18.55,0,0,0-1.58,4.31l-3.85,17.81a9.76,9.76,0,0,1-5.22,7,8.08,8.08,0,0,1-5.61.84c-3.07-.38-7.36-2.74-7.36-2.74-.21-.11-.39-.22-.54-.31l-.45-.25-9.26-5.32A3.6,3.6,0,0,1,394.38,314.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.55,285.68l7.68-4.28c2.53-1.42,4.55-1.46,5.72-.42-1.18-.36-2.8-.08-4.72,1l-7.68,4.29c-3.54,2-7.1,6.06-9.19,10.22l-1-.57C431.46,291.75,435,287.66,438.55,285.68Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--student-2--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.67 350.69 298.93 329.48 298.93 331.22 335.67 352.43 335.67 350.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.67 348.94 298.93 327.73 298.93 329.48 335.67 350.69 335.67 348.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 377.23 252.59 357.54 251.26 358.52 286.68 378.97 286.68 377.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 359.5 286.68 399.57 285.36 398.81 285.36 358.74 286.68 359.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 359.5 286.68 399.57 288 398.81 288 358.74 286.68 359.5",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 339.06 251.26 379.13 249.94 378.36 249.94 338.29 251.26 339.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 339.06 251.26 379.13 252.59 378.36 252.59 338.29 251.26 339.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 378.97 249.94 357.76 249.94 359.5 286.68 380.72 286.68 378.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.35 331.98 334.35 372.05 333.02 371.29 333.02 331.22 334.35 331.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.35 331.98 334.35 372.05 335.67 371.29 335.67 331.22 334.35 331.98",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 352.43 286.68 361.86 249.94 340.65 249.94 331.22 286.68 352.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 361.86 335.67 333.58 335.67 328.86 286.68 357.15 286.68 361.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 357.15 245.86 333.58 298.93 302.94 339.75 326.51 286.68 357.15",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 357.15 245.86 333.58 298.93 302.94 339.75 326.51 286.68 357.15",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.86 333.58 245.86 335.94 286.68 359.5 286.68 357.15 245.86 333.58",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.86 333.58 245.86 335.94 286.68 359.5 286.68 357.15 245.86 333.58",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 359.5 339.75 328.86 339.75 326.51 286.68 357.15 286.68 359.5",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 359.5 339.75 328.86 339.75 326.51 286.68 357.15 286.68 359.5",
    style: {
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.13,380.61a3.32,3.32,0,0,0,.56,1.68c.33.55,2.69,1.79,5.77,1.76s6.2-1.47,7.85-1.77,3.37-.11,5.28-.53,3.69-1,4.85-3a4.38,4.38,0,0,0-.28-2C330.74,376.62,307.13,380.61,307.13,380.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,371c-.73,1.3-4.76,2.45-7.35,3.38-2.44.87-5.45,1.33-6.75,2.65s-1,3.33,2.28,4.66a11.64,11.64,0,0,0,3,1c3.12.28,5.88-1.16,7.79-1.57,2.48-.54,4.35-.08,6.55-.71,3.28-.93,4-2.69,4-3.63,0-1.42-.45-2.37-.68-3.88s-.1-2.48-.88-2.56c0,0-.62,3.19-5.77,2.41A2.54,2.54,0,0,1,321.62,371Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,366.27l-.68,5.23a3,3,0,0,1-2.53,1.74c-2,.19-2.85,1.13-3.2,1.07s0-1-.25-1.25-1.58-.33-1.89-1.87c0-.13,0-7.57,0-7.57Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,382.69s-2.8-6,.49-8l.46-.15s-.2-.41-1.64-.11c-2.78.59-4.38,1.43-5.18,2.93a3.67,3.67,0,0,0,.17,3.21C307.8,381.68,309.61,382.67,312.79,382.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28,378.21s-.94-2.53.53-4a1,1,0,0,1,1-.35s-1.53,1.05-.69,4.13c0,0,0,.23-.38.34C314.65,378.33,314.36,378.41,314.28,378.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.46,373.26s0-.08-.49.05a.81.81,0,0,0-.46.29s-1.05,1.22-.06,3.86a.49.49,0,0,0,.59.19.41.41,0,0,0,.36-.48S316.37,374.39,317.46,373.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.91,372.61s-.15-.11-.46,0-.41.4-.41.4a5,5,0,0,0,.55,3.53s.14.38.65.17.25-.57.25-.57S318.34,373.42,318.91,372.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.13,340c-1.86,7.67-.64,28.36-.64,28.36s4.57,1.49,8.46.12l5-23.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.17,391.42a3.4,3.4,0,0,0,.55,1.65c.33.54,2.65,1.76,5.67,1.72s6.09-1.44,7.71-1.73,3.32-.11,5.19-.52,3.63-1,4.76-2.93a4.09,4.09,0,0,0-.27-1.95C312.37,387.5,289.17,391.42,289.17,391.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.21,382c-.71,1.27-4.48,2.41-7,3.31s-5.35,1.32-6.63,2.61-1,3.27,2.24,4.58a11.49,11.49,0,0,0,2.94,1c3.06.27,5.78-1.14,7.65-1.54,2.43-.53,4.27-.08,6.44-.7,3.21-.91,3.92-2.64,3.95-3.56.05-1.4-.44-2.33-.66-3.81s-.11-2.45-.87-2.52c0,0-.61,3.13-5.67,2.37A2.88,2.88,0,0,1,303.21,382Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,377.6l-.92,4.86a2.92,2.92,0,0,1-2.49,1.71c-1.92.19-2.8,1.12-3.14,1.06s0-1-.24-1.23-1.74-.53-2-2c0-.13.47-7.71.47-7.71Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.74,393.46s-2.76-5.93.48-7.87l.45-.15s-.19-.4-1.61-.1c-2.73.57-4.31,1.4-5.09,2.88a3.55,3.55,0,0,0,.17,3.14C289.83,392.47,291.61,393.44,294.74,393.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.2,389.05s-.92-2.48.52-4a1,1,0,0,1,1-.35s-1.5,1-.67,4.07c0,0,0,.22-.38.33C296.56,389.18,296.27,389.26,296.2,389.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,384.2s0-.08-.48,0a.76.76,0,0,0-.45.29s-1,1.2-.06,3.79a.48.48,0,0,0,.58.19.4.4,0,0,0,.35-.47S298.25,385.31,299.32,384.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.75,383.56s-.15-.11-.45,0-.41.39-.41.39a5,5,0,0,0,.54,3.47s.14.37.64.17.24-.57.24-.57S300.19,384.35,300.75,383.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,346.93c-2.41,7.2-3,31.07-3,31.07s4.87,2.48,8.54,1.05l6.55-21.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,359.14s-6.79-2.62-8.39-4.42c0,0,3.61,5.12,7.84,6.2Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,393.9l6.91-32.07a1,1,0,0,1,1.2-.72,1,1,0,0,1,.73,1.2l-4,18.52,18.12,10.47V371.37a1,1,0,0,1,2,0V391.3l18.12-10.46-4-18.53a1,1,0,0,1,1.93-.48l6.91,32.07a1,1,0,0,1-.73,1.2l-.23,0a1,1,0,0,1-1-.76l-2.47-11.5-18.56,10.72v14.5a1,1,0,0,1-2,0v-14.5L319.8,382.87l-2.48,11.5a1,1,0,0,1-1,.76l-.24,0A1,1,0,0,1,315.4,393.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,364.13c-2.85-1.65-2.85-4.31,0-5.95l13.86-8a11.42,11.42,0,0,1,10.31,0l17.29,9.95S344.88,371.89,339.29,373c-7.31,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316,364.13c-2.85-1.65-2.85-4.31,0-5.95l13.86-8a11.42,11.42,0,0,1,10.31,0l17.29,9.95S344.88,371.89,339.29,373c-7.31,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.73,312.82l25.21,13.54.41.65v.53a.76.76,0,0,1-.41.65l-26.53,15.32a1.41,1.41,0,0,1-.69.17,1.38,1.38,0,0,1-.69-.17L266.27,329.2v-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.72,343.15a1.41,1.41,0,0,0,.69-.17l26.53-15.32a.75.75,0,0,0,.41-.65.77.77,0,0,0-.41-.65l-24.32-14.05-28.35,16.37L291,343A1.38,1.38,0,0,0,291.72,343.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.62,310.77l24.1,13.93.2.27v2h0a.35.35,0,0,1-.2.28L292.19,342.6a1,1,0,0,1-.94,0l-24.11-13.92v-2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,326.64l.24.13,3.1,1.79.57.34,20.2,11.66a1,1,0,0,0,.94,0l26.53-15.32a.28.28,0,0,0,0-.54l-.25-.15-23.85-13.78L267.38,326.5l-.06,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.72,340.68v2a.91.91,0,0,0,.47-.12l26.53-15.31a.35.35,0,0,0,.2-.28v-2a.33.33,0,0,1-.2.27l-26.53,15.32A.91.91,0,0,1,291.72,340.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,326.36l3.43,2,.53.31,20.15,11.64a1,1,0,0,0,.94,0L316,326.57l.6-.34a5.89,5.89,0,0,0,1.92-1.68l0-.07a.24.24,0,0,0,.05-.14.41.41,0,0,0-.33-.48,8.75,8.75,0,0,1-1.79-.75h0l-21.81-12.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,326.13a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A.92.92,0,0,1,270.69,326.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.24,325.85a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.65.65,0,0,1,.31-.08,1.16,1.16,0,0,1,.55.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,267.24,325.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,326.46a.25.25,0,0,0,0,.08l.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.35,324.59a.27.27,0,0,1,0,.51,1,1,0,0,1-.89,0,.27.27,0,0,1,0-.51A1,1,0,0,1,273.35,324.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,324.31a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.36,3.36,0,0,1,1.34,1.9.85.85,0,0,0,.32,0A3.68,3.68,0,0,0,271.7,323a1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,269.9,324.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,323.05a.28.28,0,0,1,0,.52,1,1,0,0,1-.89,0,.28.28,0,0,1,0-.52A1,1,0,0,1,276,323.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.56,322.78a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.24,1.24,0,0,1,.44-1.1.72.72,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.88.88,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.51,1.51,0,0,0,272.56,322.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.66,321.52c.25.14.25.37,0,.51a1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,278.66,321.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,321.24a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0A3.68,3.68,0,0,0,277,320a1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,275.22,321.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,320c.25.15.25.37,0,.52a1,1,0,0,1-.88,0,.28.28,0,0,1,0-.52A1,1,0,0,1,281.32,320Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,319.71a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.2,1.2,0,0,0-1.19-.08A1.51,1.51,0,0,0,277.88,319.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,318.45c.25.14.25.37,0,.51a1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,284,318.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54,318.17a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.73.73,0,0,0,.33,0,3.65,3.65,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.52,1.52,0,0,0,280.54,318.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,316.91a.28.28,0,0,1,0,.52,1,1,0,0,1-.88,0c-.25-.15-.25-.37,0-.52A1,1,0,0,1,286.64,316.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,316.64a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.76,3.76,0,0,0-1.5-2.15,1.18,1.18,0,0,0-1.18-.08A1.51,1.51,0,0,0,283.2,316.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3,315.38a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,289.3,315.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.85,315.1a3.27,3.27,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.75.75,0,0,0,.33,0,3.7,3.7,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.53,1.53,0,0,0,285.85,315.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,313.84a.28.28,0,0,1,0,.52.94.94,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,292,313.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.51,313.57a2.25,2.25,0,0,0,0,.44l.31-.18a1.18,1.18,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.54,1.54,0,0,0,288.51,313.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.62,312.31a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,294.62,312.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,312a2.18,2.18,0,0,0,0,.44l.31-.18a1.1,1.1,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.55,1.55,0,0,0,291.17,312Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.24,325.85a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.65.65,0,0,1,.31-.08,1.16,1.16,0,0,1,.55.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,267.24,325.85Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.9,324.31a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.36,3.36,0,0,1,1.34,1.9.85.85,0,0,0,.32,0A3.68,3.68,0,0,0,271.7,323a1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,269.9,324.31Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M272.56,322.78a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.24,1.24,0,0,1,.44-1.1.72.72,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.88.88,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.51,1.51,0,0,0,272.56,322.78Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.22,321.24a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0A3.68,3.68,0,0,0,277,320a1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,275.22,321.24Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.88,319.71a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.2,1.2,0,0,0-1.19-.08A1.51,1.51,0,0,0,277.88,319.71Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M280.54,318.17a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.73.73,0,0,0,.33,0,3.65,3.65,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.52,1.52,0,0,0,280.54,318.17Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M283.2,316.64a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.76,3.76,0,0,0-1.5-2.15,1.18,1.18,0,0,0-1.18-.08A1.51,1.51,0,0,0,283.2,316.64Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.85,315.1a3.27,3.27,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.75.75,0,0,0,.33,0,3.7,3.7,0,0,0-1.5-2.14,1.16,1.16,0,0,0-1.18-.09A1.53,1.53,0,0,0,285.85,315.1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M288.51,313.57a2.25,2.25,0,0,0,0,.44l.31-.18a1.18,1.18,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9,1.12,1.12,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.54,1.54,0,0,0,288.51,313.57Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17,312a2.18,2.18,0,0,0,0,.44l.31-.18a1.1,1.1,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.09,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.55,1.55,0,0,0,291.17,312Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.55,348.36s-16.19-8-21.42-10.35-8.26-2.9-10.88-1.95c-2.23.82-3.58,2.72-4.47,6-.17.62-.89,4.38-.89,4.38a50,50,0,0,0,15.8,6C346.17,354.38,358.55,348.36,358.55,348.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,347.48c.65,9.69-1.29,13.81-5,16-6.05,3.61-14.11,5.76-23.29,2.06-6.13-2.47-17.17-9.1-17.17-9.1-1.79-2.9-8.57-1.29-8.27-3.65.24-1.88.59-4,.76-4.6.83-3.16,3.53-7.33,10.19-5.81,4.08.94,7.29,2.72,14.05,4.85,1.54.48,3.79-1.62,5-1.16,3,1.08,3.72,6.15,3.72,6.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "338.8 311.91 339.78 321.25 349.57 320.5 348.74 310.14 338.8 311.91",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,348.45c-.91-19.76-1-22.68-1.87-27.2s-2.73-8.65-6.5-8l-1.57.23c-.12,2.56-5.11,3.3-9.9,1.68-1.36.32-5.19,1.34-5.19,1.34-3.44,2.07-4.25,4.33-4.25,13.35s.62,15.78.69,21.1C337.89,356.59,355.07,354.08,359,348.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,348.45c-.91-19.76-1-22.68-1.87-27.2s-2.73-8.65-6.5-8l-1.57.23c-.12,2.56-5.11,3.3-9.9,1.68-1.36.32-5.19,1.34-5.19,1.34-3.44,2.07-4.25,4.33-4.25,13.35s.62,15.78.69,21.1C337.89,356.59,355.07,354.08,359,348.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.68,298.85s-2.57,3.93-2.4,4.58c.23.86,2.3.86,2.3.86Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,303.21a3,3,0,1,1,3-3A3,3,0,0,1,331.62,303.21Zm0-5.48a2.49,2.49,0,1,0,2.49,2.49A2.5,2.5,0,0,0,331.62,297.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,289.55c-2.18,1.2-5.56,3.36-4.91,11.12-2,7.41,1.16,10.26,2.49,11.11a9.2,9.2,0,0,0,6.71.51c2.56-.87,8.09-3.79,10.6-8.16,3-5.16,1.7-11.35-1.94-13.9C343.77,286.64,337.78,288.54,335.94,289.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69,301.94a2.88,2.88,0,0,1,1.07-1.43,2.46,2.46,0,0,1,2.64-.1c2.35,1.14.66,4.87-.41,5.6s-2.4.59-2.8,0c-.39,1.38.08,4.38,3.78,5.22a6.92,6.92,0,0,0,5.77-1.09c.51-2.64,3.83-5,4.84-9.33s-.06-8.12-2.85-8.87c0,0,0-3.81-6.4-4.85s-11.24,1.82-12.24,6.16c0,0,.74.72,3.46,1.07,0,0-.14,4.31,1.67,5.18,0,0-1.2,3,1.08,3.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,300.79h0l-10.37-1a.25.25,0,0,1-.23-.27.26.26,0,0,1,.27-.23l10.38,1a.25.25,0,0,1,.23.27A.26.26,0,0,1,339.34,300.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.55,286.33c-2.12-.32-3.38.11-5,.12a7,7,0,0,1-4.65-1.35c-.17-.14-.36-.31-.57-.26a.58.58,0,0,0-.24.14,2.1,2.1,0,0,0,.18,3.13l-2.39-.66a1.29,1.29,0,0,0-.8,0,1.11,1.11,0,0,0-.53.5,4.82,4.82,0,0,0-.15,3.68c.64,1.94,2.15,3,4.1,3.57a9.93,9.93,0,0,0,3,.26,11.13,11.13,0,0,0,2.29-.42l6.46-1.67c.92-.23,1.83-.47,2.76-.68l1.71-.71C350.73,288.94,347.91,286.83,344.55,286.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,312.59l-.13-1.36s-3.28,1.15-5.22.55A8.93,8.93,0,0,0,338.87,312.59Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,334.6l1,3.61a.11.11,0,0,1-.18.12l-3-2.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,338.34h0l-3-2.29,1.16-.77.26.39,1.63,2.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.76,338.33a.11.11,0,0,0,.18-.12l-.19-.7h0a.65.65,0,0,1-.56.33h-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,320.81l.19.29.23.35L297.78,336A1.92,1.92,0,0,0,300,334.6L290.23,320l-.44-.67C290.05,319.8,287.88,321.26,287.61,320.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,320.81l.19.29.23.35L297.78,336a1.79,1.79,0,0,0,1.45-.34l-10.15-15.35s0-.05,0-.07C288.51,320.72,287.76,321.06,287.61,320.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.34,321.91l.43.65c.12.19.59,0,1.08-.22.65-.36,1.25-1,1.09-1.25l-.31-.48-.12-.17c.16.26-.45.9-1.09,1.25-.47.26-.93.4-1.07.24h0S288.34,321.92,288.34,321.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,322.07c.27.45,2.45-1,2.17-1.47l-.43-.64c.28.44-1.9,1.91-2.17,1.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,320.81l.42.64c.27.44,2.38-1,2.2-1.43v0l-.43-.64C290.05,319.8,287.88,321.26,287.61,320.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,338.34a.11.11,0,0,1-.11,0A.11.11,0,0,0,300.89,338.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.71,319.5l.9,1.31c.11.19.59.05,1.07-.21.65-.35,1.26-1,1.11-1.25h0l-.9-1.32c-.37-.54-1.55.06-2.05.72A.67.67,0,0,0,286.71,319.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,319.61a2,2,0,0,0,1.3-1.24.45.45,0,0,0-.08-.42c-.42-.4-1.5.17-2,.8a.68.68,0,0,0-.13.73C286.84,319.69,287.17,319.75,287.6,319.61Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.66,331.36s.47.73.83,1.26a1.51,1.51,0,0,0,1.24.49,2,2,0,0,0,1.43-1.23l-1-1.45a3.29,3.29,0,0,1,2.56.21,3.49,3.49,0,0,1,2.14,2.06c.84,1.91,1.71,1.95,4.05,2.34,3,.51,10.32,1.43,10.32,1.43s4.81-7.9,6.65-10.62c3.21-4.77,3.46-7.45,11.15-9.18,1.53,2.06,2.6,7.33-.19,13.12-3.63,4.75-7.35,10.95-10.51,14.1-2.85,2.82-4.51,2.5-8.33,1.71-3-.61-14.17-3.74-17-5s-5.07-5.05-5.06-6.76A3,3,0,0,1,294.66,331.36Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,316.5s-4.44.17-6.23,2.1S316,335.78,316,335.78l-7.39-.37s-3.31,2.19-2.37,7.86a74.72,74.72,0,0,0,9.07,2.88c3.42.69,5.21,1.18,7.85-1.36s11.21-14.27,11.21-14.27C336.2,328.17,338.32,320,333.94,316.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,316.5s-4.44.17-6.23,2.1S316,335.78,316,335.78l-7.39-.37s-3.31,2.19-2.37,7.86a74.72,74.72,0,0,0,9.07,2.88c3.42.69,5.21,1.18,7.85-1.36s11.21-14.27,11.21-14.27C336.2,328.17,338.32,320,333.94,316.5Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,371.1c1.38.79,4,2.3,7,4,4.45,2.57,9.16,4,13.91,1.28l12.28-7.1c4.75-2.74,6.95-7.83,8.08-13.17l4.78-22.46c.53-2.53.17-4.34-.88-5.29h0c-1.18-.37-2.8-.09-4.71,1l-7.68,4.29c-4.78,2.67-9.6,9.18-10.77,14.53L344.44,366c-1.16,5.36-5.71,8.67-10.15,7.38Zm38.64-29.72a1.84,1.84,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.17-1s.14-.84.21-1.29c0-.11,0-.23.06-.35.37-2.18,3-5.27,5.79-6.91l2.26-1.29a8.14,8.14,0,0,1,1.77-.78,3.72,3.72,0,0,1,1.07-.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25,371.1c1.38.79,4,2.3,7,4,4.45,2.57,9.16,4,13.91,1.28l12.28-7.1c4.75-2.74,6.95-7.83,8.08-13.17l4.78-22.46c.53-2.53.17-4.34-.88-5.29h0c-1.18-.37-2.8-.09-4.71,1l-7.68,4.29c-4.78,2.67-9.6,9.18-10.77,14.53L344.44,366c-1.16,5.36-5.71,8.67-10.15,7.38Zm38.64-29.72a1.84,1.84,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.17-1s.14-.84.21-1.29c0-.11,0-.23.06-.35.37-2.18,3-5.27,5.79-6.91l2.26-1.29a8.14,8.14,0,0,1,1.77-.78,3.72,3.72,0,0,1,1.07-.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,371.1c1.38.79,4,2.3,7,4,4.45,2.57,9.16,4,13.91,1.28l12.28-7.1c4.75-2.74,6.95-7.83,8.08-13.17l4.78-22.46c.53-2.53.17-4.34-.88-5.29h0c-1.18-.37-2.8-.09-4.71,1l-7.68,4.29c-4.78,2.67-9.6,9.18-10.77,14.53L344.44,366c-1.16,5.36-5.71,8.67-10.15,7.38Zm38.64-29.72a1.84,1.84,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.17-1s.14-.84.21-1.29c0-.11,0-.23.06-.35.37-2.18,3-5.27,5.79-6.91l2.26-1.29a8.14,8.14,0,0,1,1.77-.78,3.72,3.72,0,0,1,1.07-.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,354.51l12.55-7.27.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.84,1.84,0,0,1,.2,1.37l-.65,3.95-11.28,6.52C353,354,353,354.51,353,354.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,354.51l12.55-7.27.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.84,1.84,0,0,1,.2,1.37l-.65,3.95-11.28,6.52C353,354,353,354.51,353,354.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,364.13l9.26,5.32s5.13,3.52,10.21,3.65c3.67-.12,7-3.17,8-7.64l3.85-17.82c1.17-5.35,6-11.86,10.76-14.54l7.68-4.28c2.53-1.41,4.56-1.46,5.72-.41-1.18-.37-2.8-.09-4.72,1l-7.68,4.29c-4.78,2.67-9.6,9.18-10.77,14.53L344.44,366a9.78,9.78,0,0,1-5.21,7,8.15,8.15,0,0,1-5.61.85c-3.08-.39-7.37-2.74-7.37-2.74l-.54-.32-.45-.25L316,365.21a3.59,3.59,0,0,1-2.11-3v-.67A3.88,3.88,0,0,0,316,364.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,362.23v-.67a3.88,3.88,0,0,0,2.11,2.57l9.26,5.32s5.13,3.52,10.21,3.65c3.67-.12,7-3.17,8-7.64l3.85-17.82a18.6,18.6,0,0,1,1.59-4.31l1,.57a18.6,18.6,0,0,0-1.59,4.31L344.44,366a9.78,9.78,0,0,1-5.21,7,8.15,8.15,0,0,1-5.61.85c-3.08-.39-7.37-2.74-7.37-2.74l-.54-.32-.45-.25L316,365.21A3.59,3.59,0,0,1,313.89,362.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.06,333.1l7.68-4.28c2.53-1.41,4.56-1.46,5.72-.41-1.18-.37-2.8-.09-4.72,1l-7.68,4.29c-3.54,2-7.1,6.06-9.18,10.22l-1-.57C351,339.17,354.52,335.08,358.06,333.1Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--student-1--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "254.37 397.63 217.63 376.42 217.63 378.16 254.37 399.37 254.37 397.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.37 395.88 217.63 374.67 217.63 376.42 254.37 397.63 254.37 395.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 424.17 171.28 404.48 169.96 405.46 205.38 425.91 205.38 424.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 406.44 205.38 446.51 204.06 445.75 204.06 405.68 205.38 406.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 406.44 205.38 446.51 206.7 445.75 206.7 405.68 205.38 406.44",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.96 386 169.96 426.06 168.64 425.3 168.64 385.23 169.96 386",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.96 386 169.96 426.06 171.28 425.3 171.28 385.23 169.96 386",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 425.91 168.64 404.7 168.64 406.44 205.38 427.66 205.38 425.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.05 378.92 253.05 418.99 251.72 418.23 251.72 378.16 253.05 378.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.05 378.92 253.05 418.99 254.37 418.23 254.37 378.16 253.05 378.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 399.37 205.38 408.8 168.64 387.59 168.64 378.16 205.38 399.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 408.8 254.37 380.52 254.37 375.8 205.38 404.09 205.38 408.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 404.09 164.56 380.52 217.63 349.88 258.45 373.44 205.38 404.09",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 404.09 164.56 380.52 217.63 349.88 258.45 373.44 205.38 404.09",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.56 380.52 164.56 382.87 205.38 406.44 205.38 404.09 164.56 380.52",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.56 380.52 164.56 382.87 205.38 406.44 205.38 404.09 164.56 380.52",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 406.44 258.45 375.8 258.45 373.44 205.38 404.09 205.38 406.44",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 406.44 258.45 375.8 258.45 373.44 205.38 404.09 205.38 406.44",
    style: {
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.73,422.22c1,.28.88,2,1,2.69.17,1.33.85,3.19.66,4a3.43,3.43,0,0,1-2,2.38,6.32,6.32,0,0,1-2.84.61,29.47,29.47,0,0,0-3.39.14c-2.81.39-3.83,1.1-6.06,1.36a17.08,17.08,0,0,1-2.77,0,12.29,12.29,0,0,1-1.82-.27c-1.51-.38-3.79-1.45-4.11-3.11a2.52,2.52,0,0,1,2-3.16c2.19-.57,4.48-.73,6.63-1.45a13.43,13.43,0,0,0,2.68-1.12c1.42-.73,2.64-1.49,2.56-2.37C240.26,422,247.54,422.16,247.73,422.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,414.72l-8.2-1.17s.5,6.73.13,8a4.93,4.93,0,0,1-2.59,2.8,13.43,13.43,0,0,1-2.68,1.12,15.41,15.41,0,0,1-1.77.48h0c-2,.39-3.11,3-.49,3.41,2.85.48,5.18-.65,8-1.34s7.15-2.17,7-5.67h0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.68,390.87c-1.86,7.66-.41,27.05-.41,27.05s4.25,2.28,8.14.9l5.05-23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,432.56c1,.3.85,2,.93,2.71.15,1.34.78,3.21.57,4a3.4,3.4,0,0,1-2.06,2.34,6.38,6.38,0,0,1-2.86.55,31.72,31.72,0,0,0-3.38.07c-2.82.34-3.86,1-6.09,1.24a18.3,18.3,0,0,1-2.77,0,13.83,13.83,0,0,1-1.82-.31c-1.5-.41-3.76-1.53-4-3.19a2.52,2.52,0,0,1,2.09-3.12c2.2-.53,4.5-.65,6.66-1.31a13.77,13.77,0,0,0,2.71-1.07c1.43-.7,2.67-1.44,2.6-2.32C222.11,432.15,229.38,432.5,229.57,432.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,426.57l-8.61-1.41s0,5.32-.36,6.56a4.94,4.94,0,0,1-2.64,2.75,13.77,13.77,0,0,1-2.71,1.07A17.79,17.79,0,0,1,215,436h0c-2,.35-3.17,2.92-.56,3.41,2.84.54,5.19-.55,8-1.18s5.76-2.27,6.44-3.41a7.23,7.23,0,0,0,.66-2.12C229.9,431.29,231.12,426.57,231.12,426.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,397.84C222.46,405,222.19,429,222.19,429s4.52,2.43,8.18,1l6.56-21.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.53,410s-6.79-2.61-8.39-4.42c0,0,3.61,5.12,7.84,6.21Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.08,445.16,243,413.09a1,1,0,0,1,1.93.48l-4,18.52,18.12,10.47V422.63a1,1,0,0,1,2,0v19.93l18.12-10.46-4-18.53a1,1,0,1,1,1.92-.48L284,445.16a1,1,0,0,1-.72,1.2l-.24,0a1,1,0,0,1-1-.76l-2.48-11.5L261,444.85v14.5a1,1,0,0,1-2,0v-14.5l-18.56-10.72L238,445.63a1,1,0,0,1-1,.76l-.24,0A1,1,0,0,1,236.08,445.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.68,415.39c-2.84-1.65-2.84-4.31,0-5.95l13.86-8a11.42,11.42,0,0,1,10.31,0l17.29,9.95S265.56,423.15,260,424.23c-7.32,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.68,415.39c-2.84-1.65-2.84-4.31,0-5.95l13.86-8a11.42,11.42,0,0,1,10.31,0l17.29,9.95S265.56,423.15,260,424.23c-7.32,1.42-14-3.52-14-3.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.1,399.27s-16.2-8-21.42-10.35S247.42,386,244.8,387c-2.24.82-3.58,2.71-4.47,6-.17.62-.89,4.38-.89,4.38a50,50,0,0,0,15.8,6C264.72,405.28,277.1,399.27,277.1,399.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.42,398.39c.65,9.69-1.29,13.8-5,16-6.05,3.61-14.11,5.77-23.29,2.07C243,414,232,407.38,232,407.38c-1.79-2.9-8.57-1.29-8.27-3.65.23-1.88.59-4,.75-4.6.84-3.17,3.54-7.34,10.19-5.81,4.09.93,7.3,2.72,14.06,4.84,1.54.49,3.79-1.62,5-1.16,3,1.09,3.72,6.16,3.72,6.16Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.34 362.81 258.33 372.16 268.12 371.4 267.21 360.18 257.34 362.81",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52,399.36c-.92-19.76-1-22.69-1.87-27.2s-2.74-8.65-6.51-8l-1.56.23c-.12,2.56-5.11,3.3-9.91,1.68-1.35.32-5.18,1.34-5.18,1.34-3.44,2.07-4.25,4.33-4.25,13.35s.62,15.77.69,21.1C256.44,407.49,273.62,405,277.52,399.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.52,399.36c-.92-19.76-1-22.69-1.87-27.2s-2.74-8.65-6.51-8l-1.56.23c-.12,2.56-5.11,3.3-9.91,1.68-1.35.32-5.18,1.34-5.18,1.34-3.44,2.07-4.25,4.33-4.25,13.35s.62,15.77.69,21.1C256.44,407.49,273.62,405,277.52,399.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.84,349.64s-2.56,3.93-2.39,4.58c.22.86,2.29.86,2.29.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.49,340.37c-2.17,1.2-5.55,3.36-4.9,11.12-2,7.4,1.16,10.25,2.49,11.1a9.17,9.17,0,0,0,6.7.52c2.57-.87,8.1-3.79,10.61-8.17,2.95-5.15,1.69-11.34-1.94-13.9C262.33,337.45,256.33,339.36,254.49,340.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24,352.84a2.92,2.92,0,0,1,1.06-1.43,2.51,2.51,0,0,1,2.65-.09c2.34,1.13.92,4.52-.41,5.6a2,2,0,0,1-2.8,0,6.14,6.14,0,0,0,3.69,4.79c4.09.39,5.8-1.3,5.8-1.3.91-2.62,3.64-4.38,4.9-8.7.94-3.21.81-7.24-2-8,0,0-.22-4.68-7.42-6.14-6.19-1.27-11.4,1.7-12.09,6.58,0,0,.74.72,3.46,1.07,0,0-.14,4.3,1.67,5.18,0,0-1.2,3,1.07,3.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,354.58h0a1.8,1.8,0,0,1-1.18-1.06,1.93,1.93,0,0,1,.16-1.83.11.11,0,1,1,.18.11,1.73,1.73,0,0,0-.15,1.63,1.6,1.6,0,0,0,1,.94.1.1,0,0,1,.09.12A.12.12,0,0,1,258.69,354.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05,354.82a1.49,1.49,0,0,1-.58.72.6.6,0,0,1-.8,0c-.15-.16,0-.44-.09-.62a.88.88,0,0,1-.11-.63.76.76,0,0,1,1-.48A.84.84,0,0,1,260.05,354.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.81,351.86c-.12.15-.37-.31-.22-.8.23-.74,1.93-1.45,3.26-.66a2.43,2.43,0,0,1,1.22,2.14,2.61,2.61,0,0,0-2.39-1.5A2.56,2.56,0,0,0,257.81,351.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,345.23c-.95,1.51-.45,4.85,0,5.37a2.9,2.9,0,0,1-2.65-.54,7.27,7.27,0,0,1-.43-3.48,4.67,4.67,0,0,0-.38,3.17,6.35,6.35,0,0,1-3-1.43,7.83,7.83,0,0,1,1.55-7.91c2.61-2.76,6.68-3.64,9.41-2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,374.39a3.57,3.57,0,0,0-2.23-2.47,3.44,3.44,0,0,0,.72-2.48,2.4,2.4,0,0,0-1.21-2,3.24,3.24,0,0,0-1.24-4.24,4.71,4.71,0,0,0,1-3.05,3.76,3.76,0,0,0-1.47-2.81l-4,3a3.08,3.08,0,0,0,1.31,4.55c-.38,1.52.07,3,1.59,3.46a3.17,3.17,0,0,0,.16,2.21,2.85,2.85,0,0,0,2.13,1.57,3.35,3.35,0,0,0-.1,2,3.4,3.4,0,0,0,1.29,1.7,2.29,2.29,0,0,1,1.12,2.05A3.45,3.45,0,0,0,272.91,374.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,363.5l-.13-1.36s-3.28,1.15-5.22.54A8.85,8.85,0,0,0,257.42,363.5Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,361.93l25.21,13.54.41.65v.53a.76.76,0,0,1-.41.65l-26.53,15.32a1.41,1.41,0,0,1-.69.17,1.38,1.38,0,0,1-.69-.17l-24.76-14.31v-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,392.26a1.41,1.41,0,0,0,.69-.17l26.53-15.31a.73.73,0,0,0,0-1.31L213.4,361.42l-28.35,16.37,24.76,14.3A1.38,1.38,0,0,0,210.5,392.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,359.88l24.1,13.93.2.27v2h0a.35.35,0,0,1-.2.28L211,391.72a1,1,0,0,1-.94,0l-24.11-13.93v-2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,375.75l.24.14,3.09,1.78.58.34L210,389.67a1.06,1.06,0,0,0,.95,0l26.53-15.32a.28.28,0,0,0,0-.54l-.25-.15L213.4,359.88l-27.24,15.73-.06,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,389.79v2a.91.91,0,0,0,.47-.12L237.5,376.4a.35.35,0,0,0,.2-.28v-2a.33.33,0,0,1-.2.27L211,389.67A.91.91,0,0,1,210.5,389.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,375.48l3.43,2,.53.31L210,389.4a1.06,1.06,0,0,0,.95,0l23.76-13.72.6-.34a5.89,5.89,0,0,0,1.92-1.68.43.43,0,0,0,0-.07.35.35,0,0,0,.06-.14A.41.41,0,0,0,237,373a9,9,0,0,1-1.79-.74l0,0-21.81-12.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,375.24a.27.27,0,0,1,0,.51,1,1,0,0,1-.89,0,.27.27,0,0,1,0-.51A.94.94,0,0,1,189.47,375.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,375a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.56.56,0,0,1,.31-.09,1.09,1.09,0,0,1,.54.17,3.36,3.36,0,0,1,1.34,1.9.85.85,0,0,0,.32,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,186,375Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,375.57s0,.05,0,.08l.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.13,373.7a.27.27,0,0,1,0,.51,1,1,0,0,1-.89,0,.27.27,0,0,1,0-.51A1,1,0,0,1,192.13,373.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.68,373.42a3.15,3.15,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.15,1.15,0,0,0,.33,0,3.71,3.71,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,188.68,373.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.78,372.16c.25.15.25.38,0,.52a1,1,0,0,1-.88,0,.28.28,0,0,1,0-.52A1,1,0,0,1,194.78,372.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34,371.89a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.24,1.24,0,0,1,.44-1.1.72.72,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,191.34,371.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.44,370.63c.25.14.25.37,0,.51a1,1,0,0,1-.88,0,.27.27,0,0,1,0-.51A1,1,0,0,1,197.44,370.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,370.35a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.19,1.19,0,0,0,.33,0,3.68,3.68,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,194,370.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,369.09a.28.28,0,0,1,0,.52,1,1,0,0,1-.88,0,.28.28,0,0,1,0-.52A1,1,0,0,1,200.1,369.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.66,368.82a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.71,3.71,0,0,0-1.5-2.15,1.18,1.18,0,0,0-1.18-.08A1.52,1.52,0,0,0,196.66,368.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,367.56a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,202.76,367.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.32,367.28a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.65,3.65,0,0,0-1.5-2.15,1.13,1.13,0,0,0-1.18-.08A1.49,1.49,0,0,0,199.32,367.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42,366a.28.28,0,0,1,0,.52,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.52A1,1,0,0,1,205.42,366Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,365.75a3.42,3.42,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.18,1.18,0,0,0-1.18-.08A1.53,1.53,0,0,0,202,365.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,364.49a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,208.08,364.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63,364.21a2.18,2.18,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.52,1.52,0,0,0,204.63,364.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.74,363a.28.28,0,0,1,0,.52,1,1,0,0,1-.88,0c-.25-.15-.25-.37,0-.52A1,1,0,0,1,210.74,363Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,362.68a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.16,1.16,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.51,1.51,0,0,0,207.29,362.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,361.42a.27.27,0,0,1,0,.51,1,1,0,0,1-.88,0c-.25-.14-.25-.37,0-.51A1,1,0,0,1,213.4,361.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,361.14a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09A.55.55,0,0,1,211,360a1.14,1.14,0,0,1,.55.16,3.3,3.3,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,210,361.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M186,375a3.37,3.37,0,0,0,0,.44l.31-.18a2.26,2.26,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.56.56,0,0,1,.31-.09,1.09,1.09,0,0,1,.54.17,3.36,3.36,0,0,1,1.34,1.9.85.85,0,0,0,.32,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,186,375Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M188.68,373.42a3.15,3.15,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.21,1.21,0,0,1,.44-1.09.61.61,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.15,1.15,0,0,0,.33,0,3.71,3.71,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,188.68,373.42Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.34,371.89a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.24,1.24,0,0,1,.44-1.1.72.72,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.74,3.74,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.52,1.52,0,0,0,191.34,371.89Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194,370.35a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.07,1.07,0,0,1,.54.16,3.33,3.33,0,0,1,1.33,1.91,1.19,1.19,0,0,0,.33,0,3.68,3.68,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.49,1.49,0,0,0,194,370.35Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M196.66,368.82a3.37,3.37,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.09,1.09,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.71,3.71,0,0,0-1.5-2.15,1.18,1.18,0,0,0-1.18-.08A1.52,1.52,0,0,0,196.66,368.82Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.32,367.28a3.25,3.25,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.21,1.21,0,0,1,.45-1.09.59.59,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.91.91,0,0,0,.33,0,3.65,3.65,0,0,0-1.5-2.15,1.13,1.13,0,0,0-1.18-.08A1.49,1.49,0,0,0,199.32,367.28Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M202,365.75a3.42,3.42,0,0,0,0,.44l.31-.18a2.46,2.46,0,0,1,0-.26,1.24,1.24,0,0,1,.45-1.1.69.69,0,0,1,.32-.08,1.12,1.12,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.18,1.18,0,0,0-1.18-.08A1.53,1.53,0,0,0,202,365.75Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M204.63,364.21a2.18,2.18,0,0,0,0,.44l.31-.18a2.11,2.11,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09.57.57,0,0,1,.32-.08,1.1,1.1,0,0,1,.54.16,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.15,1.15,1.15,0,0,0-1.19-.08A1.52,1.52,0,0,0,204.63,364.21Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.29,362.68a3.37,3.37,0,0,0,0,.44l.31-.18a2.35,2.35,0,0,1,0-.26,1.22,1.22,0,0,1,.45-1.1.66.66,0,0,1,.32-.08,1.16,1.16,0,0,1,.54.17,3.3,3.3,0,0,1,1.33,1.9.85.85,0,0,0,.32,0,3.7,3.7,0,0,0-1.49-2.15,1.19,1.19,0,0,0-1.19-.08A1.51,1.51,0,0,0,207.29,362.68Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M210,361.14a3.25,3.25,0,0,0,0,.44l.31-.18a2.17,2.17,0,0,1,0-.26,1.19,1.19,0,0,1,.45-1.09A.55.55,0,0,1,211,360a1.14,1.14,0,0,1,.55.16,3.3,3.3,0,0,1,1.33,1.9.69.69,0,0,0,.32,0,3.64,3.64,0,0,0-1.49-2.14,1.17,1.17,0,0,0-1.19-.09A1.52,1.52,0,0,0,210,361.14Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.13,384.93l1,3.62a.12.12,0,0,1-.18.12l-3-2.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.93,388.68h0l-3-2.3,1.16-.76.26.38,1.63,2.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,388.67a.12.12,0,0,0,.18-.12l-.18-.71h0a.65.65,0,0,1-.57.34h-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.76,371.15l.19.29.23.35,9.75,14.58a1.71,1.71,0,0,0,1.21-.18,1.74,1.74,0,0,0,1-1.26l-9.75-14.58-.44-.66C208.2,370.14,206,371.59,205.76,371.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.76,371.15l.19.29.23.35,9.75,14.58a1.78,1.78,0,0,0,1.45-.33l-10.15-15.36s0-.05,0-.06C206.66,371.05,205.91,371.4,205.76,371.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,372.25l.43.64c.12.19.6.05,1.08-.22.65-.35,1.25-1,1.1-1.25l-.32-.47-.12-.17c.16.25-.44.9-1.09,1.25-.47.25-.93.4-1.07.24h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6,372.41c.27.44,2.45-1,2.17-1.47l-.43-.64c.28.44-1.9,1.91-2.17,1.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.76,371.15l.42.64c.27.43,2.38-1,2.2-1.44a0,0,0,0,0,0,0l-.43-.64C208.2,370.14,206,371.59,205.76,371.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,388.67a.11.11,0,0,1-.11,0A.11.11,0,0,0,219,388.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,369.83l.89,1.32c.12.19.59.05,1.07-.21.65-.35,1.26-1,1.11-1.25h0l-.9-1.33c-.36-.54-1.54.06-2,.72A.66.66,0,0,0,204.87,369.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.75,369.94a2,2,0,0,0,1.31-1.24.46.46,0,0,0-.09-.41c-.42-.4-1.5.17-2,.79a.68.68,0,0,0-.14.74C205,370,205.33,370.08,205.75,369.94Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.1,382.13s.43.67.8,1.2l.58.87a3.51,3.51,0,0,0,2.26-1.34l-1-1.46a3.25,3.25,0,0,1,2.53.15,3.48,3.48,0,0,1,2.15,2.06c.84,1.91,1.71,1.94,4,2.34,3,.51,10.33,1.42,10.33,1.42s4.81-7.89,6.65-10.62c3.21-4.76,3.34-7.62,11-9.34,1.53,2.06,2.71,7.49-.07,13.28-3.63,4.76-7.35,11-10.51,14.1-2.85,2.83-4.51,2.5-8.33,1.72-3-.61-14.17-3.74-17-5s-5.06-5-5.05-6.77A3.29,3.29,0,0,1,213.1,382.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,367.21c-2.35.26-5.83.78-7.81,2.53s-4.28,6.12-4.28,6.12a2.43,2.43,0,0,0,.87,2.05,4.39,4.39,0,0,0,2.8.35,2.18,2.18,0,0,0,.93,2,2.9,2.9,0,0,0,2.5.17s-.45.84.94,1.81a3.22,3.22,0,0,0,2.89.35A15.16,15.16,0,0,0,253.23,367.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,367.21c-2.35.26-5.83.78-7.81,2.53s-4.28,6.12-4.28,6.12a2.43,2.43,0,0,0,.87,2.05,4.39,4.39,0,0,0,2.8.35,2.18,2.18,0,0,0,.93,2,2.9,2.9,0,0,0,2.5.17s-.45.84.94,1.81a3.22,3.22,0,0,0,2.89.35A15.16,15.16,0,0,0,253.23,367.21Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.94,422.36l7,4.05c4.45,2.57,9.16,4,13.9,1.28l12.28-7.1c4.76-2.74,7-7.83,8.09-13.17L293,385c.53-2.53.16-4.34-.89-5.29h0c-1.17-.37-2.8-.09-4.71,1l-7.67,4.29c-4.78,2.67-9.61,9.18-10.78,14.53l-3.84,17.81c-1.17,5.36-5.72,8.67-10.15,7.38Zm38.64-29.72a1.89,1.89,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.16-1s.15-.84.22-1.29c0-.11,0-.23,0-.35.37-2.18,3-5.27,5.8-6.91l2.26-1.29a8.08,8.08,0,0,1,1.76-.78,3.79,3.79,0,0,1,1.08-.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.94,422.36l7,4.05c4.45,2.57,9.16,4,13.9,1.28l12.28-7.1c4.76-2.74,7-7.83,8.09-13.17L293,385c.53-2.53.16-4.34-.89-5.29h0c-1.17-.37-2.8-.09-4.71,1l-7.67,4.29c-4.78,2.67-9.61,9.18-10.78,14.53l-3.84,17.81c-1.17,5.36-5.72,8.67-10.15,7.38Zm38.64-29.72a1.89,1.89,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.16-1s.15-.84.22-1.29c0-.11,0-.23,0-.35.37-2.18,3-5.27,5.8-6.91l2.26-1.29a8.08,8.08,0,0,1,1.76-.78,3.79,3.79,0,0,1,1.08-.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.94,422.36l7,4.05c4.45,2.57,9.16,4,13.9,1.28l12.28-7.1c4.76-2.74,7-7.83,8.09-13.17L293,385c.53-2.53.16-4.34-.89-5.29h0c-1.17-.37-2.8-.09-4.71,1l-7.67,4.29c-4.78,2.67-9.61,9.18-10.78,14.53l-3.84,17.81c-1.17,5.36-5.72,8.67-10.15,7.38Zm38.64-29.72a1.89,1.89,0,0,1,.2,1.37l-.65,3.95-11.28,6.52c0-.3.11-.64.16-1s.15-.84.22-1.29c0-.11,0-.23,0-.35.37-2.18,3-5.27,5.8-6.91l2.26-1.29a8.08,8.08,0,0,1,1.76-.78,3.79,3.79,0,0,1,1.08-.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,405.77l12.55-7.27.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.89,1.89,0,0,1,.2,1.37l-.65,3.95-11.28,6.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,405.77l12.55-7.27.66-3.94c.19-1.18-.32-1.84-1.27-1.92a1.89,1.89,0,0,1,.2,1.37l-.65,3.95-11.28,6.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.68,415.39l9.27,5.32s5.12,3.52,10.2,3.65c3.68-.12,7-3.17,8-7.64L268,398.9c1.16-5.35,6-11.86,10.76-14.54l7.67-4.28c2.53-1.42,4.56-1.46,5.72-.41-1.17-.37-2.8-.09-4.72,1l-7.67,4.29c-4.78,2.67-9.61,9.18-10.78,14.53l-3.84,17.81a9.79,9.79,0,0,1-5.22,7,8.13,8.13,0,0,1-5.61.85c-3.08-.39-7.36-2.74-7.36-2.74l-.55-.32-.44-.25-9.27-5.32a3.61,3.61,0,0,1-2.11-3v-.67A3.91,3.91,0,0,0,236.68,415.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.57,413.49v-.67a3.91,3.91,0,0,0,2.11,2.57l9.27,5.32s5.12,3.52,10.2,3.65c3.68-.12,7-3.17,8-7.64L268,398.9a18.55,18.55,0,0,1,1.58-4.31l1,.57a19.07,19.07,0,0,0-1.59,4.31l-3.84,17.81a9.79,9.79,0,0,1-5.22,7,8.13,8.13,0,0,1-5.61.85c-3.08-.39-7.36-2.74-7.36-2.74l-.55-.32-.44-.25-9.27-5.32A3.61,3.61,0,0,1,234.57,413.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.75,384.36l7.67-4.28c2.53-1.42,4.56-1.46,5.72-.41-1.17-.37-2.8-.09-4.72,1l-7.67,4.29c-3.54,2-7.1,6.06-9.19,10.22l-1-.57C271.65,390.43,275.21,386.34,278.75,384.36Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.52,252.29c1.87-6.63,2.25-18.8,3.34-24.83,1.27-7.07,6.95-13.83,6.95-13.83s-1.29-18.27-1.73-26.41c-1-19.1,2.91-26.28,5.06-29a37.56,37.56,0,0,0,2.36-3.34,31,31,0,0,0,2.17-3.88l25.63,2c1.63,3.54,3.7,9.57,3.31,14.51,2.22,10,.11,41.44-.92,52.78-.62,6.79-6.6,36.55-6.74,37.47-.07.39-1.35,2.05-4,1.46s-3.36-1.58-3.35-1.87c.05-1,0-2.08-.06-3.07-.22-6.44-2-20.27-2.41-26.85a16.89,16.89,0,0,1,2.73-10.2l-3.07-17.8a130.11,130.11,0,0,1-7.09,24.24c-3.48,8.46-15.23,33.44-15.23,33.44-1.09,2.64-6.72,1-7.22-3.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,252.29c-1.42-.32-1.48,4.65-2.48,7.61-1.07,3.18-2.8,5.27-3.71,7.87a10,10,0,0,0-.26,7.15c.57,2.19,4.95,6.06,7.41,3.71a14,14,0,0,0,3.95-8.55,49.53,49.53,0,0,1,1.66-7.7c.74-2.53,2.33-6.95,1.29-7.34l-.67,1.44c-.89,1-7.21-.71-7.49-3.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,257.42a28,28,0,0,0-.23,5.82,5.73,5.73,0,0,0,3,2.58l1.32-5.89Z",
    style: {
      fill: "#263238"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.72 265.82 296.09 264.3 297.55 259.65 291.53 262.21 290.72 265.82"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.92,252.67l.27-1.38c.71.38.37,6.13,4,10.38,2.68,3.14,5.81,5.06,7,6.69,1.6,2.18-2.58,5.5-7.78,4.16-2.58-.66-6.46-2.49-7.46-4.29s-1.6-4.69-2.42-6-3.22-2.44-3.73-3.89.06-3.7.57-5.14.29-2.77.91-2.77l.08,1.09c.32.73,2.38,1.78,5,2C295.64,253.65,297.3,253.8,297.92,252.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.47,162.21s-6.08,3.87-17.37,2.52-16-6.54-16-6.54a25.12,25.12,0,0,0-4.93,10.42c-.86,4.81-.46,19.65.12,30.31s.87,14.33.87,14.33a25.4,25.4,0,0,0-5.82,9.29c-2.66,8.77-4.16,28.42-4.16,28.42,2,2.25,5.92,2.91,9.6,3.33,0,0,11.1-22.63,13.91-31.24s4.48-11.6,6-23.68L289,217.22a21.1,21.1,0,0,0-2.28,9c-.1,8.76,1.41,19.27,1.64,23.08,0,0,5.19,3.64,10.71,1.09,0,0,2.22-11.27,4.29-24.66A279.93,279.93,0,0,0,306.12,194,202.69,202.69,0,0,0,304.47,162.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,199.37l2.43-17.64s7.38-3.79,9.31-7.5a12.22,12.22,0,0,1-6.07,8.9L289,200.93v16.29Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.14,112.55a3.77,3.77,0,0,1,.58-1.06,5,5,0,0,1,1.22-.86,15.53,15.53,0,0,1,2.69-1c1.57-.5,3.25-1.18,4-2.63a1.84,1.84,0,0,0,.22-1.35,1,1,0,0,0-1.05-.71,5.06,5.06,0,0,0,1.47-1.48,2.3,2.3,0,0,0,.23-2,1.51,1.51,0,0,0-1.68-.93A7.48,7.48,0,0,0,302,97.87a2.23,2.23,0,0,0-.59-2.6,6.92,6.92,0,0,0-2.78-.59,44.17,44.17,0,0,1-7-1.62,21,21,0,0,0-9-.39c-4.5.9-5.66,2.83-6.08,4.84,0,0-2.78.06-4.47,3.9-2.12,4.82-.49,10,2.66,14.1,1.54,2,4.49,4.26,5.57,5.4.35.35,8.32-2.59,9.21-3.89A34.4,34.4,0,0,0,292.14,112.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.42,89.53c3.14,3,.55,5.44-2.48,8.58s-5.34,5.81-8.48,2.79a7.9,7.9,0,0,1,11-11.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.29,97.83c1.65.84,5,4.52,4.66,13.06-.27,7.1-1.55,8.76-3.5,9.58-1.16.49-3,.43-5.21.2l-.12,4.28s6.3,4.54,1.37,5.48a10.89,10.89,0,0,1-7.75-1.86,10.67,10.67,0,0,1-3.08-3l-.5-9.56s-1.19,1.32-3.47-.44c-1.88-1.44-2.64-4-1.34-5.53a3.22,3.22,0,0,1,5.11.65s1.2.69,2.32-1.74a31.84,31.84,0,0,0,5.92-3.14A12.33,12.33,0,0,0,294.29,97.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,114.2l3.85,1.09a2,2,0,0,1-2.44,1.45A2.1,2.1,0,0,1,288.89,114.2Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.18,116.78a1.87,1.87,0,0,0-1.95-1.74,2.2,2.2,0,0,0-.37.06,2.05,2.05,0,0,0,1.44,1.64A2,2,0,0,0,291.18,116.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,105.81l-2.1-.63a1.06,1.06,0,0,1,1.33-.76A1.15,1.15,0,0,1,297.36,105.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.74,106l-2,.92a1.05,1.05,0,0,1,.5-1.45A1.17,1.17,0,0,1,287.74,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.33 107.1 292.4 113.1 295.68 112.64 292.33 107.1",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,120.67c-2.3-.15-7.32-2-8.17-3.86a4.8,4.8,0,0,0,1.92,3,24.93,24.93,0,0,0,6.21,2.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.34,109l.24,3.72h0A2.54,2.54,0,0,0,283,110l-.22-3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.18,108a1,1,0,0,0,.89,1.09,1,1,0,0,0,1.07-.85,1,1,0,0,0-.88-1.09A1,1,0,0,0,295.18,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.84,108a1,1,0,0,0,.89,1.09.94.94,0,0,0,1.07-.85,1,1,0,0,0-.89-1.09A1,1,0,0,0,287.84,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,162l-5.69,5.82s-2.6-6.7-2.44-6.71,3.15-4.3,3.15-4.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.83,123.89c6.2-3,6.69.7,11.69,6.15,3.47,3.79,10.34,10.75,12.43,13.69,2.37,3.31,2.79,4.71,1.47,7.5s-10.64,12.29-10.64,12.29a13.63,13.63,0,0,1-5.22-5.84l5.28-8.32-12.77-10.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.83,123.89c6.2-3,6.69.7,11.69,6.15,3.47,3.79,10.34,10.75,12.43,13.69,2.37,3.31,2.79,4.71,1.47,7.5s-10.64,12.29-10.64,12.29a13.63,13.63,0,0,1-5.22-5.84l5.28-8.32-12.77-10.8Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,149.36c1.2.76,4.91.82,6.36,0,0,0-1.86,2.22-7,1Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.67,151l-2.75-11.83c-1.51-5.43-.79-8.95-.33-10.62.73-2.31,8-4.05,8-4.05,1.11-.29,4.35-.14,5.35-.25l7.4-.28A34.13,34.13,0,0,1,303.77,134c2.23,3.24,4.26,7.79-.85,12.3.1,2.08-.77,4.31-1.62,6.6",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,124.06s2.59,4.2,1.34,6.37c-5.87-.82-8.93-4.06-10.89-6,0,0-5.71,1.29-7.16,1.69s-3,5.44-2.17,10.72,4,13.87,4,13.87c-3.4,5-6.27,9.57-7.7,13,2.9,7.79,26,10.34,38.07,4.72a52.11,52.11,0,0,0-3.69-15.62s1.77-3.61,1.33-6.39a8.84,8.84,0,0,0,3.14-5.72c.23-3.6-1.5-6.11-4.82-10.1a43.69,43.69,0,0,0-7.72-6.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,124.06s2.59,4.2,1.34,6.37c-5.87-.82-8.93-4.06-10.89-6,0,0-5.71,1.29-7.16,1.69s-3,5.44-2.17,10.72,4,13.87,4,13.87c-3.4,5-6.27,9.57-7.7,13,2.9,7.79,26,10.34,38.07,4.72a52.11,52.11,0,0,0-3.69-15.62s1.77-3.61,1.33-6.39a8.84,8.84,0,0,0,3.14-5.72c.23-3.6-1.5-6.11-4.82-10.1a43.69,43.69,0,0,0-7.72-6.76Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,145.19a7.59,7.59,0,0,0,7.3,3.8,8,8,0,0,0,6.68-4.44s-.05,5.59-6.64,5.78S281.38,145.19,281.38,145.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24,126c-4.33.49-8,1.14-9.51,4.63s-8.5,22.35-8.75,24.75,4.35,3.59,7.76,2.46c3.11-4.57,9.27-17.25,9.27-17.25S277.12,132.07,274.24,126Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,135.68l12,12.62,8.42,2.15c-3.26,7.76-4.67,9.56-7.87,9.34-3.82-.27-4.48-1.61-8.44-6.19-3.52-4.07-6.79-9.64-8-11.23-1.75-2.28-3.86-2.44-4.49-3.72-.56-1.13,7.66-4,7.66-4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,131.15q-3.47-8.64-7-17.26l-6.95-17.28.07,0L236,113.67q3.64,8.56,7.38,17.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28,134.07c-1.92-3.8-5.68-6.3-7.15-6.18s-1.6,2.51-1.6,2.51a2.22,2.22,0,0,0-1.55,1.71c-.12,1.28.44,1.63.44,1.63a2.08,2.08,0,0,0-.33,1.79,3.94,3.94,0,0,0,.8,1.19s-.34,1.15.1,1.71c1.64,2,3.45,2.08,5.39,3.2a6.1,6.1,0,0,1,2.06,1.87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,131.2a4.44,4.44,0,0,1,1.93,1.3,6.12,6.12,0,0,1,.57,1.88.84.84,0,0,1-1.38.67,1.57,1.57,0,0,1,.41,1.28c-.13.74-.94.47-.94.47s.75.91.25,1.5a.85.85,0,0,1-1.17.08,1.1,1.1,0,0,0,.88-.25c.33-.34-.39-1.74-.39-1.74s.64.41,1,0-.46-1.74-.46-1.74,1.09.58,1.4.06a2.65,2.65,0,0,0-.42-2.13A11.85,11.85,0,0,0,240.17,131.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,137.6s1.71.16,1.51-.2a4.13,4.13,0,0,1-.51-1.34c-.09-.49-.18-1-.24-1.5a14.66,14.66,0,0,0-.31-1.91,1.72,1.72,0,0,0-.74-1.21,3.42,3.42,0,0,0-1.76-.28c-.77,0-1.11-.33-1.88-.36-.38,0-1.24-.2-1.62-.16-.68.08-.27,1.87.53,2.39a3,3,0,0,0,1.85.62s-1.82,1.44-.31,4.48C244.45,139.5,247.25,137.6,247.25,137.6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,138.31a7.43,7.43,0,0,1-1-1.36,4,4,0,0,1-.51-1.34c-.09-.48-.18-1-.24-1.49a14.55,14.55,0,0,0-.31-1.92,1.74,1.74,0,0,0-.74-1.21,3.41,3.41,0,0,0-1.76-.27l-2.32-.07a7.08,7.08,0,0,0-1.13,0c-.68.08-.36,1.27.43,1.8a8.77,8.77,0,0,0,2.65.81,4.57,4.57,0,0,0-1.1,5.33C244.65,140,250,138.31,250,138.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,142.87S271,145.78,268,152s-4.74,8.38-6.79,8.9-5.05-1.32-7.34-4.12-4.92-6.62-4.92-6.62c5.75-2.2,6.57-6.07,6.57-6.07l3.16,2.76s5.08-14,5.63-16.24,1.33-5.61,3.86-5.62,3.36,1.16,6.84.82C276.41,128.26,277,136.45,272.65,142.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,142.87S271,145.78,268,152s-4.74,8.38-6.79,8.9-5.05-1.32-7.34-4.12-4.92-6.62-4.92-6.62c5.75-2.2,6.57-6.07,6.57-6.07l3.16,2.76s5.08-14,5.63-16.24,1.33-5.61,3.86-5.62,3.36,1.16,6.84.82C276.41,128.26,277,136.45,272.65,142.87Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,146.81c2.83,2.6,3.18,7.3,3.18,7.3s1.78-4.12-2.53-9.14Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,124.71s3.16,5.26,6.62,7.47a38.21,38.21,0,0,0,8.79,3.66s1.57-5.53-3.77-11.82l2.65-.13a42.63,42.63,0,0,1,9.87,8.68c4.32,5.34,4.24,10.7,0,14,0,0-.54,3.23-1.06,6.38a47.2,47.2,0,0,1,3.18,12.65l-4,1.45-4.68-4.45-5.38,5.75c-16.68,1.19-23.62-6.73-23.62-6.73a47.56,47.56,0,0,1,5.33-10.87c-.06-.49-.82-7.87-.82-7.87s7.69-5.27,2.33-17.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,135.84c1.27.48,2.25.55,2.93,9.13s.06,15.63-.74,17.62c2.54-5.51,1.86-14,1.39-18.2C297.9,138.93,298.12,136.12,295,135.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.51,122.64s2,5.2,11,7.79a4.7,4.7,0,0,1-1.47,3.14,3.07,3.07,0,0,1-4.84-1,8.86,8.86,0,0,1-5.9-1.77,6.42,6.42,0,0,1-2.42-5.54s2.18-4.34,3.55-4.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.51,122.64s2,5.2,11,7.79a4.7,4.7,0,0,1-1.47,3.14,3.07,3.07,0,0,1-4.84-1,8.86,8.86,0,0,1-5.9-1.77,6.42,6.42,0,0,1-2.42-5.54s2.18-4.34,3.55-4.35Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,130.43s1.57,2.57,3.46,2.14,0-4.31,0-4.31.6-.73-.5-2.53-3-4.2-4.29-4.41v2.74A9.47,9.47,0,0,1,291.49,130.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,130.43s1.57,2.57,3.46,2.14,0-4.31,0-4.31.6-.73-.5-2.53-3-4.2-4.29-4.41v2.74A9.47,9.47,0,0,1,291.49,130.43Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.9b11718dd0bfbdbadd001776b7439240.svg";
export { ForwardRef as ReactComponent };